/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blankObject", function() { return blankObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyDev", function() { return destroyDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_differs", function() { return _differs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_differsImmutable", function() { return _differsImmutable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fire", function() { return fire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDev", function() { return getDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observeDev", function() { return observeDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onDev", function() { return onDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "run", function() { return run; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_set", function() { return _set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDev", function() { return setDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "callAll", function() { return callAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_mount", function() { return _mount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_unmount", function() { return _unmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENDING", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUCCESS", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAILURE", function() { return FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFromStore", function() { return removeFromStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "proto", function() { return proto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "protoDev", function() { return protoDev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendNode", function() { return appendNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertNode", function() { return insertNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detachNode", function() { return detachNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detachBetween", function() { return detachBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detachBefore", function() { return detachBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detachAfter", function() { return detachAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reinsertBetween", function() { return reinsertBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reinsertChildren", function() { return reinsertChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reinsertAfter", function() { return reinsertAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reinsertBefore", function() { return reinsertBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyEach", function() { return destroyEach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFragment", function() { return createFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSvgElement", function() { return createSvgElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createText", function() { return createText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createComment", function() { return createComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addListener", function() { return addListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeListener", function() { return removeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttribute", function() { return setAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttributes", function() { return setAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAttribute", function() { return removeAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setXlinkAttribute", function() { return setXlinkAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBindingGroupValue", function() { return getBindingGroupValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toNumber", function() { return toNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeRangesToArray", function() { return timeRangesToArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "children", function() { return children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimElement", function() { return claimElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimText", function() { return claimText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInputType", function() { return setInputType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStyle", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectOption", function() { return selectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectOptions", function() { return selectOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectValue", function() { return selectValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectMultipleValue", function() { return selectMultipleValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyBlock", function() { return destroyBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outroAndDestroyBlock", function() { return outroAndDestroyBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateKeyedEach", function() { return updateKeyedEach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSpreadUpdate", function() { return getSpreadUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateRule", function() { return generateRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash", function() { return hash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapTransition", function() { return wrapTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitionManager", function() { return transitionManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
function noop() {}

function assign(tar, src) {
	for (var k in src) tar[k] = src[k];
	return tar;
}

function appendNode(node, target) {
	target.appendChild(node);
}

function insertNode(node, target, anchor) {
	target.insertBefore(node, anchor);
}

function detachNode(node) {
	node.parentNode.removeChild(node);
}

function detachBetween(before, after) {
	while (before.nextSibling && before.nextSibling !== after) {
		before.parentNode.removeChild(before.nextSibling);
	}
}

function detachBefore(after) {
	while (after.previousSibling) {
		after.parentNode.removeChild(after.previousSibling);
	}
}

function detachAfter(before) {
	while (before.nextSibling) {
		before.parentNode.removeChild(before.nextSibling);
	}
}

function reinsertBetween(before, after, target) {
	while (before.nextSibling && before.nextSibling !== after) {
		target.appendChild(before.parentNode.removeChild(before.nextSibling));
	}
}

function reinsertChildren(parent, target) {
	while (parent.firstChild) target.appendChild(parent.firstChild);
}

function reinsertAfter(before, target) {
	while (before.nextSibling) target.appendChild(before.nextSibling);
}

function reinsertBefore(after, target) {
	var parent = after.parentNode;
	while (parent.firstChild !== after) target.appendChild(parent.firstChild);
}

function destroyEach(iterations) {
	for (var i = 0; i < iterations.length; i += 1) {
		if (iterations[i]) iterations[i].d();
	}
}

function createFragment() {
	return document.createDocumentFragment();
}

function createElement(name) {
	return document.createElement(name);
}

function createSvgElement(name) {
	return document.createElementNS('http://www.w3.org/2000/svg', name);
}

function createText(data) {
	return document.createTextNode(data);
}

function createComment() {
	return document.createComment('');
}

function addListener(node, event, handler) {
	node.addEventListener(event, handler, false);
}

function removeListener(node, event, handler) {
	node.removeEventListener(event, handler, false);
}

function setAttribute(node, attribute, value) {
	node.setAttribute(attribute, value);
}

function setAttributes(node, attributes) {
	for (var key in attributes) {
		if (key in node) {
			node[key] = attributes[key];
		} else {
			if (attributes[key] === undefined) removeAttribute(node, key);
			else setAttribute(node, key, attributes[key]);
		}
	}
}

function removeAttribute(node, attribute) {
	node.removeAttribute(attribute);
}

function setXlinkAttribute(node, attribute, value) {
	node.setAttributeNS('http://www.w3.org/1999/xlink', attribute, value);
}

function getBindingGroupValue(group) {
	var value = [];
	for (var i = 0; i < group.length; i += 1) {
		if (group[i].checked) value.push(group[i].__value);
	}
	return value;
}

function toNumber(value) {
	return value === '' ? undefined : +value;
}

function timeRangesToArray(ranges) {
	var array = [];
	for (var i = 0; i < ranges.length; i += 1) {
		array.push({ start: ranges.start(i), end: ranges.end(i) });
	}
	return array;
}

function children (element) {
	return Array.from(element.childNodes);
}

function claimElement (nodes, name, attributes, svg) {
	for (var i = 0; i < nodes.length; i += 1) {
		var node = nodes[i];
		if (node.nodeName === name) {
			for (var j = 0; j < node.attributes.length; j += 1) {
				var attribute = node.attributes[j];
				if (!attributes[attribute.name]) node.removeAttribute(attribute.name);
			}
			return nodes.splice(i, 1)[0]; // TODO strip unwanted attributes
		}
	}

	return svg ? createSvgElement(name) : createElement(name);
}

function claimText (nodes, data) {
	for (var i = 0; i < nodes.length; i += 1) {
		var node = nodes[i];
		if (node.nodeType === 3) {
			node.data = data;
			return nodes.splice(i, 1)[0];
		}
	}

	return createText(data);
}

function setInputType(input, type) {
	try {
		input.type = type;
	} catch (e) {}
}

function setStyle(node, key, value) {
	node.style.setProperty(key, value);
}

function selectOption(select, value) {
	for (var i = 0; i < select.options.length; i += 1) {
		var option = select.options[i];

		if (option.__value === value) {
			option.selected = true;
			return;
		}
	}
}

function selectOptions(select, value) {
	for (var i = 0; i < select.options.length; i += 1) {
		var option = select.options[i];
		option.selected = ~value.indexOf(option.__value);
	}
}

function selectValue(select) {
	var selectedOption = select.querySelector(':checked') || select.options[0];
	return selectedOption && selectedOption.__value;
}

function selectMultipleValue(select) {
	return [].map.call(select.querySelectorAll(':checked'), function(option) {
		return option.__value;
	});
}

function destroyBlock(block, lookup) {
	block.u();
	block.d();
	lookup[block.key] = null;
}

function outroAndDestroyBlock(block, lookup) {
	block.o(function() {
		destroyBlock(block, lookup);
	});
}

function updateKeyedEach(old_blocks, component, changed, key_prop, dynamic, list, lookup, node, has_outro, create_each_block, intro_method, next, get_context) {
	var o = old_blocks.length;
	var n = list.length;

	var i = o;
	var old_indexes = {};
	while (i--) old_indexes[old_blocks[i].key] = i;

	var new_blocks = [];
	var new_lookup = {};
	var deltas = {};

	var i = n;
	while (i--) {
		var key = list[i][key_prop];
		var block = lookup[key];

		if (!block) {
			block = create_each_block(component, key, get_context(i));
			block.c();
		} else if (dynamic) {
			block.p(changed, get_context(i));
		}

		new_blocks[i] = new_lookup[key] = block;

		if (key in old_indexes) deltas[key] = Math.abs(i - old_indexes[key]);
	}

	var will_move = {};
	var did_move = {};

	var destroy = has_outro ? outroAndDestroyBlock : destroyBlock;

	function insert(block) {
		block[intro_method](node, next);
		lookup[block.key] = block;
		next = block.first;
		n--;
	}

	while (o && n) {
		var new_block = new_blocks[n - 1];
		var old_block = old_blocks[o - 1];
		var new_key = new_block.key;
		var old_key = old_block.key;

		if (new_block === old_block) {
			// do nothing
			next = new_block.first;
			o--;
			n--;
		}

		else if (!new_lookup[old_key]) {
			// remove old block
			destroy(old_block, lookup);
			o--;
		}

		else if (!lookup[new_key] || will_move[new_key]) {
			insert(new_block);
		}

		else if (did_move[old_key]) {
			o--;

		} else if (deltas[new_key] > deltas[old_key]) {
			did_move[new_key] = true;
			insert(new_block);

		} else {
			will_move[old_key] = true;
			o--;
		}
	}

	while (o--) {
		var old_block = old_blocks[o];
		if (!new_lookup[old_block.key]) destroy(old_block, lookup);
	}

	while (n) insert(new_blocks[n - 1]);

	return new_blocks;
}

function getSpreadUpdate(levels, updates) {
	var update = {};

	var to_null_out = {};
	var accounted_for = {};

	var i = levels.length;
	while (i--) {
		var o = levels[i];
		var n = updates[i];

		if (n) {
			for (var key in o) {
				if (!(key in n)) to_null_out[key] = 1;
			}

			for (var key in n) {
				if (!accounted_for[key]) {
					update[key] = n[key];
					accounted_for[key] = 1;
				}
			}

			levels[i] = n;
		} else {
			for (var key in o) {
				accounted_for[key] = 1;
			}
		}
	}

	for (var key in to_null_out) {
		if (!(key in update)) update[key] = undefined;
	}

	return update;
}

function linear(t) {
	return t;
}

function generateRule(
	a,
	b,
	delta,
	duration,
	ease,
	fn
) {
	var keyframes = '{\n';

	for (var p = 0; p <= 1; p += 16.666 / duration) {
		var t = a + delta * ease(p);
		keyframes += p * 100 + '%{' + fn(t) + '}\n';
	}

	return keyframes + '100% {' + fn(b) + '}\n}';
}

// https://github.com/darkskyapp/string-hash/blob/master/index.js
function hash(str) {
	var hash = 5381;
	var i = str.length;

	while (i--) hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
	return hash >>> 0;
}

function wrapTransition(component, node, fn, params, intro, outgroup) {
	var obj = fn(node, params);
	var duration = obj.duration || 300;
	var ease = obj.easing || linear;
	var cssText;

	// TODO share <style> tag between all transitions?
	if (obj.css && !transitionManager.stylesheet) {
		var style = createElement('style');
		document.head.appendChild(style);
		transitionManager.stylesheet = style.sheet;
	}

	if (intro) {
		if (obj.css && obj.delay) {
			cssText = node.style.cssText;
			node.style.cssText += obj.css(0);
		}

		if (obj.tick) obj.tick(0);
	}

	return {
		t: intro ? 0 : 1,
		running: false,
		program: null,
		pending: null,
		run: function(intro, callback) {
			var program = {
				start: window.performance.now() + (obj.delay || 0),
				intro: intro,
				callback: callback
			};

			if (obj.delay) {
				this.pending = program;
			} else {
				this.start(program);
			}

			if (!this.running) {
				this.running = true;
				transitionManager.add(this);
			}
		},
		start: function(program) {
			component.fire(program.intro ? 'intro.start' : 'outro.start', { node: node });

			program.a = this.t;
			program.b = program.intro ? 1 : 0;
			program.delta = program.b - program.a;
			program.duration = duration * Math.abs(program.b - program.a);
			program.end = program.start + program.duration;

			if (obj.css) {
				if (obj.delay) node.style.cssText = cssText;

				program.rule = generateRule(
					program.a,
					program.b,
					program.delta,
					program.duration,
					ease,
					obj.css
				);

				transitionManager.addRule(program.rule, program.name = '__svelte_' + hash(program.rule));

				node.style.animation = (node.style.animation || '')
					.split(', ')
					.filter(function(anim) {
						// when introing, discard old animations if there are any
						return anim && (program.delta < 0 || !/__svelte/.test(anim));
					})
					.concat(program.name + ' ' + program.duration + 'ms linear 1 forwards')
					.join(', ');
			}

			this.program = program;
			this.pending = null;
		},
		update: function(now) {
			var program = this.program;
			if (!program) return;

			var p = now - program.start;
			this.t = program.a + program.delta * ease(p / program.duration);
			if (obj.tick) obj.tick(this.t);
		},
		done: function() {
			var program = this.program;
			this.t = program.b;
			if (obj.tick) obj.tick(this.t);
			if (obj.css) transitionManager.deleteRule(node, program.name);
			program.callback();
			program = null;
			this.running = !!this.pending;
		},
		abort: function() {
			if (obj.tick) obj.tick(1);
			if (obj.css) transitionManager.deleteRule(node, this.program.name);
			this.program = this.pending = null;
			this.running = false;
		}
	};
}

var transitionManager = {
	running: false,
	transitions: [],
	bound: null,
	stylesheet: null,
	activeRules: {},

	add: function(transition) {
		this.transitions.push(transition);

		if (!this.running) {
			this.running = true;
			requestAnimationFrame(this.bound || (this.bound = this.next.bind(this)));
		}
	},

	addRule: function(rule, name) {
		if (!this.activeRules[name]) {
			this.activeRules[name] = true;
			this.stylesheet.insertRule('@keyframes ' + name + ' ' + rule, this.stylesheet.cssRules.length);
		}
	},

	next: function() {
		this.running = false;

		var now = window.performance.now();
		var i = this.transitions.length;

		while (i--) {
			var transition = this.transitions[i];

			if (transition.program && now >= transition.program.end) {
				transition.done();
			}

			if (transition.pending && now >= transition.pending.start) {
				transition.start(transition.pending);
			}

			if (transition.running) {
				transition.update(now);
				this.running = true;
			} else if (!transition.pending) {
				this.transitions.splice(i, 1);
			}
		}

		if (this.running) {
			requestAnimationFrame(this.bound);
		} else if (this.stylesheet) {
			var i = this.stylesheet.cssRules.length;
			while (i--) this.stylesheet.deleteRule(i);
			this.activeRules = {};
		}
	},

	deleteRule: function(node, name) {
		node.style.animation = node.style.animation
			.split(', ')
			.filter(function(anim) {
				return anim.indexOf(name) === -1;
			})
			.join(', ');
	}
};

function blankObject() {
	return Object.create(null);
}

function destroy(detach) {
	this.destroy = noop;
	this.fire('destroy');
	this.set = this.get = noop;

	if (detach !== false) this._fragment.u();
	this._fragment.d();
	this._fragment = this._state = null;
}

function destroyDev(detach) {
	destroy.call(this, detach);
	this.destroy = function() {
		console.warn('Component was already destroyed');
	};
}

function _differs(a, b) {
	return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
}

function _differsImmutable(a, b) {
	return a != a ? b == b : a !== b;
}

function fire(eventName, data) {
	var handlers =
		eventName in this._handlers && this._handlers[eventName].slice();
	if (!handlers) return;

	for (var i = 0; i < handlers.length; i += 1) {
		var handler = handlers[i];

		if (!handler.__calling) {
			handler.__calling = true;
			handler.call(this, data);
			handler.__calling = false;
		}
	}
}

function getDev(key) {
	if (key) console.warn("`let x = component.get('x')` is deprecated. Use `let { x } = component.get()` instead");
	return get.call(this, key);
}

function get(key) {
	return key ? this._state[key] : this._state;
}

function init(component, options) {
	component._handlers = blankObject();
	component._bind = options._bind;

	component.options = options;
	component.root = options.root || component;
	component.store = component.root.store || options.store;
}

function observe(key, callback, options) {
	var fn = callback.bind(this);

	if (!options || options.init !== false) {
		fn(this.get()[key], undefined);
	}

	return this.on(options && options.defer ? 'update' : 'state', function(event) {
		if (event.changed[key]) fn(event.current[key], event.previous && event.previous[key]);
	});
}

function observeDev(key, callback, options) {
	console.warn("this.observe(key, (newValue, oldValue) => {...}) is deprecated. Use\n\n  // runs before DOM updates\n  this.on('state', ({ changed, current, previous }) => {...});\n\n  // runs after DOM updates\n  this.on('update', ...);\n\n...or add the observe method from the svelte-extras package");

	var c = (key = '' + key).search(/[.[]/);
	if (c > -1) {
		var message =
			'The first argument to component.observe(...) must be the name of a top-level property';
		if (c > 0)
			message += ", i.e. '" + key.slice(0, c) + "' rather than '" + key + "'";

		throw new Error(message);
	}

	return observe.call(this, key, callback, options);
}

function on(eventName, handler) {
	if (eventName === 'teardown') return this.on('destroy', handler);

	var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
	handlers.push(handler);

	return {
		cancel: function() {
			var index = handlers.indexOf(handler);
			if (~index) handlers.splice(index, 1);
		}
	};
}

function onDev(eventName, handler) {
	if (eventName === 'teardown') {
		console.warn(
			"Use component.on('destroy', ...) instead of component.on('teardown', ...) which has been deprecated and will be unsupported in Svelte 2"
		);
		return this.on('destroy', handler);
	}

	return on.call(this, eventName, handler);
}

function run(fn) {
	fn();
}

function set(newState) {
	this._set(assign({}, newState));
	if (this.root._lock) return;
	this.root._lock = true;
	callAll(this.root._beforecreate);
	callAll(this.root._oncreate);
	callAll(this.root._aftercreate);
	this.root._lock = false;
}

function _set(newState) {
	var oldState = this._state,
		changed = {},
		dirty = false;

	for (var key in newState) {
		if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
	}
	if (!dirty) return;

	this._state = assign(assign({}, oldState), newState);
	this._recompute(changed, this._state);
	if (this._bind) this._bind(changed, this._state);

	if (this._fragment) {
		this.fire("state", { changed: changed, current: this._state, previous: oldState });
		this._fragment.p(changed, this._state);
		this.fire("update", { changed: changed, current: this._state, previous: oldState });
	}
}

function setDev(newState) {
	if (typeof newState !== 'object') {
		throw new Error(
			this._debugName + '.set was called without an object of data key-values to update.'
		);
	}

	this._checkReadOnly(newState);
	set.call(this, newState);
}

function callAll(fns) {
	while (fns && fns.length) fns.shift()();
}

function _mount(target, anchor) {
	this._fragment[this._fragment.i ? 'i' : 'm'](target, anchor || null);
}

function _unmount() {
	if (this._fragment) this._fragment.u();
}

function isPromise(value) {
	return value && typeof value.then === 'function';
}

var PENDING = {};
var SUCCESS = {};
var FAILURE = {};

function removeFromStore() {
	this.store._remove(this);
}

var proto = {
	destroy: destroy,
	get: get,
	fire: fire,
	observe: observe,
	on: on,
	set: set,
	teardown: destroy,
	_recompute: noop,
	_set: _set,
	_mount: _mount,
	_unmount: _unmount,
	_differs: _differs
};

var protoDev = {
	destroy: destroyDev,
	get: getDev,
	fire: fire,
	observe: observeDev,
	on: onDev,
	set: setDev,
	teardown: destroyDev,
	_recompute: noop,
	_set: _set,
	_mount: _mount,
	_unmount: _unmount,
	_differs: _differs
};




/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Common, shared methods for Svelte components.
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = {
  // Wrapper around set to call preventDefault
  eventSet: function eventSet(e, properties) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    this.set(properties);
  },

  // Geolocate user and set to "store"
  geolocate: function geolocate() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var u = _this.utils || _this.get('utils');
      if (u && u.checkGeolocate()) {
        _this.set({ isGeolocating: true });

        // Check if we have a location, use that, but still update
        var location = _this.get('location');
        if (location && location.lat && location.lng) {
          resolve(location);
        }

        // Geolocate
        u.geolocate(function (error, position) {
          _this.set({ isGeolocating: false });

          if (error) {
            return reject(error);
          } else if (position) {
            _this.set({ location: position });
            resolve(position);
          }
        });
      }
    });
  },

  // Distance between two coordinates
  // http://www.geodatasource.com/developers/javascript
  distance: function distance(lat1, lng1, lat2, lng2) {
    var unit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'miles';

    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lng1 - lng2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit === 'kilometers') {
      dist = dist * 1.609344;
    }
    if (unit === 'nautical') {
      dist = dist * 0.8684;
    }
    return dist;
  },

  // Go to an element
  goTo: function goTo(id, parent, scrollToOptions) {
    var utils = this.get('utils');
    var el = document.querySelector('[data-id=' + id + ']');

    if (utils && el) {
      utils.goTo(el, parent, scrollToOptions);
    }
  },

  // A basic query router thing
  startQueryRouter: function startQueryRouter() {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _this2 = this;

    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var utils = this.get('utils');

    // Load initial values
    if (utils && utils.query) {
      fields.forEach(function (f) {
        if (utils.query[f]) {
          _this2.set(_defineProperty({}, f, utils.query[f]));
        }
      });
    }

    // Change state if data changes
    if (this.get('isBrowser') && fields.length && utils && window && window.history) {
      fields.forEach(function (f) {
        _this2.observe(f, function (n, o) {
          if (n !== o) {
            var query = utils.query ? utils.deepClone(utils.query) : {};
            if (n) {
              query[f] = n;
            } else {
              delete query[f];
            }

            window.history.pushState(query, null, url + '?' + utils.queryString.stringify(query));
          }
        }, { init: false });
      });
    }

    // Watch for popstate
    if (window && window.history && utils) {
      window.addEventListener('popstate', function () {
        utils.parseQuery();
        var found = {};

        fields.forEach(function (f) {
          if (utils.query && utils.query[f]) {
            found[f] = utils.query[f];
          } else if (defaults && defaults[f]) {
            found[f] = defaults[f];
          }
        });

        _this2.set(found);
      });
    }
  },

  // Yay ads
  yesToAds: function yesToAds() {
    var data = this.get('data');

    if (!this.__servedAd && data && data.ad && this.get('isBrowser') && window && window.googletag) {
      window.googletag.cmd.push(function () {
        window.googletag.display(data.ad.id);
      });
      this.__servedAd = true;
    }
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Common/share helpers for Svelte components
 *
 * Note that computed methods can't be variables and have to be
 * defined in the component, but we want to share some, so
 * we make them helpers.
 */

var helpers = {};

// Create image srcset.
helpers.srcset = function (basePath, imagePath, extension) {
  var p = basePath + '/' + imagePath;

  return ['300', '600', '900', '1200', '2000'].map(function (w) {
    return p.replace(/\.([a-z]+$)/i, '-' + w + 'px.$1').replace(/\.([a-z]+$)/i, extension ? '.' + extension : '.$1') + ' ' + w + 'w';
  }).join(', ');
};

// Escape HTML, specifically for fields where we sometimes want HTML {{{ }}}
// and sometimes don't.
helpers.escapeHTML = function (input) {
  return input ? input.replace(/(<([^>]+)>)/gi, '') : '';
};

// Does data have a full byline or not
helpers.fullByline = function (data) {
  return data && data.byline && ~data.byline.indexOf('•');
};

// Simple, hacky way to determine ios
helpers.isIOS = function () {
  return typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.match && window.navigator.userAgent.match(/iphone|ipad/i) ? true : false;
};

// URL for directions via Google or Apple on iOS.  Ideally we would have a name
// with the searching, but this is hard to do.  Google Maps has place IDs,
// but I don't think that translates to Apple maps.
// https://developers.google.com/maps/documentation/urls/guide#directions-action
helpers.directionsURL = function (data, store) {
  var location = store && store.location && store.location.position ? store.location.position.lat + ',' + store.location.position.lng : undefined;

  return helpers.isIOS() ? 'https://maps.apple.com/?api=x' + (location ? '&saddr=' + encodeURIComponent(location) : '') + '&daddr=' + (data.directionsAddress ? encodeURIComponent(data.directionsAddress) : encodeURIComponent(data.latitude + ',' + data.longitude)) : 'https://www.google.com/maps/dir/?api=1' + (location ? '&origin=' + encodeURIComponent(location) : '') + '&destination=' + (data.directionsAddress ? encodeURIComponent(data.directionsAddress) : encodeURIComponent(data.latitude + ',' + data.longitude));
};

// URL for facebook link
helpers.facebookURL = function (data) {
  if (!data) {
    return '';
  }

  return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.baseURL + data.filename);
};

// URL for twitter link
helpers.twitterURL = function (data, content) {
  if (!data && !content) {
    return '';
  }

  var defaultShare = content.twitterShareDefault ? content.twitterShareDefault.replace('[[NAME]]', data.title || data.name) : '';

  return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(data.twitterShare || defaultShare || content.twitterShare) + '&url=' + encodeURIComponent(data.baseURL + data.filename) + '&via=' + encodeURIComponent(content.twitterAccount);
};

// URL for email link
helpers.emailURL = function (data, content) {
  if (!data && !content) {
    return '';
  }

  var defaultShare = content.twitterShareDefault ? content.twitterShareDefault.replace('[[NAME]]', data.title || data.name) : '';

  return 'mailto:?subject=' + encodeURIComponent(data.emailShare || data.twitterShare || defaultShare || content.emailShare) + '&body=' + encodeURIComponent(data.baseURL + data.filename);
};

// SMS url
helpers.smsURL = function (data, content) {
  if (!data && !content) {
    return '';
  }

  var defaultShare = content.twitterShareDefault ? content.twitterShareDefault.replace('[[NAME]]', data.title || data.name) : '';

  return 'sms:' + (helpers.isIOS() ? '&' : '?') + 'body=' + encodeURIComponent(data.emailShare || data.twitterShare || defaultShare || content.emailShare) + encodeURIComponent(' \n') + encodeURIComponent(data.baseURL + data.filename);
};

helpers.phoneURL = function (phone) {
  return phone ? 'tel:1' + phone.replace(/[^0-9]+/g, '') : '';
};

helpers.urlLink = function (url) {
  return url ? url.match(/^http/i) ? url : 'http://' + url : '';
};

helpers.urlText = function (url) {
  return url ? url.replace(/^https?:\/\//i, '').replace(/www\./i, '').replace(/\/$/, '') : '';
};

// Parse a date
helpers.parseDate = function (input) {
  // Assume YYYY-MM-DD
  if (typeof input === 'string') {
    return new Date(parseInt(input.split('-')[0], 10), parseInt(input.split('-')[1], 10) - 1, parseInt(input.split('-')[2], 10));
  } else if (input && typeof input.getMonth === 'function') {
    return input;
  }
};

// Format date
helpers.formatDate = function (date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Month Date, Year';

  var monthLong = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthShort = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

  var d = helpers.parseDate(date);
  if (!d) {
    return '';
  }

  return format.replace(/ISO/g, d.toString()).replace(/Year/g, d.getFullYear()).replace(/Month|MonthShort/g, monthShort[d.getMonth()]).replace(/MonthLong/g, monthLong[d.getMonth()]).replace(/Date/g, d.getDate());
};

// Is a date past
helpers.datePast = function (date) {
  var d = helpers.parseDate(date);
  if (!d) {
    return false;
  }

  var now = new Date();

  // If now is greater and not the same day
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate() ? false : now.getTime() > d.getTime();
};

module.exports = helpers;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/items.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _helpers = __webpack_require__(2);

var _helpers2 = _interopRequireDefault(_helpers);

var _methods = __webpack_require__(1);

var _methods2 = _interopRequireDefault(_methods);

var _ad = __webpack_require__(4);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sectionGroup(data) {
	return data.groups ? data.groups[0] : data.lists && data.lists[0] && data.lists[0].groups ? data.lists[0].groups[0] : undefined;
};

function data() {
	return {
		display: "full",
		isBrowser: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined
	};
};

var fullByline = _helpers2.default.fullByline;

var directionsURL = _helpers2.default.directionsURL;

var facebookURL = _helpers2.default.facebookURL;

var twitterURL = _helpers2.default.twitterURL;

var emailURL = _helpers2.default.emailURL;

var phoneURL = _helpers2.default.phoneURL;

var smsURL = _helpers2.default.smsURL;

var urlLink = _helpers2.default.urlLink;

var urlText = _helpers2.default.urlText;

var escapeHTML = _helpers2.default.escapeHTML;

var srcset = _helpers2.default.srcset;

var parseDate = _helpers2.default.parseDate;

var formatDate = _helpers2.default.formatDate;

var datePast = _helpers2.default.datePast;

var methods_1 = {
	distance: _methods2.default.distance
};

function oncreate() {
	var _this = this;

	// Watch store for location
	if (this.store) {
		this.store.observe("location", function (n) {
			if (n && n.lat && n.lng) {
				var _data = _this.get("data");
				if (_data.latitude && _data.longitude) {
					_data.distance = _this.distance(_data.latitude, _data.longitude, n.lat, n.lng);
					_this.set({ data: _data });
				}
			}
		});
	}
};

function create_main_fragment(component, state) {
	var text,
	    div,
	    text_1,
	    article,
	    div_1,
	    div_2,
	    h1,
	    a,
	    text_2_value = state.data.name,
	    text_2,
	    a_href_value,
	    text_4,
	    text_6,
	    div_3,
	    div_4,
	    text_8,
	    text_11,
	    text_12,
	    div_5,
	    text_13,
	    div_6,
	    raw_value = state.data.description,
	    text_14,
	    text_15,
	    article_class_value,
	    article_data_id_value,
	    div_class_value,
	    div_data_id_value;

	var if_block = state.display === 'full' && create_if_block(component, state);

	var if_block_1 = state.display === 'full' && create_if_block_4(component, state);

	var if_block_2 = state.data.address && create_if_block_6(component, state);

	function select_block_type_1(state) {
		if (state.data.distance) return create_if_block_7;
		return create_if_block_8;
	}

	var current_block_type = select_block_type_1(state);
	var if_block_3 = current_block_type(component, state);

	var if_block_4 = (state.data.latitude && state.data.longitude || state.data.directionsAddress) && create_if_block_9(component, state);

	var if_block_5 = state.data.mainImageLocal && state.display !== 'map' && create_if_block_10(component, state);

	var if_block_6 = state.data.byline && state.display !== 'list' && create_if_block_13(component, state);

	var if_block_7 = state.display !== 'map' && create_if_block_16(component, state);

	var if_block_8 = state.display === 'full' && create_if_block_24(component, state);

	return {
		c: function create() {
			if (if_block) if_block.c();
			text = (0, _shared.createText)("\n\n");
			div = (0, _shared.createElement)("div");
			if (if_block_1) if_block_1.c();
			text_1 = (0, _shared.createText)("\n\n  ");
			article = (0, _shared.createElement)("article");
			div_1 = (0, _shared.createElement)("div");
			div_2 = (0, _shared.createElement)("div");
			h1 = (0, _shared.createElement)("h1");
			a = (0, _shared.createElement)("a");
			text_2 = (0, _shared.createText)(text_2_value);
			text_4 = (0, _shared.createText)("\n\n        ");
			if (if_block_2) if_block_2.c();
			text_6 = (0, _shared.createText)("\n\n      ");
			div_3 = (0, _shared.createElement)("div");
			div_4 = (0, _shared.createElement)("div");
			if_block_3.c();
			text_8 = (0, _shared.createText)("\n\n        ");
			if (if_block_4) if_block_4.c();
			text_11 = (0, _shared.createText)("\n\n    ");
			if (if_block_5) if_block_5.c();
			text_12 = (0, _shared.createText)("\n\n    ");
			div_5 = (0, _shared.createElement)("div");
			if (if_block_6) if_block_6.c();
			text_13 = (0, _shared.createText)("\n\n      ");
			div_6 = (0, _shared.createElement)("div");
			text_14 = (0, _shared.createText)("\n\n      ");
			if (if_block_7) if_block_7.c();
			text_15 = (0, _shared.createText)("\n\n      ");
			if (if_block_8) if_block_8.c();
			this.h();
		},

		l: function claim(nodes) {
			if (if_block) if_block.l(nodes);
			text = (0, _shared.claimText)(nodes, "\n\n");

			div = (0, _shared.claimElement)(nodes, "DIV", { class: true, "data-id": true }, false);
			var div_nodes = (0, _shared.children)(div);

			if (if_block_1) if_block_1.l(div_nodes);
			text_1 = (0, _shared.claimText)(div_nodes, "\n\n  ");

			article = (0, _shared.claimElement)(div_nodes, "ARTICLE", { class: true, "data-id": true }, false);
			var article_nodes = (0, _shared.children)(article);

			div_1 = (0, _shared.claimElement)(article_nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			div_2 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_2_nodes = (0, _shared.children)(div_2);

			h1 = (0, _shared.claimElement)(div_2_nodes, "H1", { class: true }, false);
			var h1_nodes = (0, _shared.children)(h1);

			a = (0, _shared.claimElement)(h1_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text_2 = (0, _shared.claimText)(a_nodes, text_2_value);
			a_nodes.forEach(_shared.detachNode);
			h1_nodes.forEach(_shared.detachNode);
			text_4 = (0, _shared.claimText)(div_2_nodes, "\n\n        ");
			if (if_block_2) if_block_2.l(div_2_nodes);
			div_2_nodes.forEach(_shared.detachNode);
			text_6 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			div_3 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_3_nodes = (0, _shared.children)(div_3);

			div_4 = (0, _shared.claimElement)(div_3_nodes, "DIV", { class: true }, false);
			var div_4_nodes = (0, _shared.children)(div_4);

			if_block_3.l(div_4_nodes);
			div_4_nodes.forEach(_shared.detachNode);
			text_8 = (0, _shared.claimText)(div_3_nodes, "\n\n        ");
			if (if_block_4) if_block_4.l(div_3_nodes);
			div_3_nodes.forEach(_shared.detachNode);
			div_1_nodes.forEach(_shared.detachNode);
			text_11 = (0, _shared.claimText)(article_nodes, "\n\n    ");
			if (if_block_5) if_block_5.l(article_nodes);
			text_12 = (0, _shared.claimText)(article_nodes, "\n\n    ");

			div_5 = (0, _shared.claimElement)(article_nodes, "DIV", { class: true }, false);
			var div_5_nodes = (0, _shared.children)(div_5);

			if (if_block_6) if_block_6.l(div_5_nodes);
			text_13 = (0, _shared.claimText)(div_5_nodes, "\n\n      ");

			div_6 = (0, _shared.claimElement)(div_5_nodes, "DIV", { class: true }, false);
			var div_6_nodes = (0, _shared.children)(div_6);

			div_6_nodes.forEach(_shared.detachNode);
			text_14 = (0, _shared.claimText)(div_5_nodes, "\n\n      ");
			if (if_block_7) if_block_7.l(div_5_nodes);
			text_15 = (0, _shared.claimText)(div_5_nodes, "\n\n      ");
			if (if_block_8) if_block_8.l(div_5_nodes);
			div_5_nodes.forEach(_shared.detachNode);
			article_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + state.data.filename;
			h1.className = "heading-alternate";
			div_2.className = "item-header-left";
			div_4.className = "near-me";
			div_3.className = "item-header-right";
			div_1.className = "item-header";
			div_6.className = "item-description";
			div_5.className = "item-content";
			article.className = article_class_value = "item item-" + state.display + " " + (state.data.inView ? 'in-view' : '');
			article.dataset.id = article_data_id_value = state.data.id;
			div.className = div_class_value = "component component-item component-item-" + state.display + " " + (state.display === 'full' ? 'has-minor-navigation' : '');
			div.dataset.id = div_data_id_value = state.data.id;
		},

		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0, _shared.insertNode)(text, target, anchor);
			(0, _shared.insertNode)(div, target, anchor);
			if (if_block_1) if_block_1.m(div, null);
			(0, _shared.appendNode)(text_1, div);
			(0, _shared.appendNode)(article, div);
			(0, _shared.appendNode)(div_1, article);
			(0, _shared.appendNode)(div_2, div_1);
			(0, _shared.appendNode)(h1, div_2);
			(0, _shared.appendNode)(a, h1);
			(0, _shared.appendNode)(text_2, a);
			(0, _shared.appendNode)(text_4, div_2);
			if (if_block_2) if_block_2.m(div_2, null);
			(0, _shared.appendNode)(text_6, div_1);
			(0, _shared.appendNode)(div_3, div_1);
			(0, _shared.appendNode)(div_4, div_3);
			if_block_3.m(div_4, null);
			(0, _shared.appendNode)(text_8, div_3);
			if (if_block_4) if_block_4.m(div_3, null);
			(0, _shared.appendNode)(text_11, article);
			if (if_block_5) if_block_5.m(article, null);
			(0, _shared.appendNode)(text_12, article);
			(0, _shared.appendNode)(div_5, article);
			if (if_block_6) if_block_6.m(div_5, null);
			(0, _shared.appendNode)(text_13, div_5);
			(0, _shared.appendNode)(div_6, div_5);
			div_6.innerHTML = raw_value;
			(0, _shared.appendNode)(text_14, div_5);
			if (if_block_7) if_block_7.m(div_5, null);
			(0, _shared.appendNode)(text_15, div_5);
			if (if_block_8) if_block_8.m(div_5, null);
		},

		p: function update(changed, state) {
			if (state.display === 'full') {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block(component, state);
					if_block.c();
					if_block.m(text.parentNode, text);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (state.display === 'full') {
				if (if_block_1) {
					if_block_1.p(changed, state);
				} else {
					if_block_1 = create_if_block_4(component, state);
					if_block_1.c();
					if_block_1.m(div, text_1);
				}
			} else if (if_block_1) {
				if_block_1.u();
				if_block_1.d();
				if_block_1 = null;
			}

			if (changed.data && text_2_value !== (text_2_value = state.data.name)) {
				text_2.data = text_2_value;
			}

			if (changed.data && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + state.data.filename)) {
				a.href = a_href_value;
			}

			if (state.data.address) {
				if (if_block_2) {
					if_block_2.p(changed, state);
				} else {
					if_block_2 = create_if_block_6(component, state);
					if_block_2.c();
					if_block_2.m(div_2, null);
				}
			} else if (if_block_2) {
				if_block_2.u();
				if_block_2.d();
				if_block_2 = null;
			}

			if (current_block_type === (current_block_type = select_block_type_1(state)) && if_block_3) {
				if_block_3.p(changed, state);
			} else {
				if_block_3.u();
				if_block_3.d();
				if_block_3 = current_block_type(component, state);
				if_block_3.c();
				if_block_3.m(div_4, null);
			}

			if (state.data.latitude && state.data.longitude || state.data.directionsAddress) {
				if (if_block_4) {
					if_block_4.p(changed, state);
				} else {
					if_block_4 = create_if_block_9(component, state);
					if_block_4.c();
					if_block_4.m(div_3, null);
				}
			} else if (if_block_4) {
				if_block_4.u();
				if_block_4.d();
				if_block_4 = null;
			}

			if (state.data.mainImageLocal && state.display !== 'map') {
				if (if_block_5) {
					if_block_5.p(changed, state);
				} else {
					if_block_5 = create_if_block_10(component, state);
					if_block_5.c();
					if_block_5.m(article, text_12);
				}
			} else if (if_block_5) {
				if_block_5.u();
				if_block_5.d();
				if_block_5 = null;
			}

			if (state.data.byline && state.display !== 'list') {
				if (if_block_6) {
					if_block_6.p(changed, state);
				} else {
					if_block_6 = create_if_block_13(component, state);
					if_block_6.c();
					if_block_6.m(div_5, text_13);
				}
			} else if (if_block_6) {
				if_block_6.u();
				if_block_6.d();
				if_block_6 = null;
			}

			if (changed.data && raw_value !== (raw_value = state.data.description)) {
				div_6.innerHTML = raw_value;
			}

			if (state.display !== 'map') {
				if (if_block_7) {
					if_block_7.p(changed, state);
				} else {
					if_block_7 = create_if_block_16(component, state);
					if_block_7.c();
					if_block_7.m(div_5, text_15);
				}
			} else if (if_block_7) {
				if_block_7.u();
				if_block_7.d();
				if_block_7 = null;
			}

			if (state.display === 'full') {
				if (if_block_8) {
					if_block_8.p(changed, state);
				} else {
					if_block_8 = create_if_block_24(component, state);
					if_block_8.c();
					if_block_8.m(div_5, null);
				}
			} else if (if_block_8) {
				if_block_8.u();
				if_block_8.d();
				if_block_8 = null;
			}

			if ((changed.display || changed.data) && article_class_value !== (article_class_value = "item item-" + state.display + " " + (state.data.inView ? 'in-view' : ''))) {
				article.className = article_class_value;
			}

			if (changed.data && article_data_id_value !== (article_data_id_value = state.data.id)) {
				article.dataset.id = article_data_id_value;
			}

			if (changed.display && div_class_value !== (div_class_value = "component component-item component-item-" + state.display + " " + (state.display === 'full' ? 'has-minor-navigation' : ''))) {
				div.className = div_class_value;
			}

			if (changed.data && div_data_id_value !== (div_data_id_value = state.data.id)) {
				div.dataset.id = div_data_id_value;
			}
		},

		u: function unmount() {
			div_6.innerHTML = '';

			if (if_block) if_block.u();
			(0, _shared.detachNode)(text);
			(0, _shared.detachNode)(div);
			if (if_block_1) if_block_1.u();
			if (if_block_2) if_block_2.u();
			if_block_3.u();
			if (if_block_4) if_block_4.u();
			if (if_block_5) if_block_5.u();
			if (if_block_6) if_block_6.u();
			if (if_block_7) if_block_7.u();
			if (if_block_8) if_block_8.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_1) if_block_1.d();
			if (if_block_2) if_block_2.d();
			if_block_3.d();
			if (if_block_4) if_block_4.d();
			if (if_block_5) if_block_5.d();
			if (if_block_6) if_block_6.d();
			if (if_block_7) if_block_7.d();
			if (if_block_8) if_block_8.d();
		}
	};
}

// (4:6) {{#if $isBrowser && $offline}}
function create_if_block_2(component, state) {
	var img, img_alt_value, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal.replace('.jpg', '-600px.jpg');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal.replace('.jpg', '-600px.jpg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (8:6) {{else}}
function create_if_block_3(component, state) {
	var picture, source, source_srcset_value, text, source_1, source_1_srcset_value, text_1, img, img_alt_value, img_src_value;

	return {
		c: function create() {
			picture = (0, _shared.createElement)("picture");
			source = (0, _shared.createElement)("source");
			text = (0, _shared.createText)("\n          ");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n          ");
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			picture = (0, _shared.claimElement)(nodes, "PICTURE", {}, false);
			var picture_nodes = (0, _shared.children)(picture);

			source = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(picture_nodes, "\n          ");

			source_1 = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(picture_nodes, "\n          ");

			img = (0, _shared.claimElement)(picture_nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			picture_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.type = "image/webp";
			(0, _shared.setAttribute)(source, "srcset", source_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal, 'webp'));
			source.sizes = "100vw";
			source_1.type = "image/jpeg";
			(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal));
			source_1.sizes = "100vw";
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(picture, target, anchor);
			(0, _shared.appendNode)(source, picture);
			(0, _shared.appendNode)(text, picture);
			(0, _shared.appendNode)(source_1, picture);
			(0, _shared.appendNode)(text_1, picture);
			(0, _shared.appendNode)(img, picture);
		},

		p: function update(changed, state) {
			if (changed.data && source_srcset_value !== (source_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal, 'webp'))) {
				(0, _shared.setAttribute)(source, "srcset", source_srcset_value);
			}

			if (changed.data && source_1_srcset_value !== (source_1_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal))) {
				(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value);
			}

			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal)) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(picture);
		},

		d: _shared.noop
	};
}

// (3:4) {{#if data.mainImageLocal}}
function create_if_block_1(component, state) {
	var if_block_anchor;

	function select_block_type(state) {
		if (state.$isBrowser && state.$offline) return create_if_block_2;
		return create_if_block_3;
	}

	var current_block_type = select_block_type(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},

		u: function unmount() {
			if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (1:0) {{#if display === 'full'}}
function create_if_block(component, state) {
	var div;

	var if_block = state.data.mainImageLocal && create_if_block_1(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			if (if_block) if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			if (if_block) if_block.l(div_nodes);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "main-visual";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			if (if_block) if_block.m(div, null);
		},

		p: function update(changed, state) {
			if (state.data.mainImageLocal) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_1(component, state);
					if_block.c();
					if_block.m(div, null);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
		}
	};
}

// (30:6) {{#if sectionGroup }}
function create_if_block_5(component, state) {
	var h1,
	    a,
	    text_value = state.sectionGroup.title,
	    text,
	    a_href_value;

	return {
		c: function create() {
			h1 = (0, _shared.createElement)("h1");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)(text_value);
			this.h();
		},

		l: function claim(nodes) {
			h1 = (0, _shared.claimElement)(nodes, "H1", {}, false);
			var h1_nodes = (0, _shared.children)(h1);

			a = (0, _shared.claimElement)(h1_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, text_value);
			a_nodes.forEach(_shared.detachNode);
			h1_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + state.sectionGroup.filename;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(h1, target, anchor);
			(0, _shared.appendNode)(a, h1);
			(0, _shared.appendNode)(text, a);
		},

		p: function update(changed, state) {
			if (changed.sectionGroup && text_value !== (text_value = state.sectionGroup.title)) {
				text.data = text_value;
			}

			if ((changed.data || changed.sectionGroup) && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + state.sectionGroup.filename)) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(h1);
		},

		d: _shared.noop
	};
}

// (28:2) {{#if display === 'full'}}
function create_if_block_4(component, state) {
	var nav;

	var if_block = state.sectionGroup && create_if_block_5(component, state);

	return {
		c: function create() {
			nav = (0, _shared.createElement)("nav");
			if (if_block) if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			nav = (0, _shared.claimElement)(nodes, "NAV", { class: true }, false);
			var nav_nodes = (0, _shared.children)(nav);

			if (if_block) if_block.l(nav_nodes);
			nav_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			nav.className = "minor-navigation minor-nav-lists";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(nav, target, anchor);
			if (if_block) if_block.m(nav, null);
		},

		p: function update(changed, state) {
			if (state.sectionGroup) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_5(component, state);
					if_block.c();
					if_block.m(nav, null);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(nav);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
		}
	};
}

// (43:8) {{#if data.address}}
function create_if_block_6(component, state) {
	var address,
	    text_value = state.data.address,
	    text;

	return {
		c: function create() {
			address = (0, _shared.createElement)("address");
			text = (0, _shared.createText)(text_value);
		},

		l: function claim(nodes) {
			address = (0, _shared.claimElement)(nodes, "ADDRESS", {}, false);
			var address_nodes = (0, _shared.children)(address);

			text = (0, _shared.claimText)(address_nodes, text_value);
			address_nodes.forEach(_shared.detachNode);
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(address, target, anchor);
			(0, _shared.appendNode)(text, address);
		},

		p: function update(changed, state) {
			if (changed.data && text_value !== (text_value = state.data.address)) {
				text.data = text_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(address);
		},

		d: _shared.noop
	};
}

// (50:10) {{#if data.distance}}
function create_if_block_7(component, state) {
	var text_value = state.utils.round(state.data.distance, 1),
	    text,
	    text_1;

	return {
		c: function create() {
			text = (0, _shared.createText)(text_value);
			text_1 = (0, _shared.createText)(" mi");
		},

		l: function claim(nodes) {
			text = (0, _shared.claimText)(nodes, text_value);
			text_1 = (0, _shared.claimText)(nodes, " mi");
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(text, target, anchor);
			(0, _shared.insertNode)(text_1, target, anchor);
		},

		p: function update(changed, state) {
			if ((changed.utils || changed.data) && text_value !== (text_value = state.utils.round(state.data.distance, 1))) {
				text.data = text_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(text);
			(0, _shared.detachNode)(text_1);
		},

		d: _shared.noop
	};
}

// (52:10) {{else}}
function create_if_block_8(component, state) {
	var text;

	return {
		c: function create() {
			text = (0, _shared.createText)(" ");
		},

		l: function claim(nodes) {
			text = (0, _shared.claimText)(nodes, " ");
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(text, target, anchor);
		},

		p: _shared.noop,

		u: function unmount() {
			(0, _shared.detachNode)(text);
		},

		d: _shared.noop
	};
}

// (57:8) {{#if (data.latitude && data.longitude) || data.directionsAddress}}
function create_if_block_9(component, state) {
	var a, text, a_href_value;

	return {
		c: function create() {
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)("Directions");
			this.h();
		},

		l: function claim(nodes) {
			a = (0, _shared.claimElement)(nodes, "A", { href: true, target: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, "Directions");
			a_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = directionsURL(state.data, state.store);
			a.target = "_blank";
			a.className = "directions";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(a, target, anchor);
			(0, _shared.appendNode)(text, a);
		},

		p: function update(changed, state) {
			if ((changed.data || changed.store) && a_href_value !== (a_href_value = directionsURL(state.data, state.store))) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(a);
		},

		d: _shared.noop
	};
}

// (67:12) {{#if $isBrowser && $offline}}
function create_if_block_11(component, state) {
	var img, img_alt_value, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal.replace('.jpg', '-600px.jpg');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal.replace('.jpg', '-600px.jpg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (71:12) {{else}}
function create_if_block_12(component, state) {
	var picture, source, source_srcset_value, text, source_1, source_1_srcset_value, text_1, img, img_alt_value, img_src_value;

	return {
		c: function create() {
			picture = (0, _shared.createElement)("picture");
			source = (0, _shared.createElement)("source");
			text = (0, _shared.createText)("\n                ");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n                ");
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			picture = (0, _shared.claimElement)(nodes, "PICTURE", {}, false);
			var picture_nodes = (0, _shared.children)(picture);

			source = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(picture_nodes, "\n                ");

			source_1 = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(picture_nodes, "\n                ");

			img = (0, _shared.claimElement)(picture_nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			picture_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.type = "image/webp";
			(0, _shared.setAttribute)(source, "srcset", source_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal, 'webp'));
			source.sizes = "100vw";
			source_1.type = "image/jpeg";
			(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal));
			source_1.sizes = "100vw";
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(picture, target, anchor);
			(0, _shared.appendNode)(source, picture);
			(0, _shared.appendNode)(text, picture);
			(0, _shared.appendNode)(source_1, picture);
			(0, _shared.appendNode)(text_1, picture);
			(0, _shared.appendNode)(img, picture);
		},

		p: function update(changed, state) {
			if (changed.data && source_srcset_value !== (source_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal, 'webp'))) {
				(0, _shared.setAttribute)(source, "srcset", source_srcset_value);
			}

			if (changed.data && source_1_srcset_value !== (source_1_srcset_value = srcset(state.data.basePath, state.data.mainImageLocal))) {
				(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value);
			}

			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainImageLocal)) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(picture);
		},

		d: _shared.noop
	};
}

// (63:4) {{#if data.mainImageLocal && display !== 'map' }}
function create_if_block_10(component, state) {
	var div,
	    figure,
	    a,
	    a_href_value,
	    text_1,
	    cite,
	    text_2_value = state.data.imageCredit,
	    text_2;

	function select_block_type_2(state) {
		if (state.$isBrowser && state.$offline) return create_if_block_11;
		return create_if_block_12;
	}

	var current_block_type = select_block_type_2(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			figure = (0, _shared.createElement)("figure");
			a = (0, _shared.createElement)("a");
			if_block.c();
			text_1 = (0, _shared.createText)("\n\n          ");
			cite = (0, _shared.createElement)("cite");
			text_2 = (0, _shared.createText)(text_2_value);
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			figure = (0, _shared.claimElement)(div_nodes, "FIGURE", {}, false);
			var figure_nodes = (0, _shared.children)(figure);

			a = (0, _shared.claimElement)(figure_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			if_block.l(a_nodes);
			a_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(figure_nodes, "\n\n          ");

			cite = (0, _shared.claimElement)(figure_nodes, "CITE", {}, false);
			var cite_nodes = (0, _shared.children)(cite);

			text_2 = (0, _shared.claimText)(cite_nodes, text_2_value);
			cite_nodes.forEach(_shared.detachNode);
			figure_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + state.data.filename;
			div.className = "item-image";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(figure, div);
			(0, _shared.appendNode)(a, figure);
			if_block.m(a, null);
			(0, _shared.appendNode)(text_1, figure);
			(0, _shared.appendNode)(cite, figure);
			(0, _shared.appendNode)(text_2, cite);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type_2(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(a, null);
			}

			if (changed.data && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + state.data.filename)) {
				a.href = a_href_value;
			}

			if (changed.data && text_2_value !== (text_2_value = state.data.imageCredit)) {
				text_2.data = text_2_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
			if_block.u();
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (96:10) {{#if fullByline(data)}}
function create_if_block_14(component, state) {
	var raw_value = state.data.byline,
	    raw_before,
	    raw_after;

	return {
		c: function create() {
			raw_before = (0, _shared.createElement)('noscript');
			raw_after = (0, _shared.createElement)('noscript');
		},

		l: function claim(nodes) {
			raw_before = (0, _shared.createElement)('noscript');
			raw_after = (0, _shared.createElement)('noscript');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(raw_before, target, anchor);
			raw_before.insertAdjacentHTML("afterend", raw_value);
			(0, _shared.insertNode)(raw_after, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && raw_value !== (raw_value = state.data.byline)) {
				(0, _shared.detachBetween)(raw_before, raw_after);
				raw_before.insertAdjacentHTML("afterend", raw_value);
			}
		},

		u: function unmount() {
			(0, _shared.detachBetween)(raw_before, raw_after);

			(0, _shared.detachNode)(raw_before);
			(0, _shared.detachNode)(raw_after);
		},

		d: _shared.noop
	};
}

// (98:10) {{else}}
function create_if_block_15(component, state) {
	var strong,
	    text,
	    text_1_value = escapeHTML(state.data.byline),
	    text_1,
	    text_2;

	return {
		c: function create() {
			strong = (0, _shared.createElement)("strong");
			text = (0, _shared.createText)("By ");
			text_1 = (0, _shared.createText)(text_1_value);
			text_2 = (0, _shared.createText)(" • Star Tribune");
		},

		l: function claim(nodes) {
			strong = (0, _shared.claimElement)(nodes, "STRONG", {}, false);
			var strong_nodes = (0, _shared.children)(strong);

			text = (0, _shared.claimText)(strong_nodes, "By ");
			text_1 = (0, _shared.claimText)(strong_nodes, text_1_value);
			strong_nodes.forEach(_shared.detachNode);
			text_2 = (0, _shared.claimText)(nodes, " • Star Tribune");
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(strong, target, anchor);
			(0, _shared.appendNode)(text, strong);
			(0, _shared.appendNode)(text_1, strong);
			(0, _shared.insertNode)(text_2, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = escapeHTML(state.data.byline))) {
				text_1.data = text_1_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(strong);
			(0, _shared.detachNode)(text_2);
		},

		d: _shared.noop
	};
}

// (94:6) {{#if data.byline && display !== 'list'}}
function create_if_block_13(component, state) {
	var div;

	function select_block_type_3(state) {
		if (fullByline(state.data)) return create_if_block_14;
		return create_if_block_15;
	}

	var current_block_type = select_block_type_3(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			if_block.l(div_nodes);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "byline";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			if_block.m(div, null);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type_3(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(div, null);
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
			if_block.u();
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (113:16) {{#if data.endDate && data.startDate !== data.endDate}}
function create_if_block_19(component, state) {
	var text,
	    time,
	    text_1_value = formatDate(state.data.endDate),
	    text_1;

	return {
		c: function create() {
			text = (0, _shared.createText)("- ");
			time = (0, _shared.createElement)("time");
			text_1 = (0, _shared.createText)(text_1_value);
			this.h();
		},

		l: function claim(nodes) {
			text = (0, _shared.claimText)(nodes, "- ");

			time = (0, _shared.claimElement)(nodes, "TIME", { datetime: true }, false);
			var time_nodes = (0, _shared.children)(time);

			text_1 = (0, _shared.claimText)(time_nodes, text_1_value);
			time_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			time.dateTime = "formatDate(data.endDate, 'ISO')";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(text, target, anchor);
			(0, _shared.insertNode)(time, target, anchor);
			(0, _shared.appendNode)(text_1, time);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = formatDate(state.data.endDate))) {
				text_1.data = text_1_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(text);
			(0, _shared.detachNode)(time);
		},

		d: _shared.noop
	};
}

// (116:16) {{#if datePast(data.endDate) || (!data.endDate && datePast(data.startDate)) }}
function create_if_block_20(component, state) {
	var br, em, text;

	return {
		c: function create() {
			br = (0, _shared.createElement)("br");
			em = (0, _shared.createElement)("em");
			text = (0, _shared.createText)("This event has already happened.");
		},

		l: function claim(nodes) {
			br = (0, _shared.claimElement)(nodes, "BR", {}, false);
			var br_nodes = (0, _shared.children)(br);

			br_nodes.forEach(_shared.detachNode);

			em = (0, _shared.claimElement)(nodes, "EM", {}, false);
			var em_nodes = (0, _shared.children)(em);

			text = (0, _shared.claimText)(em_nodes, "This event has already happened.");
			em_nodes.forEach(_shared.detachNode);
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(br, target, anchor);
			(0, _shared.insertNode)(em, target, anchor);
			(0, _shared.appendNode)(text, em);
		},

		u: function unmount() {
			(0, _shared.detachNode)(br);
			(0, _shared.detachNode)(em);
		},

		d: _shared.noop
	};
}

// (109:12) {{#if data.startDate}}
function create_if_block_18(component, state) {
	var dt,
	    span,
	    text,
	    dd,
	    span_1,
	    time,
	    text_1_value = formatDate(state.data.startDate),
	    text_1,
	    text_2,
	    text_3;

	var if_block = state.data.endDate && state.data.startDate !== state.data.endDate && create_if_block_19(component, state);

	var if_block_1 = (datePast(state.data.endDate) || !state.data.endDate && datePast(state.data.startDate)) && create_if_block_20(component, state);

	return {
		c: function create() {
			dt = (0, _shared.createElement)("dt");
			span = (0, _shared.createElement)("span");
			text = (0, _shared.createText)("When");
			dd = (0, _shared.createElement)("dd");
			span_1 = (0, _shared.createElement)("span");
			time = (0, _shared.createElement)("time");
			text_1 = (0, _shared.createText)(text_1_value);
			text_2 = (0, _shared.createText)("\n                ");
			if (if_block) if_block.c();
			text_3 = (0, _shared.createText)("\n                ");
			if (if_block_1) if_block_1.c();
			this.h();
		},

		l: function claim(nodes) {
			dt = (0, _shared.claimElement)(nodes, "DT", {}, false);
			var dt_nodes = (0, _shared.children)(dt);

			span = (0, _shared.claimElement)(dt_nodes, "SPAN", {}, false);
			var span_nodes = (0, _shared.children)(span);

			text = (0, _shared.claimText)(span_nodes, "When");
			span_nodes.forEach(_shared.detachNode);
			dt_nodes.forEach(_shared.detachNode);

			dd = (0, _shared.claimElement)(nodes, "DD", {}, false);
			var dd_nodes = (0, _shared.children)(dd);

			span_1 = (0, _shared.claimElement)(dd_nodes, "SPAN", {}, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			time = (0, _shared.claimElement)(span_1_nodes, "TIME", { datetime: true }, false);
			var time_nodes = (0, _shared.children)(time);

			text_1 = (0, _shared.claimText)(time_nodes, text_1_value);
			time_nodes.forEach(_shared.detachNode);
			text_2 = (0, _shared.claimText)(span_1_nodes, "\n                ");
			if (if_block) if_block.l(span_1_nodes);
			text_3 = (0, _shared.claimText)(span_1_nodes, "\n                ");
			if (if_block_1) if_block_1.l(span_1_nodes);
			span_1_nodes.forEach(_shared.detachNode);
			dd_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			time.dateTime = "formatDate(data.startDate, 'ISO')";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(dt, target, anchor);
			(0, _shared.appendNode)(span, dt);
			(0, _shared.appendNode)(text, span);
			(0, _shared.insertNode)(dd, target, anchor);
			(0, _shared.appendNode)(span_1, dd);
			(0, _shared.appendNode)(time, span_1);
			(0, _shared.appendNode)(text_1, time);
			(0, _shared.appendNode)(text_2, span_1);
			if (if_block) if_block.m(span_1, null);
			(0, _shared.appendNode)(text_3, span_1);
			if (if_block_1) if_block_1.m(span_1, null);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = formatDate(state.data.startDate))) {
				text_1.data = text_1_value;
			}

			if (state.data.endDate && state.data.startDate !== state.data.endDate) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_19(component, state);
					if_block.c();
					if_block.m(span_1, text_3);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (datePast(state.data.endDate) || !state.data.endDate && datePast(state.data.startDate)) {
				if (!if_block_1) {
					if_block_1 = create_if_block_20(component, state);
					if_block_1.c();
					if_block_1.m(span_1, null);
				}
			} else if (if_block_1) {
				if_block_1.u();
				if_block_1.d();
				if_block_1 = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(dt);
			(0, _shared.detachNode)(dd);
			if (if_block) if_block.u();
			if (if_block_1) if_block_1.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_1) if_block_1.d();
		}
	};
}

// (122:12) {{#if data.phone}}
function create_if_block_21(component, state) {
	var dt,
	    span,
	    text,
	    dd,
	    span_1,
	    a,
	    text_1_value = state.data.phone,
	    text_1,
	    a_href_value;

	return {
		c: function create() {
			dt = (0, _shared.createElement)("dt");
			span = (0, _shared.createElement)("span");
			text = (0, _shared.createText)("Phone");
			dd = (0, _shared.createElement)("dd");
			span_1 = (0, _shared.createElement)("span");
			a = (0, _shared.createElement)("a");
			text_1 = (0, _shared.createText)(text_1_value);
			this.h();
		},

		l: function claim(nodes) {
			dt = (0, _shared.claimElement)(nodes, "DT", {}, false);
			var dt_nodes = (0, _shared.children)(dt);

			span = (0, _shared.claimElement)(dt_nodes, "SPAN", {}, false);
			var span_nodes = (0, _shared.children)(span);

			text = (0, _shared.claimText)(span_nodes, "Phone");
			span_nodes.forEach(_shared.detachNode);
			dt_nodes.forEach(_shared.detachNode);

			dd = (0, _shared.claimElement)(nodes, "DD", {}, false);
			var dd_nodes = (0, _shared.children)(dd);

			span_1 = (0, _shared.claimElement)(dd_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			a = (0, _shared.claimElement)(span_1_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text_1 = (0, _shared.claimText)(a_nodes, text_1_value);
			a_nodes.forEach(_shared.detachNode);
			span_1_nodes.forEach(_shared.detachNode);
			dd_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = phoneURL(state.data.phone);
			span_1.className = "linkable phone-link";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(dt, target, anchor);
			(0, _shared.appendNode)(span, dt);
			(0, _shared.appendNode)(text, span);
			(0, _shared.insertNode)(dd, target, anchor);
			(0, _shared.appendNode)(span_1, dd);
			(0, _shared.appendNode)(a, span_1);
			(0, _shared.appendNode)(text_1, a);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = state.data.phone)) {
				text_1.data = text_1_value;
			}

			if (changed.data && a_href_value !== (a_href_value = phoneURL(state.data.phone))) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(dt);
			(0, _shared.detachNode)(dd);
		},

		d: _shared.noop
	};
}

// (129:12) {{#if data.website}}
function create_if_block_22(component, state) {
	var dt,
	    span,
	    text,
	    dd,
	    span_1,
	    a,
	    text_1_value = urlText(state.data.website),
	    text_1,
	    a_href_value;

	return {
		c: function create() {
			dt = (0, _shared.createElement)("dt");
			span = (0, _shared.createElement)("span");
			text = (0, _shared.createText)("Website");
			dd = (0, _shared.createElement)("dd");
			span_1 = (0, _shared.createElement)("span");
			a = (0, _shared.createElement)("a");
			text_1 = (0, _shared.createText)(text_1_value);
			this.h();
		},

		l: function claim(nodes) {
			dt = (0, _shared.claimElement)(nodes, "DT", {}, false);
			var dt_nodes = (0, _shared.children)(dt);

			span = (0, _shared.claimElement)(dt_nodes, "SPAN", {}, false);
			var span_nodes = (0, _shared.children)(span);

			text = (0, _shared.claimText)(span_nodes, "Website");
			span_nodes.forEach(_shared.detachNode);
			dt_nodes.forEach(_shared.detachNode);

			dd = (0, _shared.claimElement)(nodes, "DD", {}, false);
			var dd_nodes = (0, _shared.children)(dd);

			span_1 = (0, _shared.claimElement)(dd_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			a = (0, _shared.claimElement)(span_1_nodes, "A", { href: true, target: true, rel: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text_1 = (0, _shared.claimText)(a_nodes, text_1_value);
			a_nodes.forEach(_shared.detachNode);
			span_1_nodes.forEach(_shared.detachNode);
			dd_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = urlLink(state.data.website);
			a.target = "_blank";
			a.rel = "noopener";
			span_1.className = "linkable";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(dt, target, anchor);
			(0, _shared.appendNode)(span, dt);
			(0, _shared.appendNode)(text, span);
			(0, _shared.insertNode)(dd, target, anchor);
			(0, _shared.appendNode)(span_1, dd);
			(0, _shared.appendNode)(a, span_1);
			(0, _shared.appendNode)(text_1, a);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = urlText(state.data.website))) {
				text_1.data = text_1_value;
			}

			if (changed.data && a_href_value !== (a_href_value = urlLink(state.data.website))) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(dt);
			(0, _shared.detachNode)(dd);
		},

		d: _shared.noop
	};
}

// (107:8) {{#if data.phone || data.website || data.startDate}}
function create_if_block_17(component, state) {
	var dl, if_block_anchor, if_block_1_anchor;

	var if_block = state.data.startDate && create_if_block_18(component, state);

	var if_block_1 = state.data.phone && create_if_block_21(component, state);

	var if_block_2 = state.data.website && create_if_block_22(component, state);

	return {
		c: function create() {
			dl = (0, _shared.createElement)("dl");
			if (if_block) if_block.c();
			if_block_anchor = (0, _shared.createComment)();
			if (if_block_1) if_block_1.c();
			if_block_1_anchor = (0, _shared.createComment)();
			if (if_block_2) if_block_2.c();
		},

		l: function claim(nodes) {
			dl = (0, _shared.claimElement)(nodes, "DL", {}, false);
			var dl_nodes = (0, _shared.children)(dl);

			if (if_block) if_block.l(dl_nodes);
			if_block_anchor = (0, _shared.createComment)();
			if (if_block_1) if_block_1.l(dl_nodes);
			if_block_1_anchor = (0, _shared.createComment)();
			if (if_block_2) if_block_2.l(dl_nodes);
			dl_nodes.forEach(_shared.detachNode);
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(dl, target, anchor);
			if (if_block) if_block.m(dl, null);
			(0, _shared.appendNode)(if_block_anchor, dl);
			if (if_block_1) if_block_1.m(dl, null);
			(0, _shared.appendNode)(if_block_1_anchor, dl);
			if (if_block_2) if_block_2.m(dl, null);
		},

		p: function update(changed, state) {
			if (state.data.startDate) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_18(component, state);
					if_block.c();
					if_block.m(dl, if_block_anchor);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (state.data.phone) {
				if (if_block_1) {
					if_block_1.p(changed, state);
				} else {
					if_block_1 = create_if_block_21(component, state);
					if_block_1.c();
					if_block_1.m(dl, if_block_1_anchor);
				}
			} else if (if_block_1) {
				if_block_1.u();
				if_block_1.d();
				if_block_1 = null;
			}

			if (state.data.website) {
				if (if_block_2) {
					if_block_2.p(changed, state);
				} else {
					if_block_2 = create_if_block_22(component, state);
					if_block_2.c();
					if_block_2.m(dl, null);
				}
			} else if (if_block_2) {
				if_block_2.u();
				if_block_2.d();
				if_block_2 = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(dl);
			if (if_block) if_block.u();
			if (if_block_1) if_block_1.u();
			if (if_block_2) if_block_2.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_1) if_block_1.d();
			if (if_block_2) if_block_2.d();
		}
	};
}

// (156:12) {{#each data.lists as l @id}}
function create_each_block(component, key_1, state) {
	var l = state.l,
	    each_value = state.each_value,
	    l_index = state.l_index;
	var a,
	    text_value = l.title,
	    text,
	    a_href_value;

	return {
		key: key_1,

		first: null,

		c: function create() {
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)(text_value);
			this.h();
		},

		l: function claim(nodes) {
			a = (0, _shared.claimElement)(nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, text_value);
			a_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + l.filename;
			this.first = a;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(a, target, anchor);
			(0, _shared.appendNode)(text, a);
		},

		p: function update(changed, state) {
			l = state.l;
			each_value = state.each_value;
			l_index = state.l_index;
			if (changed.data && text_value !== (text_value = l.title)) {
				text.data = text_value;
			}

			if (changed.data && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + l.filename)) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(a);
		},

		d: _shared.noop
	};
}

// (153:8) {{#if display !== 'list' && data.lists}}
function create_if_block_23(component, state) {
	var div,
	    h3,
	    text,
	    text_1,
	    each_blocks_1 = [],
	    each_lookup = (0, _shared.blankObject)();

	var each_value = state.data.lists;

	for (var i = 0; i < each_value.length; i += 1) {
		var key = each_value[i].id;
		each_blocks_1[i] = each_lookup[key] = create_each_block(component, key, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value: each_value,
			l: each_value[i],
			l_index: i
		}));
	}

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			h3 = (0, _shared.createElement)("h3");
			text = (0, _shared.createText)("Featured in");
			text_1 = (0, _shared.createText)("\n            ");

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			h3 = (0, _shared.claimElement)(div_nodes, "H3", {}, false);
			var h3_nodes = (0, _shared.children)(h3);

			text = (0, _shared.claimText)(h3_nodes, "Featured in");
			h3_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(div_nodes, "\n            ");

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(div_nodes);
			}div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "related";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(h3, div);
			(0, _shared.appendNode)(text, h3);
			(0, _shared.appendNode)(text_1, div);

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div, null);
			}
		},

		p: function update(changed, state) {
			var each_value = state.data.lists;

			each_blocks_1 = (0, _shared.updateKeyedEach)(each_blocks_1, component, changed, "id", 1, each_value, each_lookup, div, false, create_each_block, "m", null, function (i) {
				return (0, _shared.assign)((0, _shared.assign)({}, state), {
					each_value: each_value,
					l: each_value[i],
					l_index: i
				});
			});
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: function destroy() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}
		}
	};
}

// (106:6) {{#if display !== 'map'}}
function create_if_block_16(component, state) {
	var text, div, a, span, text_1, a_href_value, text_3, a_1, span_1, text_4, a_1_href_value, text_6, a_2, span_2, text_7, a_2_href_value, text_9, a_3, span_3, text_10, a_3_href_value, text_13, if_block_1_anchor;

	var if_block = (state.data.phone || state.data.website || state.data.startDate) && create_if_block_17(component, state);

	var if_block_1 = state.display !== 'list' && state.data.lists && create_if_block_23(component, state);

	return {
		c: function create() {
			if (if_block) if_block.c();
			text = (0, _shared.createText)("\n\n        ");
			div = (0, _shared.createElement)("div");
			a = (0, _shared.createElement)("a");
			span = (0, _shared.createElement)("span");
			text_1 = (0, _shared.createText)("Share on Facebook");
			text_3 = (0, _shared.createText)("\n          ");
			a_1 = (0, _shared.createElement)("a");
			span_1 = (0, _shared.createElement)("span");
			text_4 = (0, _shared.createText)("Share on Twitter");
			text_6 = (0, _shared.createText)("\n          ");
			a_2 = (0, _shared.createElement)("a");
			span_2 = (0, _shared.createElement)("span");
			text_7 = (0, _shared.createText)("Share via email");
			text_9 = (0, _shared.createText)("\n          ");
			a_3 = (0, _shared.createElement)("a");
			span_3 = (0, _shared.createElement)("span");
			text_10 = (0, _shared.createText)("Share via SMS");
			text_13 = (0, _shared.createText)("\n\n        ");
			if (if_block_1) if_block_1.c();
			if_block_1_anchor = (0, _shared.createComment)();
			this.h();
		},

		l: function claim(nodes) {
			if (if_block) if_block.l(nodes);
			text = (0, _shared.claimText)(nodes, "\n\n        ");

			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			a = (0, _shared.claimElement)(div_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			span = (0, _shared.claimElement)(a_nodes, "SPAN", { class: true }, false);
			var span_nodes = (0, _shared.children)(span);

			text_1 = (0, _shared.claimText)(span_nodes, "Share on Facebook");
			span_nodes.forEach(_shared.detachNode);
			a_nodes.forEach(_shared.detachNode);
			text_3 = (0, _shared.claimText)(div_nodes, "\n          ");

			a_1 = (0, _shared.claimElement)(div_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			span_1 = (0, _shared.claimElement)(a_1_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			text_4 = (0, _shared.claimText)(span_1_nodes, "Share on Twitter");
			span_1_nodes.forEach(_shared.detachNode);
			a_1_nodes.forEach(_shared.detachNode);
			text_6 = (0, _shared.claimText)(div_nodes, "\n          ");

			a_2 = (0, _shared.claimElement)(div_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_2_nodes = (0, _shared.children)(a_2);

			span_2 = (0, _shared.claimElement)(a_2_nodes, "SPAN", { class: true }, false);
			var span_2_nodes = (0, _shared.children)(span_2);

			text_7 = (0, _shared.claimText)(span_2_nodes, "Share via email");
			span_2_nodes.forEach(_shared.detachNode);
			a_2_nodes.forEach(_shared.detachNode);
			text_9 = (0, _shared.claimText)(div_nodes, "\n          ");

			a_3 = (0, _shared.claimElement)(div_nodes, "A", { href: true, class: true, rel: true }, false);
			var a_3_nodes = (0, _shared.children)(a_3);

			span_3 = (0, _shared.claimElement)(a_3_nodes, "SPAN", { class: true }, false);
			var span_3_nodes = (0, _shared.children)(span_3);

			text_10 = (0, _shared.claimText)(span_3_nodes, "Share via SMS");
			span_3_nodes.forEach(_shared.detachNode);
			a_3_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			text_13 = (0, _shared.claimText)(nodes, "\n\n        ");
			if (if_block_1) if_block_1.l(nodes);
			if_block_1_anchor = (0, _shared.createComment)();
			this.h();
		},

		h: function hydrate() {
			span.className = "sr-only";
			a.href = a_href_value = facebookURL(state.data, state.content);
			a.target = "_blank";
			a.rel = "noopener";
			a.className = "facebook-button";
			span_1.className = "sr-only";
			a_1.href = a_1_href_value = twitterURL(state.data, state.content);
			a_1.target = "_blank";
			a_1.rel = "noopener";
			a_1.className = "twitter-button";
			span_2.className = "sr-only";
			a_2.href = a_2_href_value = emailURL(state.data, state.content);
			a_2.target = "_blank";
			a_2.rel = "noopener";
			a_2.className = "email-button";
			span_3.className = "sr-only";
			a_3.href = a_3_href_value = smsURL(state.data, state.content);
			a_3.className = "sms-button";
			a_3.rel = "noopener";
			div.className = "social-buttons social-buttons-gray";
		},

		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0, _shared.insertNode)(text, target, anchor);
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(a, div);
			(0, _shared.appendNode)(span, a);
			(0, _shared.appendNode)(text_1, span);
			(0, _shared.appendNode)(text_3, div);
			(0, _shared.appendNode)(a_1, div);
			(0, _shared.appendNode)(span_1, a_1);
			(0, _shared.appendNode)(text_4, span_1);
			(0, _shared.appendNode)(text_6, div);
			(0, _shared.appendNode)(a_2, div);
			(0, _shared.appendNode)(span_2, a_2);
			(0, _shared.appendNode)(text_7, span_2);
			(0, _shared.appendNode)(text_9, div);
			(0, _shared.appendNode)(a_3, div);
			(0, _shared.appendNode)(span_3, a_3);
			(0, _shared.appendNode)(text_10, span_3);
			(0, _shared.insertNode)(text_13, target, anchor);
			if (if_block_1) if_block_1.m(target, anchor);
			(0, _shared.insertNode)(if_block_1_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (state.data.phone || state.data.website || state.data.startDate) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_17(component, state);
					if_block.c();
					if_block.m(text.parentNode, text);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if ((changed.data || changed.content) && a_href_value !== (a_href_value = facebookURL(state.data, state.content))) {
				a.href = a_href_value;
			}

			if ((changed.data || changed.content) && a_1_href_value !== (a_1_href_value = twitterURL(state.data, state.content))) {
				a_1.href = a_1_href_value;
			}

			if ((changed.data || changed.content) && a_2_href_value !== (a_2_href_value = emailURL(state.data, state.content))) {
				a_2.href = a_2_href_value;
			}

			if ((changed.data || changed.content) && a_3_href_value !== (a_3_href_value = smsURL(state.data, state.content))) {
				a_3.href = a_3_href_value;
			}

			if (state.display !== 'list' && state.data.lists) {
				if (if_block_1) {
					if_block_1.p(changed, state);
				} else {
					if_block_1 = create_if_block_23(component, state);
					if_block_1.c();
					if_block_1.m(if_block_1_anchor.parentNode, if_block_1_anchor);
				}
			} else if (if_block_1) {
				if_block_1.u();
				if_block_1.d();
				if_block_1 = null;
			}
		},

		u: function unmount() {
			if (if_block) if_block.u();
			(0, _shared.detachNode)(text);
			(0, _shared.detachNode)(div);
			(0, _shared.detachNode)(text_13);
			if (if_block_1) if_block_1.u();
			(0, _shared.detachNode)(if_block_1_anchor);
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_1) if_block_1.d();
		}
	};
}

// (164:8) {{#if data.ad}}
function create_if_block_25(component, state) {

	var ad_initial_data = { ad: state.data.ad };
	var ad = new _ad2.default({
		root: component.root,
		data: ad_initial_data
	});

	return {
		c: function create() {
			ad._fragment.c();
		},

		l: function claim(nodes) {
			ad._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			ad._mount(target, anchor);
		},

		p: function update(changed, state) {
			var ad_changes = {};
			if (changed.data) ad_changes.ad = state.data.ad;
			ad._set(ad_changes);
		},

		u: function unmount() {
			ad._unmount();
		},

		d: function destroy() {
			ad.destroy(false);
		}
	};
}

// (163:6) {{#if display === 'full'}}
function create_if_block_24(component, state) {
	var if_block_anchor;

	var if_block = state.data.ad && create_if_block_25(component, state);

	return {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (state.data.ad) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_25(component, state);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}
		},

		u: function unmount() {
			if (if_block) if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if (if_block) if_block.d();
		}
	};
}

function Items(options) {
	(0, _shared.init)(this, options);
	this._state = (0, _shared.assign)((0, _shared.assign)(this.store._init(["isBrowser", "offline"]), data()), options.data);
	this.store._add(this, ["isBrowser", "offline"]);
	this._recompute({ data: 1 }, this._state);

	this._handlers.destroy = [_shared.removeFromStore];

	var self = this;
	var _oncreate = function _oncreate() {
		var changed = { data: 1, display: 1, $isBrowser: 1, $offline: 1, sectionGroup: 1, utils: 1, store: 1, content: 1 };
		oncreate.call(self);
		self.fire("update", { changed: changed, current: self._state });
	};

	if (!options.root) {
		this._oncreate = [];
		this._beforecreate = [];
		this._aftercreate = [];
	}

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(_oncreate);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);

		this._lock = true;
		(0, _shared.callAll)(this._beforecreate);
		(0, _shared.callAll)(this._oncreate);
		(0, _shared.callAll)(this._aftercreate);
		this._lock = false;
	}
}

(0, _shared.assign)(Items.prototype, _shared.proto);
(0, _shared.assign)(Items.prototype, methods_1);

Items.prototype._recompute = function _recompute(changed, state) {
	if (changed.data) {
		if (this._differs(state.sectionGroup, state.sectionGroup = sectionGroup(state.data))) changed.sectionGroup = true;
	}
};
exports.default = Items;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/ad.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

function data() {
	return {
		isBrowser: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined
	};
};

function oncreate() {
	var _this = this;

	this.observe('ad', function (n) {
		if (!_this.__servedAd && n && _this.get('isBrowser') && window && window.googletag) {
			window.googletag.cmd.push(function () {
				window.googletag.display(n.id);
			});
			_this.__servedAd = true;
		}
	}, { defer: true });
};

function create_main_fragment(component, state) {
	var if_block_anchor;

	var if_block = state.ad && state.ad.id && create_if_block(component, state);

	return {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (state.ad && state.ad.id) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block(component, state);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}
		},

		u: function unmount() {
			if (if_block) if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if (if_block) if_block.d();
		}
	};
}

// (1:0) {{#if ad && ad.id}}
function create_if_block(component, state) {
	var div, div_1, div_1_id_value;

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			div_1 = (0, _shared.createElement)("div");
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			div_1 = (0, _shared.claimElement)(div_nodes, "DIV", { id: true, class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			div_1_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div_1.id = div_1_id_value = state.ad.id;
			div_1.className = "ad-content";
			div.className = "ad";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(div_1, div);
		},

		p: function update(changed, state) {
			if (changed.ad && div_1_id_value !== (div_1_id_value = state.ad.id)) {
				div_1.id = div_1_id_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: _shared.noop
	};
}

function Ad(options) {
	(0, _shared.init)(this, options);
	this._state = (0, _shared.assign)(data(), options.data);

	var self = this;
	var _oncreate = function _oncreate() {
		var changed = { ad: 1 };
		oncreate.call(self);
		self.fire("update", { changed: changed, current: self._state });
	};

	if (!options.root) {
		this._oncreate = [];
	}

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(_oncreate);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);

		(0, _shared.callAll)(this._oncreate);
	}
}

(0, _shared.assign)(Ad.prototype, _shared.proto);
exports.default = Ad;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Handle interaction observing, specifically, given a list of items,
 * finding the top one
 */

/* global window, document, _ */


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Observer = function () {
  function Observer() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Observer);

    // ACtually throttling is bad because we can miss when something gets
    // to a relevant place
    options.throttle = options.throttle === false || options.throttle ? options.throttle : 150;
    options.attribute = options.attribute || 'data-id';
    options.visibleThreshold = options.visibleThreshold || 0.85;
    options.onObserve = options.onObserve || function () {};
    options.root = options.root || document.querySelector('document');
    options.forceItem = options.forceItem === false || options.forceItem ? options.forceItem : false;
    this.options = options;

    // Don't do anything if not in browser
    if (!window || !window.IntersectionObserver) {
      return;
    }

    // Initalize entries
    this.entries = [];

    // Make observer
    this.observer = new IntersectionObserver(this.options.throttle ? _.throttle(_.bind(this.onObserve, this), this.options.throttle) : _.bind(this.onObserve, this), {
      root: _.isElement(this.options.root) ? this.options.root : document.querySelector(this.options.root),
      threshold: this.options.threshold || _.map(_.range(0, 21), function (i) {
        return i * 5 / 100;
      })
    });

    // Add elements
    if (this.options.elements) {
      this.addElements(this.options.elements);
    }
  }

  _createClass(Observer, [{
    key: 'addElements',
    value: function addElements(elements) {
      var _this = this;

      if (_.isArrayLike(elements)) {
        if (_.isArrayLike(this.options.elements)) {
          this.options.elements = _.map(this.options.elements);
          this.options.elements.concat(elements);
        } else {
          this.options.elements = elements;
        }

        // NodeList iteration is not widely supported
        // https://css-tricks.com/snippets/javascript/loop-queryselectorall-matches/
        [].forEach.call(elements, function (e) {
          _this.observer.observe(e);
        });
      } else if (_.isElement(elements)) {
        if (_.isArrayLike(this.options.elements)) {
          this.options.elements.push(elements);
        } else {
          this.options.elements = [elements];
        }

        this.observer.observe(elements);
      }
    }
  }, {
    key: 'onObserve',
    value: function onObserve(entries) {
      // We only want to highlight one element at a time, so
      // order by the top and which one is most in view.  We need
      // to keep track of entries.
      entries = this.combinedEntries(entries);
      var sorted = _.orderBy(entries, ['roundedRatio', function (e) {
        return e.boundingRect.top;
      }], ['desc', 'asc']);
      if (sorted[0].intersectionRatio >= this.options.visibleThreshold || this.options.forceItem) {
        sorted[0].inView = true;
      }

      this.options.onObserve(sorted[0].inView ? sorted[0].target.getAttribute(this.options.attribute) : undefined, sorted[0].inView ? sorted[0] : undefined, sorted);
    }
  }, {
    key: 'combinedEntries',
    value: function combinedEntries(newEntries) {
      var _this2 = this;

      this.entries = this.entries || [];

      // Find existing
      _.each(newEntries, function (n) {
        var existing = _.findIndex(_this2.entries, function (e) {
          return n.target === e.target;
        });

        if (~existing) {
          _this2.entries[existing] = n;
        } else {
          _this2.entries.push(n);
        }
      });

      // Update positions
      this.entries = _.map(this.entries, function (e) {
        // We care about where on the page it is and need to standardize
        e.boundingRect = e.target.getBoundingClientRect();
        e.roundedRatio = Math.min(1, Math.round(e.intersectionRatio * 100) / 100);
        return e;
      });

      return _.map(this.entries);
    }

    // Stop (disconnect) all items

  }, {
    key: 'stop',
    value: function stop() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }]);

  return Observer;
}();

// Export a generator for the class.


module.exports = function (options) {
  return new Observer(options);
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Google map styles
 */

var mapStyles = [{
  elementType: 'geometry',
  stylers: [{
    color: '#f5f5f5'
  }]
}, {
  elementType: 'labels.icon',
  stylers: [{
    visibility: 'off'
  }]
}, {
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#616161'
  }]
}, {
  elementType: 'labels.text.stroke',
  stylers: [{
    color: '#f5f5f5'
  }]
}, {
  featureType: 'administrative.land_parcel',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#bdbdbd'
  }]
}, {
  featureType: 'poi',
  elementType: 'geometry',
  stylers: [{
    color: '#eeeeee'
  }]
}, {
  featureType: 'poi',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#757575'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'geometry',
  stylers: [{
    color: '#e5e5e5'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#d9e8d9'
  }]
}, {
  featureType: 'poi.park',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#9e9e9e'
  }]
}, {
  featureType: 'road',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }]
}, {
  featureType: 'road.arterial',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#757575'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'geometry',
  stylers: [{
    color: '#ffffff'
  }]
}, {
  featureType: 'road.highway',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#616161'
  }]
}, {
  featureType: 'road.local',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#9e9e9e'
  }]
}, {
  featureType: 'transit.line',
  elementType: 'geometry',
  stylers: [{
    color: '#e5e5e5'
  }]
}, {
  featureType: 'transit.station',
  elementType: 'geometry',
  stylers: [{
    color: '#eeeeee'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry',
  stylers: [{
    color: '#c9c9c9'
  }]
}, {
  featureType: 'water',
  elementType: 'geometry.fill',
  stylers: [{
    color: '#cae2e9'
  }]
}, {
  featureType: 'water',
  elementType: 'labels.text.fill',
  stylers: [{
    color: '#9e9e9e'
  }]
}];

module.exports = mapStyles;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/map.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _mapStyles = __webpack_require__(6);

var _mapStyles2 = _interopRequireDefault(_mapStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function data() {
  return {
    isBrowser: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined,
    locations: [],
    markers: {},
    bounds: undefined,
    map: undefined,
    center: {
      lat: 44.9629232,
      lng: -93.159196
    },
    zoom: 11,
    focusZoom: 15,
    focusUserPosition: true,
    zindex: 10
  };
};

var methods = {
  // Draw map
  drawMap: function drawMap() {
    var map = this.get("map");

    // Only draw map if needed
    if (!map) {
      map = new window.google.maps.Map(this.refs.map, {
        zoom: this.get("zoom"),
        center: this.get("center"),
        minZoom: 9,
        maxZoom: 17,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: _mapStyles2.default
      });

      // Add map to component
      this.set({ map: map });
    } else {
      // If the map is already there for some reason, just
      // trigger a resize
      window.google.maps.event.trigger(map, "resize");
    }
  },

  // Undraw map
  undrawMap: function undrawMap() {
    var map = this.get("map");
    var markers = this.get("markers");
    if (!map) {
      return;
    }

    // Remove markers
    if (markers && _.size(markers)) {
      _.each(markers, function (m) {
        m.setMap(null);
      });
    }

    // Remove events from map
    if (map) {
      google.maps.event.clearInstanceListeners(map);
      google.maps.event.clearListeners(map);
    }
  },

  // Add markers
  addMarkers: function addMarkers() {
    var _this = this;

    var markers = this.get("markers");
    var locations = this.get("locations");
    var map = this.get("map");

    // Go through locations
    locations.forEach(function (l) {
      if (!markers[l.id]) {
        _this.addMarker(l);
      }
    });

    // Update map view
    map.fitBounds(this.get("bounds"), this.boundsPadding());
  },

  // Add a marker
  addMarker: function addMarker(location) {
    var _this2 = this;

    var markers = this.get("markers");
    var bounds = this.get("bounds");

    // Don't add without a position
    if (!location.lat || !location.lng) {
      return;
    }

    var p = {
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lng)
    };

    var infowindow = new window.google.maps.InfoWindow({
      content: location.content
      // maxWidth: 200
    });

    // Make marker
    var marker = new window.google.maps.Marker({
      position: p,
      title: location.content,
      icon: this.mapIcon(),
      zIndex: this.getAndAddZIndex()
    });

    // Click event
    marker.addListener("click", function () {
      if (_this2.root && _this2.root.goTo) {
        _this2.root.goTo(location.id, _this2.get("itemContainer"), {
          over: { top: parseFloat(_this2.get("goToOffset")) || -0.2 }
        });
      } else {
        infowindow.open(_this2.get("map"), marker);
      }
    });

    // Add to map
    marker.setMap(this.get("map"));

    // Update bounds
    if (!bounds) {
      bounds = new google.maps.LatLngBounds();
    }
    bounds.extend(p);

    // Add to collection
    markers = markers || {};
    markers[location.id] = marker;
    this.set({ markers: markers, bounds: bounds });
  },

  // Make map icon
  mapIcon: function mapIcon() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "inactive";

    var activeColor = "#FF9900";
    var inActiveColor = "#B3B3B3";
    var mobileSize = 0.65;
    var desktopSize = 0.9;
    var activeScale = 1;
    var inActiveScale = 0.75;
    var mobileish = this.isMobileIsh();

    return {
      path: "M22.9,0C10.2,0,0,10.2,0,22.9c0,12.7,22.9,43.8,22.9,43.8s22.9-31,22.9-43.8C45.8,10.2,35.6,0,22.9,0z M22.9,33.3c-5.8,0-10.4-4.6-10.4-10.4c0-5.8,4.6-10.4,10.4-10.4c5.8,0,10.4,4.6,10.4,10.4C33.3,28.7,28.8,33.3,22.9,33.3z",
      scale: (mobileish ? mobileSize : desktopSize) * (state === "active" ? activeScale : state === "inactive" ? inActiveScale : inActiveScale),
      anchor: new google.maps.Point(45.8 / 2, 66.7),
      fillColor: state === "active" ? activeColor : state === "inactive" ? inActiveColor : inActiveColor,
      fillOpacity: 0.95,
      strokeWeight: 0
    };
  },

  // Person icon for user location
  userLocationIcon: function userLocationIcon() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#222222";

    var mobileish = this.isMobileIsh();
    var mobileSize = 0.55;
    var desktopSize = 0.4;

    return {
      path: "M24.7,17.4L24.7,17.4h-5.3c3-1.5,5.1-4.6,5.1-8.2c0-5.1-4.1-9.2-9.2-9.2S6.1,4.1,6.1,9.2c0,3.6,2.1,6.7,5.1,8.2H5.9 c-3.3,0-5.9,2.7-5.9,5.9v21.4c0,3.3,2.7,5.9,5.9,5.9h1.3v31.2c0,2.5,2,4.6,4.6,4.6h6.9c2.5,0,4.6-2,4.6-4.6V50.6h1.4 c3.3,0,5.9-2.7,5.9-5.9V23.3C30.6,20,27.9,17.4,24.7,17.4z",
      scale: mobileish ? mobileSize : desktopSize,
      anchor: new google.maps.Point(30.6 / 2, 86.4),
      fillColor: color,
      fillOpacity: 0.95,
      strokeWeight: 0
    };
  },

  // Handle user position
  updateUserPosition: function updateUserPosition() {
    var location = this.store ? this.store.get("location") : undefined;
    var positionMarker = this.get("positionMarker");
    if (!location || !location.lat || !location.lng) {
      return;
    }

    // Make marker if needed
    if (!positionMarker) {
      // Make marker
      positionMarker = new window.google.maps.Marker({
        position: location,
        title: "Your location",
        icon: this.userLocationIcon(),
        zIndex: this.getAndAddZIndex()
      });

      // Add to map
      positionMarker.setMap(this.get("map"));

      // Add to collection
      this.set({ positionMarker: positionMarker });
    } else {
      positionMarker.setPosition(location);
    }
  },

  // Center on locations
  focusLocations: function focusLocations(focus) {
    var _this3 = this;

    focus = _.isString(focus) ? [focus] : _.isArray(focus) ? focus : [];
    var userPosition = this.store && this.store.get("location") && this.store.get("location").lat ? this.store.get("location") : undefined;
    var map = this.get("map");
    var locations = this.get("locations");
    var markers = this.get("markers");
    var includeUser = this.get("focusUserPosition");

    // Translate to locations
    focus = _.filter(_.map(focus, function (f) {
      var l = _.find(locations, { id: f });
      if (l && markers[l.id]) {
        l.marker = markers[l.id];
      }

      return l.lat && l.lng ? l : undefined;
    }));

    // Go through all markers
    var bounds = new google.maps.LatLngBounds();
    _.each(locations, function (l) {
      if (_.find(focus, { id: l.id })) {
        markers[l.id].setIcon(_this3.mapIcon("active"));
        markers[l.id].setZIndex(_this3.getAndAddZIndex());
        bounds.extend({ lat: l.lat, lng: l.lng });
      } else if (markers[l.id]) {
        markers[l.id].setIcon(_this3.mapIcon());
      }
    });

    // If non focused, then focus to original bounds
    if ((!focus || !focus.length) && this.get("bounds")) {
      map.fitBounds(this.get("bounds"), this.boundsPadding());

      // Issue where markers disspear
      map.panTo(map.getCenter());
      return;
    }

    // Look for user location
    if (userPosition && includeUser) {
      bounds.extend(userPosition, 10);
    }

    // If just one
    if (focus.length === 1 && (!includeUser || includeUser && !userPosition)) {
      map.setCenter({ lat: focus[0].lat, lng: focus[0].lng });
      map.setZoom(this.get("focusZoom"));
      // Issue where markers disspear
      map.panTo(map.getCenter());
    } else {
      // Set bounds
      map.fitBounds(bounds, this.boundsPadding());
      // Issue where markers disspear
      map.panTo(map.getCenter());
    }
  },

  // A simple, hackish way to determine view.  Assumes mobile.
  isMobileIsh: function isMobileIsh() {
    var widthTest = 600;
    var map = this.get("map");
    return map && _.isFunction(map.getDiv) && _.isObject(map.getDiv()) && map.getDiv().offsetWidth && map.getDiv().offsetWidth > widthTest ? false : true;
  },

  // Get padding for get bounds
  boundsPadding: function boundsPadding() {
    return this.isMobileIsh() ? 10 : 100;
  },

  // Get and set zindex
  getAndAddZIndex: function getAndAddZIndex() {
    var z = this.get("zindex") + 1;
    this.set({ zindex: z });
    return z;
  }
};

function oncreate() {
  var _this4 = this;

  // Ref
  if (this.get("isBrowser")) {
    this.drawMap();
  }

  // When locations are available add markers
  this.observe("locations", function (n, o) {
    // For some reason this is getting called too often, so
    // we do a bit of hackery to check if the number of items has
    // changed.
    if (_this4.get("isBrowser") && n && (n && o && n.length !== o.length || !o)) {
      _this4.addMarkers();
    }
  }, { defer: true });

  // Watch store for user location
  if (this.store) {
    this.store.observe("location", function (n) {
      if (n && n.lat && n.lng && _this4.store.get("isBrowser")) {
        _this4.updateUserPosition();
      }
    });
  }

  // Watch for locations in view (which should be an array of IDs)
  this.observe("inView", function (n) {
    if (n && _this4.get("isBrowser")) {
      _this4.focusLocations(n);
    }
  });
};

function ondestroy() {
  this.undrawMap();
};

function create_main_fragment(component, state) {
  var div;

  return {
    c: function create() {
      div = (0, _shared.createElement)("div");
      this.h();
    },

    l: function claim(nodes) {
      div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
      var div_nodes = (0, _shared.children)(div);

      div_nodes.forEach(_shared.detachNode);
      this.h();
    },

    h: function hydrate() {
      div.className = "map-container";
    },

    m: function mount(target, anchor) {
      (0, _shared.insertNode)(div, target, anchor);
      component.refs.map = div;
    },

    p: _shared.noop,

    u: function unmount() {
      (0, _shared.detachNode)(div);
    },

    d: function destroy() {
      if (component.refs.map === div) component.refs.map = null;
    }
  };
}

function Map(options) {
  (0, _shared.init)(this, options);
  this.refs = {};
  this._state = (0, _shared.assign)(data(), options.data);

  this._handlers.destroy = [ondestroy];

  var self = this;
  var _oncreate = function _oncreate() {
    var changed = {};
    oncreate.call(self);
    self.fire("update", { changed: changed, current: self._state });
  };

  if (!options.root) {
    this._oncreate = [];
  }

  this._fragment = create_main_fragment(this, this._state);

  this.root._oncreate.push(_oncreate);

  if (options.target) {
    var nodes = (0, _shared.children)(options.target);
    options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
    nodes.forEach(_shared.detachNode);
    this._mount(options.target, options.anchor);

    (0, _shared.callAll)(this._oncreate);
  }
}

(0, _shared.assign)(Map.prototype, _shared.proto);
(0, _shared.assign)(Map.prototype, methods);
exports.default = Map;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(9);
module.exports = __webpack_require__(10);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Main JS file for project.
 */

// Define globals
/* global $ */


// Dependencies

var _utils = __webpack_require__(11);

var _utils2 = _interopRequireDefault(_utils);

var _iosHomescreen = __webpack_require__(15);

var _iosHomescreen2 = _interopRequireDefault(_iosHomescreen);

var _store = __webpack_require__(16);

var _store2 = _interopRequireDefault(_store);

var _header = __webpack_require__(18);

var _header2 = _interopRequireDefault(_header);

var _groups = __webpack_require__(19);

var _groups2 = _interopRequireDefault(_groups);

var _index = __webpack_require__(20);

var _index2 = _interopRequireDefault(_index);

var _lists = __webpack_require__(21);

var _lists2 = _interopRequireDefault(_lists);

var _items = __webpack_require__(3);

var _items2 = _interopRequireDefault(_items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  Header: _header2.default,
  Groups: _groups2.default,
  Index: _index2.default,
  Lists: _lists2.default,
  Items: _items2.default
};

// Setup utils function


// Since we can't do dynamic imports
var utils = (0, _utils2.default)({
  useView: false
});

// Attach to store
_store2.default.set({ utils: utils });

// Create components.  Get page data.
var dataFile = $('body').attr('data-page-data');
if (dataFile) {
  window.fetch(dataFile).then(function (response) {
    return response.json();
  }).then(function (data) {
    // Make components
    $('[data-component]').each(function (e, el) {
      var c = $(el).attr('data-component');
      new components[c]({
        hydrated: true,
        target: el,
        data: {
          data: data,
          content: window.__startribune ? window.__startribune.contentSettings : {},
          groups: window.__startribune ? window.__startribune.groups : {},
          utils: utils
        },
        store: _store2.default
      });
    });

    // Handle ios homescreen, only when same referrer, or been on the site
    // a few times
    var visits = _store2.default.get('visits') ? _store2.default.get('visits').count : 0;
    if (data && data.dataset && data.dataset === 'index' && (_store2.default.get('sameReferrer') || visits > 3)) {
      (0, _iosHomescreen2.default)(utils);
    }
  }).catch(console.error);
}

// Some general handling of spacing for fixed items
function adjustFixedElements() {
  var $header = $('.project-header');
  var $mNav = $('.minor-navigation');

  // Header
  $('.has-header').each(function (i, el) {
    $(el).css('padding-top', $header.outerHeight());
  });
  $('.adjust-header').each(function (i, el) {
    $(el).css('top', $header.outerHeight());
  });

  // Minor nav
  $('.has-minor-navigation').each(function (i, el) {
    $(el).css('padding-top', $mNav.outerHeight());
  });
}
$(document).ready(adjustFixedElements);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Utility functions.
 */

/* global window, document, pym, _, $ */


// Dependencies

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _queryString = __webpack_require__(12);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Util class
var Util = function () {
  /**
   * Constructor
   * @param  {object} options Object with the following keys:
   *                          - pym: Enable pym.js, defaults to true
   *                          - views: Object describing views
   *                          - useView: Boolean whether to show view, defaults
   *                            to true.
   * @return {undefined}
   */
  function Util(options) {
    _classCallCheck(this, Util);

    this.options = options || {};

    // Defaults
    this.options.pym = this.options.pym === undefined ? true : this.options.pym;
    this.options.runChecks = this.options.runChecks === undefined ? true : this.options.runChecks;
    this.options.useView = this.options.useView === undefined ? true : this.options.useView;
    this.options.views = this.options.views || {
      develop: /localhost.*|127\.0\.0\.1.*/i,
      staging: /staging/i
    };

    // Read in query params
    this.parseQuery();

    // Set the view
    this.setView();

    // Enable pym
    if (this.options.pym) {
      this.pym = !_.isUndefined(window.pym) ? new pym.Child({ polling: 500 }) : undefined;
    }

    // Run checks
    if (this.options.runChecks) {
      this.checkGeolocate();
      this.checkLocalStorage();
    }

    // Polyfill object-fit if available
    if (window.objectFitImages) {
      window.objectFitImages();
    }

    // Attach for ease of use
    this.queryString = _queryString2.default;

    // Do this up front since it can be an async test
    this.checkGeolocate();
  }

  // Set view (make note)


  _createClass(Util, [{
    key: 'setView',
    value: function setView() {
      if (this.options.useView) {
        var view = void 0;
        _.find(this.options.views, function (match, v) {
          view = v;
          return window.location.href.match(match) ? v : undefined;
        });

        if (view) {
          var div = document.createElement('div');
          var body = document.getElementsByTagName('body')[0];
          div.className = 'site-view site-view-' + view;
          body.insertBefore(div, body.childNodes[0]);
        }
      }
    }

    // Get query params and adjust as needed

  }, {
    key: 'parseQuery',
    value: function parseQuery() {
      this.query = _queryString2.default.parse(document.location.search);

      // Adjust options
      if (this.query.pym && this.query.pym === 'true') {
        this.options.pym = true;
      }
    }

    // Super basic deep clone

  }, {
    key: 'deepClone',
    value: function deepClone(data) {
      return JSON.parse(JSON.stringify(data));
    }

    // Simple check to see if embedded in iframe

  }, {
    key: 'isEmbedded',
    value: function isEmbedded() {
      if (!_.isUndefined(this.embedded)) {
        return this.embedded;
      }

      try {
        this.embedded = window.self !== window.top;
      } catch (e) {
        this.embedded = true;
      }

      return this.embedded;
    }

    // Check for local storage

  }, {
    key: 'checkLocalStorage',
    value: function checkLocalStorage() {
      if (!_.isUndefined(this.hasLocalStorage)) {
        return this.hasLocalStorage;
      }

      try {
        window.localStorage.setItem('test', 'test');
        window.localStorage.removeItem('test');
        this.hasLocalStorage = true;
      } catch (e) {
        this.hasLocalStorage = false;
      }

      return this.hasLocalStorage;
    }

    // Check for geolocation

  }, {
    key: 'checkGeolocate',
    value: function checkGeolocate() {
      if (_.isUndefined(this.hasGeolocate)) {
        this.hasGeolocate = window.navigator && 'geolocation' in window.navigator;
        // Unfortunately HTTPS is needed, but in some browsers,
        // the API is still available.  We could run the API, but then the user
        // gets a dialog.  :(
      }

      return this.hasGeolocate;
    }

    // Basic geolocation function

  }, {
    key: 'geolocate',
    value: function geolocate(done) {
      var _this = this;

      var watch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.checkGeolocate()) {
        // iphone acts weird sometimes about this.  This is some hacky way
        // to ensure it works ok, but who knows.
        // https://stackoverflow.com/questions/3397585/navigator-geolocation-getcurrentposition-sometimes-works-sometimes-doesnt
        window.navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});

        this.geolocateWatchID = window.navigator.geolocation[watch ? 'watchPosition' : 'getCurrentPosition'](function (position) {
          done(null, {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        }, function (error) {
          _this.hasGeolocate = false;
          done(error ? error : 'Unable to find your position.');
        }, { maximumAge: 5000, timeout: 50000, enableHighAccuracy: true });
      } else {
        done('Geolocation not available');
      }
    }

    // Stop geolocation

  }, {
    key: 'stopGeolocate',
    value: function stopGeolocate() {
      if (this.geolocateWatchID && this.checkGeolocate()) {
        window.navigator.geolocation.clearWatch(this.geolocateWatchID);
      }
    }

    // Scroll to id
    // Note scrollIntoView is a native API but it is
    // not widely supported and not good polyfills exists,
    // specifically ones that can offset.

  }, {
    key: 'goTo',
    value: function goTo(id, parent) {
      var scrollToOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var el = _.isElement(id) ? id : id[0] && _.isElement(id[0]) ? id[0] : document.getElementById(id);
      var $parent = _.isUndefined(parent) ? $(window) : $(parent);
      scrollToOptions.duration = scrollToOptions.duration || 1250;

      if (!el) {
        return;
      }

      if (this.isEmbedded() && this.pym) {
        this.pym.scrollParentToChildEl(el);
      } else {
        $parent.scrollTo($(el), scrollToOptions);
      }
    }

    // Round number

  }, {
    key: 'round',
    value: function round(value) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      return _.isNumber(value) ? Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) : value;
    }

    // Test for ios

  }, {
    key: 'checkAndroid',
    value: function checkAndroid() {
      if (!_.isBoolean(this.isAndroid)) {
        this.isAndroid = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/android/i);
      }

      return this.isAndroid;
    }

    // Test for ios

  }, {
    key: 'checkIOS',
    value: function checkIOS() {
      if (!_.isBoolean(this.isIOS)) {
        this.isIOS = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/iphone|ipad/i);
      }

      return this.isIOS;
    }

    // Test for windows phone

  }, {
    key: 'checkWindowsPhone',
    value: function checkWindowsPhone() {
      if (!_.isBoolean(this.isWindowsPhone)) {
        this.isWindowsPhone = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/windows\sphone/i);
      }

      return this.isWindowsPhone;
    }

    // Check basic mobile (assume ios or android)

  }, {
    key: 'checkMobile',
    value: function checkMobile() {
      return this.checkAndroid() && this.checkIOS() && this.checkWindowsPhone();
    }

    // Can autoplay video
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/video/autoplay.js

  }, {
    key: 'checkAutoplay',
    value: function checkAutoplay(done) {
      var _this2 = this;

      var timeout = void 0;
      var waitTime = 200;
      var retries = 8;
      var currentTry = 0;
      var elem = document.createElement('video');
      var elemStyle = elem.style;
      done = _.isFunction(done) ? done : function () {};

      // Only check once
      if (_.isBoolean(this.canAutoplay)) {
        return done(null, this.canAutoplay);
      }

      // Test callback for playing event listener
      var testAutoplay = function testAutoplay(arg) {
        currentTry++;
        clearTimeout(timeout);
        _this2.canAutoplay = arg && arg.type === 'playing' || elem.currentTime !== 0;

        if (!_this2.canAutoplay && currentTry < retries) {
          //Detection can be flaky if the browser is slow, so lets retry in a little bit
          timeout = setTimeout(testAutoplay, waitTime);
          return;
        }

        elem.removeEventListener('playing', testAutoplay, false);
        done(null, _this2.canAutoplay);

        // Cleanup, but don't assume elem is still in the page -
        // an extension (eg Flashblock) may already have removed it.
        if (elem.parentNode) {
          elem.parentNode.removeChild(elem);
        }
      };

      // Skip the test if video itself, or the autoplay
      // element on it isn't supported
      if (!('autoplay' in elem)) {
        this.canAutoplay = false;
        return done(null, this.canAutoplay);
      }

      elemStyle.position = 'absolute';
      elemStyle.height = 0;
      elemStyle.width = 0;

      try {
        elem.src = 'data:video/ogg;base64,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';
        elem.src = 'data:video/mp4;base64,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';
      } catch (e) {
        this.canAutoplay = false;
        return done(null, this.canAutoplay);
      }

      elem.setAttribute('autoplay', '');
      elemStyle.cssText = 'display:none';
      document.getElementsByTagName('body')[0].appendChild(elem);

      // wait for the next tick to add the listener, otherwise the element may
      // not have time to play in high load situations (e.g. the test suite)
      setTimeout(function () {
        elem.addEventListener('playing', testAutoplay, false);
        timeout = setTimeout(testAutoplay, waitTime);
      }, 0);
    }
  }]);

  return Util;
}();

// Export a generator for the class.


exports.default = function (options) {
  return new Util(options);
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(13);
var objectAssign = __webpack_require__(14);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Add to home screen is handled differently on platforms, on iOS, there
 * is no API of sorts, so we point to the action for that
 */

/* global $ */


module.exports = function (utils, diff) {
  var hideAfter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15000;
  var delayShow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3000;

  if (!utils) {
    return;
  } else if (utils.query && utils.query.homescreen) {
    // Keep going
  } else if (!utils.checkIOS()) {
    return;
  } else if (window.navigator && 'standalone' in window.navigator && window.navigator.standalone) {
    // Check that we are not in "web app" standalone
    return;
  }

  // Since we don't want to do this unless we can track how
  // often it happens, then we need to check storage capabilities
  if (!utils.checkLocalStorage()) {
    return;
  }

  // Check last time
  var lastTime = window.localStorage.getItem('ios-homescreen-seen');
  lastTime = lastTime ? parseInt(lastTime, 10) : 0;

  // Current time
  var now = new Date().getTime();

  // Default difference (3 days)
  diff = diff || 1000 * 60 * 60 * 24 * 3;

  // Check differenence
  if (!lastTime || now - lastTime > diff || utils.query && utils.query.homescreen) {
    setTimeout(function () {
      var $note = $('.ios-homescreen');

      // Save new time
      window.localStorage.setItem('ios-homescreen-seen', now);

      // Show
      $note.addClass('show');

      // Allow to close
      $note.find('.close').on('click', function (e) {
        e.preventDefault();
        $note.removeClass('show');
      });

      // Hide after a certain amount of time
      setTimeout(function () {
        $note.removeClass('show');
      }, hideAfter);
    }, delayShow || 0);
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Store/state component to use in other components
 */

// Define globals
/* global $, _ */


// Dependencies

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(17);

var _methods = __webpack_require__(1);

var _methods2 = _interopRequireDefault(_methods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Create custom class for methods
var AppStore = function (_Store) {
  _inherits(AppStore, _Store);

  function AppStore() {
    _classCallCheck(this, AppStore);

    // Setup offline
    var _this = _possibleConstructorReturn(this, (AppStore.__proto__ || Object.getPrototypeOf(AppStore)).apply(this, arguments));

    _this.offlineWatching();

    // Once utils are add
    _this.observe('utils', function () {
      _this.trackVisits();
    });

    // Referrer
    _this.set({
      sameReferrer: document.referrer && window.location && window.location.hostname && !!~document.referrer.indexOf(window.location.hostname)
    });
    return _this;
  }

  // Watch offline events, be conservative


  _createClass(AppStore, [{
    key: 'offlineWatching',
    value: function offlineWatching() {
      var _this2 = this;

      if (window.navigator) {
        if (_.isBoolean(window.navigator.onLine)) {
          this.set({ offline: !window.navigator.onLine });
          $('body').toggleClass('offline', !window.navigator.onLine);
        }

        window.addEventListener('load', function () {
          window.addEventListener('online', function () {
            _this2.set({ offline: false });
            $('body').toggleClass('offline', false);
          });
          window.addEventListener('offline', function () {
            _this2.set({ offline: true });
            $('body').toggleClass('offline', true);
          });
        });
      }
    }

    // Track visits to alter interface

  }, {
    key: 'trackVisits',
    value: function trackVisits() {
      var utils = this.get('utils');
      var visits = this.get('visits');

      // Don't need to do more than once.
      if (!utils || visits) {
        return;
      }

      if (utils && utils.checkLocalStorage()) {
        var visitCount = window.localStorage.getItem('tc-guide-visit-count');
        visitCount = visitCount ? parseInt(visitCount, 10) : 0;
        visitCount = visitCount + 1;
        visits = {};

        // Arbitrary points
        if (visitCount > 2) {
          visits.repeat = true;
        } else if (visitCount > 50) {
          visitCount = 0;
        }

        // Add to store
        visits.count = visitCount;
        this.set({ visits: visits });

        // Save
        window.localStorage.setItem('tc-guide-visit-count', visitCount);
      }
    }

    // Geolocate user

  }, {
    key: 'geolocate',
    value: function geolocate() {
      return _.bind(_methods2.default.geolocate, this).apply(undefined, arguments);
    }
  }]);

  return AppStore;
}(_store.Store);

// Create our store


var store = new AppStore({
  error: false,
  errorMessage: null,
  location: null,
  offline: false,
  isBrowser: typeof window !== 'undefined' && !!window
});

// Debug
if (window) {
  window.__store = store;
}

module.exports = store;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_js__ = __webpack_require__(0);


function Store(state, options) {
	this._observers = { pre: Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["blankObject"])(), post: Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["blankObject"])() };
	this._handlers = {};
	this._dependents = [];

	this._computed = Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["blankObject"])();
	this._sortedComputedProperties = [];

	this._state = Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["assign"])({}, state);
	this._differs = options && options.immutable ? __WEBPACK_IMPORTED_MODULE_0__shared_js__["_differsImmutable"] : __WEBPACK_IMPORTED_MODULE_0__shared_js__["_differs"];
}

Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["assign"])(Store.prototype, {
	_add: function(component, props) {
		this._dependents.push({
			component: component,
			props: props
		});
	},

	_init: function(props) {
		var state = {};
		for (var i = 0; i < props.length; i += 1) {
			var prop = props[i];
			state['$' + prop] = this._state[prop];
		}
		return state;
	},

	_remove: function(component) {
		var i = this._dependents.length;
		while (i--) {
			if (this._dependents[i].component === component) {
				this._dependents.splice(i, 1);
				return;
			}
		}
	},

	_sortComputedProperties: function() {
		var computed = this._computed;
		var sorted = this._sortedComputedProperties = [];
		var cycles;
		var visited = Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["blankObject"])();

		function visit(key) {
			if (cycles[key]) {
				throw new Error('Cyclical dependency detected');
			}

			if (visited[key]) return;
			visited[key] = true;

			var c = computed[key];

			if (c) {
				cycles[key] = true;
				c.deps.forEach(visit);
				sorted.push(c);
			}
		}

		for (var key in this._computed) {
			cycles = Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["blankObject"])();
			visit(key);
		}
	},

	compute: function(key, deps, fn) {
		var store = this;
		var value;

		var c = {
			deps: deps,
			update: function(state, changed, dirty) {
				var values = deps.map(function(dep) {
					if (dep in changed) dirty = true;
					return state[dep];
				});

				if (dirty) {
					var newValue = fn.apply(null, values);
					if (store._differs(newValue, value)) {
						value = newValue;
						changed[key] = true;
						state[key] = value;
					}
				}
			}
		};

		c.update(this._state, {}, true);

		this._computed[key] = c;
		this._sortComputedProperties();
	},

	fire: __WEBPACK_IMPORTED_MODULE_0__shared_js__["fire"],

	get: __WEBPACK_IMPORTED_MODULE_0__shared_js__["get"],

	// TODO remove this method
	observe: __WEBPACK_IMPORTED_MODULE_0__shared_js__["observe"],

	on: __WEBPACK_IMPORTED_MODULE_0__shared_js__["on"],

	onchange: function(callback) {
		// TODO remove this method
		console.warn("store.onchange is deprecated in favour of store.on('state', event => {...})");

		return this.on('state', function(event) {
			callback(event.current, event.changed);
		});
	},

	set: function(newState) {
		var oldState = this._state,
			changed = this._changed = {},
			dirty = false;

		for (var key in newState) {
			if (this._computed[key]) throw new Error("'" + key + "' is a read-only property");
			if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
		}
		if (!dirty) return;

		this._state = Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["assign"])(Object(__WEBPACK_IMPORTED_MODULE_0__shared_js__["assign"])({}, oldState), newState);

		for (var i = 0; i < this._sortedComputedProperties.length; i += 1) {
			this._sortedComputedProperties[i].update(this._state, changed);
		}

		this.fire('state', {
			changed: changed,
			current: this._state,
			previous: oldState
		});

		var dependents = this._dependents.slice(); // guard against mutations
		for (var i = 0; i < dependents.length; i += 1) {
			var dependent = dependents[i];
			var componentState = {};
			dirty = false;

			for (var j = 0; j < dependent.props.length; j += 1) {
				var prop = dependent.props[j];
				if (prop in changed) {
					componentState['$' + prop] = this._state[prop];
					dirty = true;
				}
			}

			if (dirty) dependent.component.set(componentState);
		}

		this.fire('update', {
			changed: changed,
			current: this._state,
			previous: oldState
		});
	}
});




/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/header.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _helpers = __webpack_require__(2);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function data() {
	return {
		isBrowser: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined,
		fullNavOpen: false
	};
};

var facebookURL = _helpers2.default.facebookURL;

var twitterURL = _helpers2.default.twitterURL;

var emailURL = _helpers2.default.emailURL;

var smsURL = _helpers2.default.smsURL;

function backURL(data) {
	// Groups go back to home page
	// Lists go back to group
	// Items go to either list or groups
	return data.dataset === "groups" ? "../" : data.dataset === "lists" && data.groups && data.groups[0] ? data.basePath + "/" + data.groups[0].filename : data.dataset === "items" && data.lists && data.lists[0] ? data.basePath + "/" + data.lists[0].filename : data.dataset === "items" && data.groups && data.groups[0] ? data.basePath + "/" + data.groups[0].filename : data.basePath;
};

var methods = {
	// Toggle the full nav
	toggleFullNav: function toggleFullNav(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		this.set({ fullNavOpen: !this.get("fullNavOpen") });
	},

	// Go back using browser.  If different domain, then go to root
	// of guide
	goBack: function goBack(e) {
		var sameDomain = ~document.referrer.indexOf(window.location.host);
		if (sameDomain && e && e.preventDefault) {
			e.preventDefault();
		} else if (!sameDomain) {
			return;
		}
		if (window.history) {
			window.history.back(-1);
		}
	}
};

function create_main_fragment(component, state) {
	var nav,
	    div,
	    a,
	    span,
	    text,
	    a_href_value,
	    text_2,
	    a_1,
	    span_1,
	    text_3,
	    text_5,
	    div_1,
	    h1,
	    text_6,
	    text_7,
	    a_2,
	    span_2,
	    text_8,
	    a_2_class_value,
	    text_11,
	    h1_1,
	    text_12_value = state.data.name || state.data.title || state.content.title,
	    text_12,
	    text_14,
	    div_2,
	    h1_2,
	    span_3,
	    text_15,
	    text_17,
	    div_3,
	    ul,
	    text_19,
	    div_4,
	    div_5,
	    a_3,
	    span_4,
	    text_20,
	    a_3_href_value,
	    text_22,
	    a_4,
	    span_5,
	    text_23,
	    a_4_href_value,
	    text_25,
	    a_5,
	    span_6,
	    text_26,
	    a_5_href_value,
	    text_28,
	    a_6,
	    span_7,
	    text_29,
	    a_6_href_value,
	    div_2_class_value;

	function click_handler(event) {
		component.toggleFullNav(event);
	}

	var each_value = state.groups;

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(component, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value: each_value,
			g: each_value[i],
			g_index: i
		}));
	}

	return {
		c: function create() {
			nav = (0, _shared.createElement)("nav");
			div = (0, _shared.createElement)("div");
			a = (0, _shared.createElement)("a");
			span = (0, _shared.createElement)("span");
			text = (0, _shared.createText)("Back");
			text_2 = (0, _shared.createText)("\n\n    ");
			a_1 = (0, _shared.createElement)("a");
			span_1 = (0, _shared.createElement)("span");
			text_3 = (0, _shared.createText)("Go to homepage");
			text_5 = (0, _shared.createText)("\n\n    ");
			div_1 = (0, _shared.createElement)("div");
			h1 = (0, _shared.createElement)("h1");
			text_6 = (0, _shared.createText)("Essential Twin Cities Guide");
			text_7 = (0, _shared.createText)("\n\n      ");
			a_2 = (0, _shared.createElement)("a");
			span_2 = (0, _shared.createElement)("span");
			text_8 = (0, _shared.createText)("Menu");
			text_11 = (0, _shared.createText)("\n\n    ");
			h1_1 = (0, _shared.createElement)("h1");
			text_12 = (0, _shared.createText)(text_12_value);
			text_14 = (0, _shared.createText)("\n\n  ");
			div_2 = (0, _shared.createElement)("div");
			h1_2 = (0, _shared.createElement)("h1");
			span_3 = (0, _shared.createElement)("span");
			text_15 = (0, _shared.createText)("Essential Twin Cities Guide");
			text_17 = (0, _shared.createText)("\n\n    ");
			div_3 = (0, _shared.createElement)("div");
			ul = (0, _shared.createElement)("ul");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			text_19 = (0, _shared.createText)("\n\n    ");
			div_4 = (0, _shared.createElement)("div");
			div_5 = (0, _shared.createElement)("div");
			a_3 = (0, _shared.createElement)("a");
			span_4 = (0, _shared.createElement)("span");
			text_20 = (0, _shared.createText)("Share on Facebook");
			text_22 = (0, _shared.createText)("\n\n        ");
			a_4 = (0, _shared.createElement)("a");
			span_5 = (0, _shared.createElement)("span");
			text_23 = (0, _shared.createText)("Share on Twitter");
			text_25 = (0, _shared.createText)("\n\n        ");
			a_5 = (0, _shared.createElement)("a");
			span_6 = (0, _shared.createElement)("span");
			text_26 = (0, _shared.createText)("Share via email");
			text_28 = (0, _shared.createText)("\n\n        ");
			a_6 = (0, _shared.createElement)("a");
			span_7 = (0, _shared.createElement)("span");
			text_29 = (0, _shared.createText)("Share via SMS");
			this.h();
		},

		l: function claim(nodes) {
			nav = (0, _shared.claimElement)(nodes, "NAV", {}, false);
			var nav_nodes = (0, _shared.children)(nav);

			div = (0, _shared.claimElement)(nav_nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			a = (0, _shared.claimElement)(div_nodes, "A", { href: true, class: true, title: true }, false);
			var a_nodes = (0, _shared.children)(a);

			span = (0, _shared.claimElement)(a_nodes, "SPAN", { class: true }, false);
			var span_nodes = (0, _shared.children)(span);

			text = (0, _shared.claimText)(span_nodes, "Back");
			span_nodes.forEach(_shared.detachNode);
			a_nodes.forEach(_shared.detachNode);
			text_2 = (0, _shared.claimText)(div_nodes, "\n\n    ");

			a_1 = (0, _shared.claimElement)(div_nodes, "A", { href: true, class: true, title: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			span_1 = (0, _shared.claimElement)(a_1_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			text_3 = (0, _shared.claimText)(span_1_nodes, "Go to homepage");
			span_1_nodes.forEach(_shared.detachNode);
			a_1_nodes.forEach(_shared.detachNode);
			text_5 = (0, _shared.claimText)(div_nodes, "\n\n    ");

			div_1 = (0, _shared.claimElement)(div_nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			h1 = (0, _shared.claimElement)(div_1_nodes, "H1", { class: true }, false);
			var h1_nodes = (0, _shared.children)(h1);

			text_6 = (0, _shared.claimText)(h1_nodes, "Essential Twin Cities Guide");
			h1_nodes.forEach(_shared.detachNode);
			text_7 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			a_2 = (0, _shared.claimElement)(div_1_nodes, "A", { href: true, class: true, title: true }, false);
			var a_2_nodes = (0, _shared.children)(a_2);

			span_2 = (0, _shared.claimElement)(a_2_nodes, "SPAN", { class: true }, false);
			var span_2_nodes = (0, _shared.children)(span_2);

			text_8 = (0, _shared.claimText)(span_2_nodes, "Menu");
			span_2_nodes.forEach(_shared.detachNode);
			a_2_nodes.forEach(_shared.detachNode);
			div_1_nodes.forEach(_shared.detachNode);
			text_11 = (0, _shared.claimText)(div_nodes, "\n\n    ");

			h1_1 = (0, _shared.claimElement)(div_nodes, "H1", { class: true }, false);
			var h1_1_nodes = (0, _shared.children)(h1_1);

			text_12 = (0, _shared.claimText)(h1_1_nodes, text_12_value);
			h1_1_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			text_14 = (0, _shared.claimText)(nav_nodes, "\n\n  ");

			div_2 = (0, _shared.claimElement)(nav_nodes, "DIV", { class: true }, false);
			var div_2_nodes = (0, _shared.children)(div_2);

			h1_2 = (0, _shared.claimElement)(div_2_nodes, "H1", { class: true }, false);
			var h1_2_nodes = (0, _shared.children)(h1_2);

			span_3 = (0, _shared.claimElement)(h1_2_nodes, "SPAN", {}, false);
			var span_3_nodes = (0, _shared.children)(span_3);

			text_15 = (0, _shared.claimText)(span_3_nodes, "Essential Twin Cities Guide");
			span_3_nodes.forEach(_shared.detachNode);
			h1_2_nodes.forEach(_shared.detachNode);
			text_17 = (0, _shared.claimText)(div_2_nodes, "\n\n    ");

			div_3 = (0, _shared.claimElement)(div_2_nodes, "DIV", { class: true }, false);
			var div_3_nodes = (0, _shared.children)(div_3);

			ul = (0, _shared.claimElement)(div_3_nodes, "UL", { class: true }, false);
			var ul_nodes = (0, _shared.children)(ul);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(_shared.detachNode);
			div_3_nodes.forEach(_shared.detachNode);
			text_19 = (0, _shared.claimText)(div_2_nodes, "\n\n    ");

			div_4 = (0, _shared.claimElement)(div_2_nodes, "DIV", { class: true }, false);
			var div_4_nodes = (0, _shared.children)(div_4);

			div_5 = (0, _shared.claimElement)(div_4_nodes, "DIV", { class: true }, false);
			var div_5_nodes = (0, _shared.children)(div_5);

			a_3 = (0, _shared.claimElement)(div_5_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_3_nodes = (0, _shared.children)(a_3);

			span_4 = (0, _shared.claimElement)(a_3_nodes, "SPAN", { class: true }, false);
			var span_4_nodes = (0, _shared.children)(span_4);

			text_20 = (0, _shared.claimText)(span_4_nodes, "Share on Facebook");
			span_4_nodes.forEach(_shared.detachNode);
			a_3_nodes.forEach(_shared.detachNode);
			text_22 = (0, _shared.claimText)(div_5_nodes, "\n\n        ");

			a_4 = (0, _shared.claimElement)(div_5_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_4_nodes = (0, _shared.children)(a_4);

			span_5 = (0, _shared.claimElement)(a_4_nodes, "SPAN", { class: true }, false);
			var span_5_nodes = (0, _shared.children)(span_5);

			text_23 = (0, _shared.claimText)(span_5_nodes, "Share on Twitter");
			span_5_nodes.forEach(_shared.detachNode);
			a_4_nodes.forEach(_shared.detachNode);
			text_25 = (0, _shared.claimText)(div_5_nodes, "\n\n        ");

			a_5 = (0, _shared.claimElement)(div_5_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_5_nodes = (0, _shared.children)(a_5);

			span_6 = (0, _shared.claimElement)(a_5_nodes, "SPAN", { class: true }, false);
			var span_6_nodes = (0, _shared.children)(span_6);

			text_26 = (0, _shared.claimText)(span_6_nodes, "Share via email");
			span_6_nodes.forEach(_shared.detachNode);
			a_5_nodes.forEach(_shared.detachNode);
			text_28 = (0, _shared.claimText)(div_5_nodes, "\n\n        ");

			a_6 = (0, _shared.claimElement)(div_5_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_6_nodes = (0, _shared.children)(a_6);

			span_7 = (0, _shared.claimElement)(a_6_nodes, "SPAN", { class: true }, false);
			var span_7_nodes = (0, _shared.children)(span_7);

			text_29 = (0, _shared.claimText)(span_7_nodes, "Share via SMS");
			span_7_nodes.forEach(_shared.detachNode);
			a_6_nodes.forEach(_shared.detachNode);
			div_5_nodes.forEach(_shared.detachNode);
			div_4_nodes.forEach(_shared.detachNode);
			div_2_nodes.forEach(_shared.detachNode);
			nav_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			span.className = "sr-only";
			a.href = a_href_value = backURL(state.data);
			a.className = "back-logo";
			a.title = "Go back a page";
			span_1.className = "sr-only";
			a_1.href = "http://startribune.com";
			a_1.className = "middle-logo";
			a_1.title = "Home";
			h1.className = "secondary-head";
			span_2.className = "sr-only";
			(0, _shared.addListener)(a_2, "click", click_handler);
			a_2.href = "#/menu";
			a_2.className = a_2_class_value = "menu-logo " + (state.fullNavOpen ? 'menu-logo-close' : '');
			a_2.title = "Menu";
			div_1.className = "top-nav-left";
			h1_1.className = "sr-only";
			div.className = "top-nav-section";
			h1_2.className = "main-nav-heading";
			ul.className = "main-nav-groups cf";
			div_3.className = "vertical-center";
			span_4.className = "sr-only";
			a_3.href = a_3_href_value = facebookURL(state.data, state.content);
			a_3.target = "_blank";
			a_3.rel = "noopener";
			a_3.className = "facebook-button";
			span_5.className = "sr-only";
			a_4.href = a_4_href_value = twitterURL(state.data, state.content);
			a_4.target = "_blank";
			a_4.rel = "noopener";
			a_4.className = "twitter-button";
			span_6.className = "sr-only";
			a_5.href = a_5_href_value = emailURL(state.data, state.content);
			a_5.target = "_blank";
			a_5.rel = "noopener";
			a_5.className = "email-button";
			span_7.className = "sr-only";
			a_6.href = a_6_href_value = smsURL(state.data, state.content);
			a_6.target = "_blank";
			a_6.rel = "noopener";
			a_6.className = "sms-button";
			div_5.className = "social-buttons";
			div_4.className = "vertical-bottom";
			div_2.className = div_2_class_value = "full-nav " + (state.fullNavOpen ? 'full-nav-open' : '');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(nav, target, anchor);
			(0, _shared.appendNode)(div, nav);
			(0, _shared.appendNode)(a, div);
			(0, _shared.appendNode)(span, a);
			(0, _shared.appendNode)(text, span);
			(0, _shared.appendNode)(text_2, div);
			(0, _shared.appendNode)(a_1, div);
			(0, _shared.appendNode)(span_1, a_1);
			(0, _shared.appendNode)(text_3, span_1);
			(0, _shared.appendNode)(text_5, div);
			(0, _shared.appendNode)(div_1, div);
			(0, _shared.appendNode)(h1, div_1);
			(0, _shared.appendNode)(text_6, h1);
			(0, _shared.appendNode)(text_7, div_1);
			(0, _shared.appendNode)(a_2, div_1);
			(0, _shared.appendNode)(span_2, a_2);
			(0, _shared.appendNode)(text_8, span_2);
			(0, _shared.appendNode)(text_11, div);
			(0, _shared.appendNode)(h1_1, div);
			(0, _shared.appendNode)(text_12, h1_1);
			(0, _shared.appendNode)(text_14, nav);
			(0, _shared.appendNode)(div_2, nav);
			(0, _shared.appendNode)(h1_2, div_2);
			(0, _shared.appendNode)(span_3, h1_2);
			(0, _shared.appendNode)(text_15, span_3);
			(0, _shared.appendNode)(text_17, div_2);
			(0, _shared.appendNode)(div_3, div_2);
			(0, _shared.appendNode)(ul, div_3);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			(0, _shared.appendNode)(text_19, div_2);
			(0, _shared.appendNode)(div_4, div_2);
			(0, _shared.appendNode)(div_5, div_4);
			(0, _shared.appendNode)(a_3, div_5);
			(0, _shared.appendNode)(span_4, a_3);
			(0, _shared.appendNode)(text_20, span_4);
			(0, _shared.appendNode)(text_22, div_5);
			(0, _shared.appendNode)(a_4, div_5);
			(0, _shared.appendNode)(span_5, a_4);
			(0, _shared.appendNode)(text_23, span_5);
			(0, _shared.appendNode)(text_25, div_5);
			(0, _shared.appendNode)(a_5, div_5);
			(0, _shared.appendNode)(span_6, a_5);
			(0, _shared.appendNode)(text_26, span_6);
			(0, _shared.appendNode)(text_28, div_5);
			(0, _shared.appendNode)(a_6, div_5);
			(0, _shared.appendNode)(span_7, a_6);
			(0, _shared.appendNode)(text_29, span_7);
		},

		p: function update(changed, state) {
			if (changed.data && a_href_value !== (a_href_value = backURL(state.data))) {
				a.href = a_href_value;
			}

			if (changed.fullNavOpen && a_2_class_value !== (a_2_class_value = "menu-logo " + (state.fullNavOpen ? 'menu-logo-close' : ''))) {
				a_2.className = a_2_class_value;
			}

			if ((changed.data || changed.content) && text_12_value !== (text_12_value = state.data.name || state.data.title || state.content.title)) {
				text_12.data = text_12_value;
			}

			var each_value = state.groups;

			if (changed.data || changed.groups) {
				for (var i = 0; i < each_value.length; i += 1) {
					var each_context = (0, _shared.assign)((0, _shared.assign)({}, state), {
						each_value: each_value,
						g: each_value[i],
						g_index: i
					});

					if (each_blocks[i]) {
						each_blocks[i].p(changed, each_context);
					} else {
						each_blocks[i] = create_each_block(component, each_context);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].u();
					each_blocks[i].d();
				}
				each_blocks.length = each_value.length;
			}

			if ((changed.data || changed.content) && a_3_href_value !== (a_3_href_value = facebookURL(state.data, state.content))) {
				a_3.href = a_3_href_value;
			}

			if ((changed.data || changed.content) && a_4_href_value !== (a_4_href_value = twitterURL(state.data, state.content))) {
				a_4.href = a_4_href_value;
			}

			if ((changed.data || changed.content) && a_5_href_value !== (a_5_href_value = emailURL(state.data, state.content))) {
				a_5.href = a_5_href_value;
			}

			if ((changed.data || changed.content) && a_6_href_value !== (a_6_href_value = smsURL(state.data, state.content))) {
				a_6.href = a_6_href_value;
			}

			if (changed.fullNavOpen && div_2_class_value !== (div_2_class_value = "full-nav " + (state.fullNavOpen ? 'full-nav-open' : ''))) {
				div_2.className = div_2_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(nav);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].u();
			}
		},

		d: function destroy() {
			(0, _shared.removeListener)(a_2, "click", click_handler);

			(0, _shared.destroyEach)(each_blocks);
		}
	};
}

// (29:8) {{#each groups as g}}
function create_each_block(component, state) {
	var g = state.g,
	    each_value = state.each_value,
	    g_index = state.g_index;
	var li,
	    a,
	    text_value = g.title,
	    text,
	    a_href_value;

	return {
		c: function create() {
			li = (0, _shared.createElement)("li");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)(text_value);
			this.h();
		},

		l: function claim(nodes) {
			li = (0, _shared.claimElement)(nodes, "LI", { class: true }, false);
			var li_nodes = (0, _shared.children)(li);

			a = (0, _shared.claimElement)(li_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, text_value);
			a_nodes.forEach(_shared.detachNode);
			li_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + g.filename;
			li.className = "group";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(li, target, anchor);
			(0, _shared.appendNode)(a, li);
			(0, _shared.appendNode)(text, a);
		},

		p: function update(changed, state) {
			g = state.g;
			each_value = state.each_value;
			g_index = state.g_index;
			if (changed.groups && text_value !== (text_value = g.title)) {
				text.data = text_value;
			}

			if ((changed.data || changed.groups) && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + g.filename)) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(li);
		},

		d: _shared.noop
	};
}

function Header(options) {
	(0, _shared.init)(this, options);
	this._state = (0, _shared.assign)(data(), options.data);

	this._fragment = create_main_fragment(this, this._state);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);
	}
}

(0, _shared.assign)(Header.prototype, _shared.proto);
(0, _shared.assign)(Header.prototype, methods);
exports.default = Header;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/groups.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _helpers = __webpack_require__(2);

var _helpers2 = _interopRequireDefault(_helpers);

var _methods = __webpack_require__(1);

var _methods2 = _interopRequireDefault(_methods);

var _observe = __webpack_require__(5);

var _observe2 = _interopRequireDefault(_observe);

var _mapStyles = __webpack_require__(6);

var _mapStyles2 = _interopRequireDefault(_mapStyles);

var _items = __webpack_require__(3);

var _items2 = _interopRequireDefault(_items);

var _map = __webpack_require__(7);

var _map2 = _interopRequireDefault(_map);

var _ad = __webpack_require__(4);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function allListsItems(data) {
	var o = [];
	if (data.lists) {
		o = o.concat(data.lists);
	}
	if (data.items) {
		o = o.concat(data.items);
	}

	return o;
};

function mapLocations(allItems) {
	return allItems ? allItems.map(function (i) {
		return {
			id: i.id,
			content: i.name || i.title,
			lat: parseFloat(i.latitude),
			lng: parseFloat(i.longitude)
		};
	}) : [];
};

function hasLocations(allItems) {
	return allItems ? !!allItems.find(function (i) {
		return i && i.latitude && i.longitude || i && i.items && !!i.items.find(function (t) {
			return t && t.latitude && t.longitude;
		});
	}) : false;
};

function data() {
	return {
		isBrowser: (typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined,
		view: 'featured',
		mapCenter: {
			lat: 44.9629232,
			lng: -93.159196
		},
		smallZoom: 11,
		largeZoom: 10
	};
};

var srcset = _helpers2.default.srcset;

var methods_1 = {
	startQueryRouter: _methods2.default.startQueryRouter,
	eventSet: _methods2.default.eventSet,
	goTo: _methods2.default.goTo,

	// Find item by ID
	findByID: function findByID(id) {
		var data = this.get('data');
		var allItems = this.allItems(data);

		if (id && data.lists && _.find(data.lists, { id: id })) {
			return _.find(data.lists, { id: id });
		} else if (id && data.items && _.find(data.items, { id: id })) {
			return _.find(data.items, { id: id });
		} else if (id && allItems && _.find(allItems, { id: id })) {
			return _.find(allItems, { id: id });
		}
	},


	// Set all lists and items
	setAll: function setAll(values) {
		var set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
		var exceptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

		var data = this.get('data');
		var allItems = this.allItems(data);

		if (data.lists) {
			data.lists = _.map(data.lists, function (l) {
				return !exceptions || exceptions && !~exceptions.indexOf(l.id) ? _.extend(l, values) : l;
			});
		}
		if (data.items) {
			data.items = _.map(data.items, function (l) {
				return !exceptions || exceptions && !~exceptions.indexOf(l.id) ? _.extend(l, values) : l;
			});
		}
		if (allItems) {
			allItems = _.map(allItems, function (l) {
				return !exceptions || exceptions && !~exceptions.indexOf(l.id) ? _.extend(l, values) : l;
			});
		}

		if (set) {
			this.set({ data: data });
		}
	},


	// Observe featured item
	observeFeaturedItem: function observeFeaturedItem(id) {
		var currentID = this.get('observeFeaturedItemID');
		if (currentID && currentID === id) {
			return;
		}
		var item = this.findByID(id);
		if (item) {
			this.setAll({ inView: false }, false, [id]);
			item.inView = true;
			this.set({ data: this.get('data'), observeFeaturedItemID: id });
		}
	},


	// Observe a map item
	observeMapItem: function observeMapItem(id) {
		var currentID = this.get('observeMapItemID');
		if (currentID && currentID === id) {
			return;
		}

		var item = this.findByID(id);
		if (item) {
			// Check if item has location
			var loc = item.latitude && item.longitude;
			this.setAll({ inView: false }, false, loc ? [id] : []);
			item.inView = true;
			this.set({
				data: this.get('data'),
				locationsInView: loc ? [id] : [],
				observeMapItemID: id
			});
		}
	},


	// Hover items
	hoverItem: function hoverItem(e, item) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		// Set main visual to hover item
		var data = this.get('data');
		data.mainVisual = item.mainImageLocal ? item.mainImageLocal : undefined;
		data.mainVisualDescription = item.imageDescription ? item.imageDescription : undefined;

		// Since we want a default state and a more stiky state
		// than what CSS hover can accomplish, we manage it in data
		this.get('allListsItems').forEach(function (i) {
			i.inFocus = i.id === item.id ? true : false;
		});

		this.set({
			data: data
		});
	},


	// All items (items in lists)
	allItems: function allItems(data) {
		var o = [];
		if (data.lists) {
			data.lists.forEach(function (l) {
				if (l.items && l.items.length) {
					o = o.concat(l.items);
				}
			});
		}
		if (data.items) {
			o = o.concat(data.items);
		}

		// Sort by name
		o = o.sort(function (a, b) {
			var at = (a.title || a.name || 'zzzzzzz').toLowerCase().replace(/^(the|a|an)\s/, '');
			var bt = (b.title || b.name || 'zzzzzzz').toLowerCase().replace(/^(the|a|an)\s/, '');
			return at < bt ? -1 : at > bt ? 1 : 0;
		});

		return o;
	}
};

function oncreate() {
	var _this = this;

	this.__intialized = false;

	// Allow for linkable views
	this.startQueryRouter(['view'], { view: 'featured' });

	// Make all items
	this.observe('data', function (n) {
		if (n && (n.items || n.lists)) {
			var allItems = _this.allItems(_this.get('data'));
			_this.set({ allItems: allItems });
		}
	});

	// Make first item in focus
	this.observe('allListsItems', function (n) {
		if (n && !_this.__intialized) {
			n[0].inFocus = true;
			_this.__intialized = true;
		}
	});

	// React to view change.  Since we need to have access to the dom
	// for the map, we defer the observe
	this.observe('view', function (n, o) {
		if (n && n !== o) {
			if (n === 'featured') {
				// Observe feature events
				if (_this.__featuredObserver) {
					_this.__featuredObserver.stop();
					_this.__featuredObserver.addElements(document.querySelectorAll('.groups-items li'));
				} else {
					_this.__featuredObserver = (0, _observe2.default)({
						visibleThreshold: 0.75,
						elements: document.querySelectorAll('.groups-items li'),
						onObserve: _.bind(_this.observeFeaturedItem, _this),
						throttle: false
					});
				}
			} else if (n === 'map') {
				// Observe map events
				if (_this.__mapObserver) {
					_this.__mapObserver.stop();
					_this.__mapObserver.addElements(document.querySelectorAll('.map-items .item'));
				} else {
					_this.__mapObserver = (0, _observe2.default)({
						visibleThreshold: 0.9,
						elements: document.querySelectorAll('.map-items .item'),
						onObserve: _.bind(_this.observeMapItem, _this),
						throttle: false
					});
				}

				// Geolocate
				if (_this.store) {
					_this.store.geolocate().catch(function (error) {
						// TODO: Do something in the interface about this
						// error.
						console.error(error);
					});
				}
			}
		}
	}, { defer: true });
};

function ondestroy() {
	var u = this.get('utils');
	if (u) {
		u.stopGeolocate();
	}
};

function create_main_fragment(component, state) {
	var div,
	    text_1,
	    div_1,
	    nav,
	    h1,
	    text_2_value = state.data.title,
	    text_2,
	    text_3,
	    text_5,
	    text_6,
	    div_1_class_value;

	function select_block_type_1(state) {
		if (state.view === 'map') return create_if_block;
		if (state.data.mainVisual) return create_if_block_1;
		return null;
	}

	var current_block_type = select_block_type_1(state);
	var if_block = current_block_type && current_block_type(component, state);

	var if_block_2 = state.hasLocations && create_if_block_4(component, state);

	var if_block_3 = state.view === 'featured' && create_if_block_6(component, state);

	var if_block_4 = state.view === 'map' && create_if_block_11(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			if (if_block) if_block.c();
			text_1 = (0, _shared.createText)("\n\n");
			div_1 = (0, _shared.createElement)("div");
			nav = (0, _shared.createElement)("nav");
			h1 = (0, _shared.createElement)("h1");
			text_2 = (0, _shared.createText)(text_2_value);
			text_3 = (0, _shared.createText)("\n\n    ");
			if (if_block_2) if_block_2.c();
			text_5 = (0, _shared.createText)("\n\n  ");
			if (if_block_3) if_block_3.c();
			text_6 = (0, _shared.createText)("\n\n  ");
			if (if_block_4) if_block_4.c();
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			if (if_block) if_block.l(div_nodes);
			div_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(nodes, "\n\n");

			div_1 = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			nav = (0, _shared.claimElement)(div_1_nodes, "NAV", { class: true }, false);
			var nav_nodes = (0, _shared.children)(nav);

			h1 = (0, _shared.claimElement)(nav_nodes, "H1", {}, false);
			var h1_nodes = (0, _shared.children)(h1);

			text_2 = (0, _shared.claimText)(h1_nodes, text_2_value);
			h1_nodes.forEach(_shared.detachNode);
			text_3 = (0, _shared.claimText)(nav_nodes, "\n\n    ");
			if (if_block_2) if_block_2.l(nav_nodes);
			nav_nodes.forEach(_shared.detachNode);
			text_5 = (0, _shared.claimText)(div_1_nodes, "\n\n  ");
			if (if_block_3) if_block_3.l(div_1_nodes);
			text_6 = (0, _shared.claimText)(div_1_nodes, "\n\n  ");
			if (if_block_4) if_block_4.l(div_1_nodes);
			div_1_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "main-visual";
			nav.className = "minor-navigation adjust-header";
			div_1.className = div_1_class_value = "component component-group has-minor-navigation view-" + state.view;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			if (if_block) if_block.m(div, null);
			(0, _shared.insertNode)(text_1, target, anchor);
			(0, _shared.insertNode)(div_1, target, anchor);
			(0, _shared.appendNode)(nav, div_1);
			(0, _shared.appendNode)(h1, nav);
			(0, _shared.appendNode)(text_2, h1);
			(0, _shared.appendNode)(text_3, nav);
			if (if_block_2) if_block_2.m(nav, null);
			(0, _shared.appendNode)(text_5, div_1);
			if (if_block_3) if_block_3.m(div_1, null);
			(0, _shared.appendNode)(text_6, div_1);
			if (if_block_4) if_block_4.m(div_1, null);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type_1(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if (if_block) {
					if_block.u();
					if_block.d();
				}
				if_block = current_block_type && current_block_type(component, state);
				if (if_block) if_block.c();
				if (if_block) if_block.m(div, null);
			}

			if (changed.data && text_2_value !== (text_2_value = state.data.title)) {
				text_2.data = text_2_value;
			}

			if (state.hasLocations) {
				if (if_block_2) {
					if_block_2.p(changed, state);
				} else {
					if_block_2 = create_if_block_4(component, state);
					if_block_2.c();
					if_block_2.m(nav, null);
				}
			} else if (if_block_2) {
				if_block_2.u();
				if_block_2.d();
				if_block_2 = null;
			}

			if (state.view === 'featured') {
				if (if_block_3) {
					if_block_3.p(changed, state);
				} else {
					if_block_3 = create_if_block_6(component, state);
					if_block_3.c();
					if_block_3.m(div_1, text_6);
				}
			} else if (if_block_3) {
				if_block_3.u();
				if_block_3.d();
				if_block_3 = null;
			}

			if (state.view === 'map') {
				if (if_block_4) {
					if_block_4.p(changed, state);
				} else {
					if_block_4 = create_if_block_11(component, state);
					if_block_4.c();
					if_block_4.m(div_1, null);
				}
			} else if (if_block_4) {
				if_block_4.u();
				if_block_4.d();
				if_block_4 = null;
			}

			if (changed.view && div_1_class_value !== (div_1_class_value = "component component-group has-minor-navigation view-" + state.view)) {
				div_1.className = div_1_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
			if (if_block) if_block.u();
			(0, _shared.detachNode)(text_1);
			(0, _shared.detachNode)(div_1);
			if (if_block_2) if_block_2.u();
			if (if_block_3) if_block_3.u();
			if (if_block_4) if_block_4.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_2) if_block_2.d();
			if (if_block_3) if_block_3.d();
			if (if_block_4) if_block_4.d();
		}
	};
}

// (5:4) {{#if $isBrowser && $offline}}
function create_if_block_2(component, state) {
	var img, img_alt_value, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual.replace('.jpg', '-600px.jpg');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual.replace('.jpg', '-600px.jpg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (9:4) {{else}}
function create_if_block_3(component, state) {
	var picture, source, source_srcset_value, text, source_1, source_1_srcset_value, text_1, img, img_alt_value, img_src_value;

	return {
		c: function create() {
			picture = (0, _shared.createElement)("picture");
			source = (0, _shared.createElement)("source");
			text = (0, _shared.createText)("\n        ");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n        ");
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			picture = (0, _shared.claimElement)(nodes, "PICTURE", {}, false);
			var picture_nodes = (0, _shared.children)(picture);

			source = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(picture_nodes, "\n        ");

			source_1 = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(picture_nodes, "\n        ");

			img = (0, _shared.claimElement)(picture_nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			picture_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.type = "image/webp";
			(0, _shared.setAttribute)(source, "srcset", source_srcset_value = srcset(state.data.basePath, state.data.mainVisual, 'webp'));
			source.sizes = "100vw";
			source_1.type = "image/jpeg";
			(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value = srcset(state.data.basePath, state.data.mainVisual));
			source_1.sizes = "100vw";
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(picture, target, anchor);
			(0, _shared.appendNode)(source, picture);
			(0, _shared.appendNode)(text, picture);
			(0, _shared.appendNode)(source_1, picture);
			(0, _shared.appendNode)(text_1, picture);
			(0, _shared.appendNode)(img, picture);
		},

		p: function update(changed, state) {
			if (changed.data && source_srcset_value !== (source_srcset_value = srcset(state.data.basePath, state.data.mainVisual, 'webp'))) {
				(0, _shared.setAttribute)(source, "srcset", source_srcset_value);
			}

			if (changed.data && source_1_srcset_value !== (source_1_srcset_value = srcset(state.data.basePath, state.data.mainVisual))) {
				(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value);
			}

			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual)) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(picture);
		},

		d: _shared.noop
	};
}

// (2:2) {{#if view === 'map'}}
function create_if_block(component, state) {

	var map_initial_data = {
		locations: state.mapLocations,
		inView: state.locationsInView,
		zoom: 10,
		goToOffset: -0.6
	};
	var map = new _map2.default({
		root: component.root,
		data: map_initial_data
	});

	return {
		c: function create() {
			map._fragment.c();
		},

		l: function claim(nodes) {
			map._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			map._mount(target, anchor);
		},

		p: function update(changed, state) {
			var map_changes = {};
			if (changed.mapLocations) map_changes.locations = state.mapLocations;
			if (changed.locationsInView) map_changes.inView = state.locationsInView;
			map._set(map_changes);
		},

		u: function unmount() {
			map._unmount();
		},

		d: function destroy() {
			map.destroy(false);
		}
	};
}

// (4:28) 
function create_if_block_1(component, state) {
	var if_block_anchor;

	function select_block_type(state) {
		if (state.$isBrowser && state.$offline) return create_if_block_2;
		return create_if_block_3;
	}

	var current_block_type = select_block_type(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},

		u: function unmount() {
			if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (39:12) {{#if $isGeolocating}}
function create_if_block_5(component, state) {
	var img, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { class: true, src: true, alt: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.className = "loading-icon";
			img.src = img_src_value = "" + state.data.basePath + "/assets/images/icons/loading.svg";
			img.alt = "Loading icon";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/assets/images/icons/loading.svg")) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (31:4) {{#if hasLocations}}
function create_if_block_4(component, state) {
	var ul, li, a, text, a_class_value, li_1, a_1, text_1, a_1_class_value;

	function click_handler(event) {
		component.eventSet(event, { view: 'featured' });
	}

	var if_block = state.$isGeolocating && create_if_block_5(component, state);

	function click_handler_1(event) {
		component.eventSet(event, { view: 'map' });
	}

	return {
		c: function create() {
			ul = (0, _shared.createElement)("ul");
			li = (0, _shared.createElement)("li");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)("Featured");
			li_1 = (0, _shared.createElement)("li");
			a_1 = (0, _shared.createElement)("a");
			text_1 = (0, _shared.createText)("Map\n            ");
			if (if_block) if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			ul = (0, _shared.claimElement)(nodes, "UL", { class: true }, false);
			var ul_nodes = (0, _shared.children)(ul);

			li = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_nodes = (0, _shared.children)(li);

			a = (0, _shared.claimElement)(li_nodes, "A", { href: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, "Featured");
			a_nodes.forEach(_shared.detachNode);
			li_nodes.forEach(_shared.detachNode);

			li_1 = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_1_nodes = (0, _shared.children)(li_1);

			a_1 = (0, _shared.claimElement)(li_1_nodes, "A", { href: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			text_1 = (0, _shared.claimText)(a_1_nodes, "Map\n            ");
			if (if_block) if_block.l(a_1_nodes);
			a_1_nodes.forEach(_shared.detachNode);
			li_1_nodes.forEach(_shared.detachNode);
			ul_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			(0, _shared.addListener)(a, "click", click_handler);
			a.href = "?view=featured";
			a.className = a_class_value = "featured " + (state.view === 'featured' ? 'active' : '');
			(0, _shared.addListener)(a_1, "click", click_handler_1);
			a_1.href = "?view=map";
			a_1.className = a_1_class_value = "distance " + (state.view === 'map' ? 'active' : '');
			ul.className = "cf";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(ul, target, anchor);
			(0, _shared.appendNode)(li, ul);
			(0, _shared.appendNode)(a, li);
			(0, _shared.appendNode)(text, a);
			(0, _shared.appendNode)(li_1, ul);
			(0, _shared.appendNode)(a_1, li_1);
			(0, _shared.appendNode)(text_1, a_1);
			if (if_block) if_block.m(a_1, null);
		},

		p: function update(changed, state) {
			if (changed.view && a_class_value !== (a_class_value = "featured " + (state.view === 'featured' ? 'active' : ''))) {
				a.className = a_class_value;
			}

			if (state.$isGeolocating) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_5(component, state);
					if_block.c();
					if_block.m(a_1, null);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (changed.view && a_1_class_value !== (a_1_class_value = "distance " + (state.view === 'map' ? 'active' : ''))) {
				a_1.className = a_1_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(ul);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			(0, _shared.removeListener)(a, "click", click_handler);
			if (if_block) if_block.d();
			(0, _shared.removeListener)(a_1, "click", click_handler_1);
		}
	};
}

// (50:6) {{#each allListsItems as i @airtableId}}
function create_each_block(component, key_1, state) {
	var i = state.i,
	    each_value = state.each_value,
	    i_index = state.i_index;
	var li,
	    a,
	    text,
	    span,
	    text_1_value = i.title || i.name,
	    text_1,
	    a_href_value,
	    li_data_id_value,
	    li_class_value;

	var if_block = i.mainImageLocal && create_if_block_7(component, state);

	return {
		key: key_1,

		first: null,

		c: function create() {
			li = (0, _shared.createElement)("li");
			a = (0, _shared.createElement)("a");
			if (if_block) if_block.c();
			text = (0, _shared.createText)("\n\n            ");
			span = (0, _shared.createElement)("span");
			text_1 = (0, _shared.createText)(text_1_value);
			this.h();
		},

		l: function claim(nodes) {
			li = (0, _shared.claimElement)(nodes, "LI", { "data-id": true, class: true }, false);
			var li_nodes = (0, _shared.children)(li);

			a = (0, _shared.claimElement)(li_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			if (if_block) if_block.l(a_nodes);
			text = (0, _shared.claimText)(a_nodes, "\n\n            ");

			span = (0, _shared.claimElement)(a_nodes, "SPAN", {}, false);
			var span_nodes = (0, _shared.children)(span);

			text_1 = (0, _shared.claimText)(span_nodes, text_1_value);
			span_nodes.forEach(_shared.detachNode);
			a_nodes.forEach(_shared.detachNode);
			li_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + i.filename;
			(0, _shared.addListener)(li, "mouseover", mouseover_handler);
			li.dataset.id = li_data_id_value = i.id;
			li.className = li_class_value = "" + (i.inView ? 'in-view' : '') + " " + (i.inFocus ? 'in-focus' : '');

			li._svelte = {
				component: component,
				each_value: state.each_value,
				i_index: state.i_index
			};

			this.first = li;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(li, target, anchor);
			(0, _shared.appendNode)(a, li);
			if (if_block) if_block.m(a, null);
			(0, _shared.appendNode)(text, a);
			(0, _shared.appendNode)(span, a);
			(0, _shared.appendNode)(text_1, span);
		},

		p: function update(changed, state) {
			i = state.i;
			each_value = state.each_value;
			i_index = state.i_index;
			if (i.mainImageLocal) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_7(component, state);
					if_block.c();
					if_block.m(a, text);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (changed.allListsItems && text_1_value !== (text_1_value = i.title || i.name)) {
				text_1.data = text_1_value;
			}

			if ((changed.data || changed.allListsItems) && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + i.filename)) {
				a.href = a_href_value;
			}

			if (changed.allListsItems && li_data_id_value !== (li_data_id_value = i.id)) {
				li.dataset.id = li_data_id_value;
			}

			if (changed.allListsItems && li_class_value !== (li_class_value = "" + (i.inView ? 'in-view' : '') + " " + (i.inFocus ? 'in-focus' : ''))) {
				li.className = li_class_value;
			}

			li._svelte.each_value = state.each_value;
			li._svelte.i_index = state.i_index;
		},

		u: function unmount() {
			(0, _shared.detachNode)(li);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			(0, _shared.removeListener)(li, "mouseover", mouseover_handler);
		}
	};
}

// (54:14) {{#if $isBrowser && $offline}}
function create_if_block_8(component, state) {
	var i = state.i,
	    each_value = state.each_value,
	    i_index = state.i_index;
	var img, img_alt_value, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.alt = img_alt_value = i.imageDescription ? i.imageDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + i.mainVisual.replace('.jpg', '-600px.jpg');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			i = state.i;
			each_value = state.each_value;
			i_index = state.i_index;
			if (changed.allListsItems && img_alt_value !== (img_alt_value = i.imageDescription ? i.imageDescription : '')) {
				img.alt = img_alt_value;
			}

			if ((changed.data || changed.allListsItems) && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + i.mainVisual.replace('.jpg', '-600px.jpg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (58:14) {{else}}
function create_if_block_9(component, state) {
	var i = state.i,
	    each_value = state.each_value,
	    i_index = state.i_index;
	var picture, source, source_srcset_value, text, source_1, source_1_srcset_value, text_1, img, img_alt_value, img_src_value;

	return {
		c: function create() {
			picture = (0, _shared.createElement)("picture");
			source = (0, _shared.createElement)("source");
			text = (0, _shared.createText)("\n                  ");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n                  ");
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			picture = (0, _shared.claimElement)(nodes, "PICTURE", {}, false);
			var picture_nodes = (0, _shared.children)(picture);

			source = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(picture_nodes, "\n                  ");

			source_1 = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(picture_nodes, "\n                  ");

			img = (0, _shared.claimElement)(picture_nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			picture_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.type = "image/webp";
			(0, _shared.setAttribute)(source, "srcset", source_srcset_value = srcset(state.data.basePath, i.mainImageLocal, 'webp'));
			source.sizes = "100vw";
			source_1.type = "image/jpeg";
			(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value = srcset(state.data.basePath, i.mainImageLocal));
			source_1.sizes = "100vw";
			img.alt = img_alt_value = i.imageDescription ? i.imageDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + i.mainImageLocal;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(picture, target, anchor);
			(0, _shared.appendNode)(source, picture);
			(0, _shared.appendNode)(text, picture);
			(0, _shared.appendNode)(source_1, picture);
			(0, _shared.appendNode)(text_1, picture);
			(0, _shared.appendNode)(img, picture);
		},

		p: function update(changed, state) {
			i = state.i;
			each_value = state.each_value;
			i_index = state.i_index;
			if ((changed.data || changed.allListsItems) && source_srcset_value !== (source_srcset_value = srcset(state.data.basePath, i.mainImageLocal, 'webp'))) {
				(0, _shared.setAttribute)(source, "srcset", source_srcset_value);
			}

			if ((changed.data || changed.allListsItems) && source_1_srcset_value !== (source_1_srcset_value = srcset(state.data.basePath, i.mainImageLocal))) {
				(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value);
			}

			if (changed.allListsItems && img_alt_value !== (img_alt_value = i.imageDescription ? i.imageDescription : '')) {
				img.alt = img_alt_value;
			}

			if ((changed.data || changed.allListsItems) && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + i.mainImageLocal)) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(picture);
		},

		d: _shared.noop
	};
}

// (53:12) {{#if i.mainImageLocal }}
function create_if_block_7(component, state) {
	var i = state.i,
	    each_value = state.each_value,
	    i_index = state.i_index;
	var if_block_anchor;

	function select_block_type_2(state) {
		if (state.$isBrowser && state.$offline) return create_if_block_8;
		return create_if_block_9;
	}

	var current_block_type = select_block_type_2(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			i = state.i;
			each_value = state.each_value;
			i_index = state.i_index;
			if (current_block_type === (current_block_type = select_block_type_2(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},

		u: function unmount() {
			if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (81:4) {{#if data.ad}}
function create_if_block_10(component, state) {

	var ad_initial_data = { ad: state.data.ad };
	var ad = new _ad2.default({
		root: component.root,
		data: ad_initial_data
	});

	return {
		c: function create() {
			ad._fragment.c();
		},

		l: function claim(nodes) {
			ad._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			ad._mount(target, anchor);
		},

		p: function update(changed, state) {
			var ad_changes = {};
			if (changed.data) ad_changes.ad = state.data.ad;
			ad._set(ad_changes);
		},

		u: function unmount() {
			ad._unmount();
		},

		d: function destroy() {
			ad.destroy(false);
		}
	};
}

// (48:2) {{#if view === 'featured'}}
function create_if_block_6(component, state) {
	var ul,
	    each_blocks_1 = [],
	    each_lookup = (0, _shared.blankObject)(),
	    text,
	    if_block_anchor;

	var each_value = state.allListsItems;

	for (var i = 0; i < each_value.length; i += 1) {
		var key = each_value[i].airtableId;
		each_blocks_1[i] = each_lookup[key] = create_each_block(component, key, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value: each_value,
			i: each_value[i],
			i_index: i
		}));
	}

	var if_block = state.data.ad && create_if_block_10(component, state);

	return {
		c: function create() {
			ul = (0, _shared.createElement)("ul");

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}text = (0, _shared.createText)("\n\n    ");
			if (if_block) if_block.c();
			if_block_anchor = (0, _shared.createComment)();
			this.h();
		},

		l: function claim(nodes) {
			ul = (0, _shared.claimElement)(nodes, "UL", { class: true }, false);
			var ul_nodes = (0, _shared.children)(ul);

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(ul_nodes);
			}ul_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(nodes, "\n\n    ");
			if (if_block) if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
			this.h();
		},

		h: function hydrate() {
			ul.className = "groups-items";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(ul, target, anchor);

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(ul, null);
			}(0, _shared.insertNode)(text, target, anchor);
			if (if_block) if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			var each_value = state.allListsItems;

			each_blocks_1 = (0, _shared.updateKeyedEach)(each_blocks_1, component, changed, "airtableId", 1, each_value, each_lookup, ul, false, create_each_block, "m", null, function (i) {
				return (0, _shared.assign)((0, _shared.assign)({}, state), {
					each_value: each_value,
					i: each_value[i],
					i_index: i
				});
			});

			if (state.data.ad) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_10(component, state);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(ul);
			(0, _shared.detachNode)(text);
			if (if_block) if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}if (if_block) if_block.d();
		}
	};
}

// (94:10) {{#each allItems as i @airtableId}}
function create_each_block_1(component, key_1, state) {
	var i = state.i,
	    each_value_1 = state.each_value_1,
	    i_index_1 = state.i_index_1;
	var first;

	var item_initial_data = {
		data: i,
		utils: state.utils,
		display: "map",
		view: state.view,
		content: state.content
	};
	var item = new _items2.default({
		root: component.root,
		data: item_initial_data
	});

	return {
		key: key_1,

		first: null,

		c: function create() {
			first = (0, _shared.createComment)();
			item._fragment.c();
			this.h();
		},

		l: function claim(nodes) {
			first = (0, _shared.createComment)();
			item._fragment.l(nodes);
			this.h();
		},

		h: function hydrate() {
			this.first = first;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(first, target, anchor);
			item._mount(target, anchor);
		},

		p: function update(changed, state) {
			i = state.i;
			each_value_1 = state.each_value_1;
			i_index_1 = state.i_index_1;
			var item_changes = {};
			if (changed.allItems) item_changes.data = i;
			if (changed.utils) item_changes.utils = state.utils;
			if (changed.view) item_changes.view = state.view;
			if (changed.content) item_changes.content = state.content;
			item._set(item_changes);
		},

		u: function unmount() {
			(0, _shared.detachNode)(first);
			item._unmount();
		},

		d: function destroy() {
			item.destroy(false);
		}
	};
}

// (93:8) {{#if allItems}}
function create_if_block_12(component, state) {
	var each_blocks_1 = [],
	    each_lookup = (0, _shared.blankObject)(),
	    each_anchor;

	var each_value_1 = state.allItems;

	for (var i = 0; i < each_value_1.length; i += 1) {
		var key = each_value_1[i].airtableId;
		each_blocks_1[i] = each_lookup[key] = create_each_block_1(component, key, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value_1: each_value_1,
			i: each_value_1[i],
			i_index_1: i
		}));
	}

	return {
		c: function create() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}each_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(nodes);
			}each_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(target, anchor);
			}(0, _shared.insertNode)(each_anchor, target, anchor);
		},

		p: function update(changed, state) {
			var each_value_1 = state.allItems;

			each_blocks_1 = (0, _shared.updateKeyedEach)(each_blocks_1, component, changed, "airtableId", 1, each_value_1, each_lookup, each_anchor.parentNode, false, create_each_block_1, "m", each_anchor, function (i) {
				return (0, _shared.assign)((0, _shared.assign)({}, state), {
					each_value_1: each_value_1,
					i: each_value_1[i],
					i_index_1: i
				});
			});
		},

		u: function unmount() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].u();
			}(0, _shared.detachNode)(each_anchor);
		},

		d: function destroy() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}
		}
	};
}

// (100:8) {{#if data.ad}}
function create_if_block_13(component, state) {

	var ad_initial_data = { ad: state.data.ad };
	var ad = new _ad2.default({
		root: component.root,
		data: ad_initial_data
	});

	return {
		c: function create() {
			ad._fragment.c();
		},

		l: function claim(nodes) {
			ad._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			ad._mount(target, anchor);
		},

		p: function update(changed, state) {
			var ad_changes = {};
			if (changed.data) ad_changes.ad = state.data.ad;
			ad._set(ad_changes);
		},

		u: function unmount() {
			ad._unmount();
		},

		d: function destroy() {
			ad.destroy(false);
		}
	};
}

// (86:2) {{#if view === 'map'}}
function create_if_block_11(component, state) {
	var div, div_1, text, div_2, text_1;

	var map_initial_data = {
		locations: state.mapLocations,
		inView: state.locationsInView,
		zoom: 11,
		focusUserPosition: false,
		itemContainer: ".map-items",
		goToOffset: -0.2
	};
	var map = new _map2.default({
		root: component.root,
		slots: { default: (0, _shared.createFragment)() },
		data: map_initial_data
	});

	var if_block = state.allItems && create_if_block_12(component, state);

	var if_block_1 = state.data.ad && create_if_block_13(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			div_1 = (0, _shared.createElement)("div");
			map._fragment.c();
			text = (0, _shared.createText)("\n\n      ");
			div_2 = (0, _shared.createElement)("div");
			if (if_block) if_block.c();
			text_1 = (0, _shared.createText)("\n\n        ");
			if (if_block_1) if_block_1.c();
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			div_1 = (0, _shared.claimElement)(div_nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			map._fragment.l(div_1_nodes);
			div_1_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(div_nodes, "\n\n      ");

			div_2 = (0, _shared.claimElement)(div_nodes, "DIV", { class: true }, false);
			var div_2_nodes = (0, _shared.children)(div_2);

			if (if_block) if_block.l(div_2_nodes);
			text_1 = (0, _shared.claimText)(div_2_nodes, "\n\n        ");
			if (if_block_1) if_block_1.l(div_2_nodes);
			div_2_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div_1.className = "map-wrapper";
			div_2.className = "map-items";
			div.className = "map-items-container";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(div_1, div);
			map._mount(div_1, null);
			(0, _shared.appendNode)(text, div);
			(0, _shared.appendNode)(div_2, div);
			if (if_block) if_block.m(div_2, null);
			(0, _shared.appendNode)(text_1, div_2);
			if (if_block_1) if_block_1.m(div_2, null);
		},

		p: function update(changed, state) {
			var map_changes = {};
			if (changed.mapLocations) map_changes.locations = state.mapLocations;
			if (changed.locationsInView) map_changes.inView = state.locationsInView;
			map_changes.focusUserPosition = false;
			map._set(map_changes);

			if (state.allItems) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_12(component, state);
					if_block.c();
					if_block.m(div_2, text_1);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (state.data.ad) {
				if (if_block_1) {
					if_block_1.p(changed, state);
				} else {
					if_block_1 = create_if_block_13(component, state);
					if_block_1.c();
					if_block_1.m(div_2, null);
				}
			} else if (if_block_1) {
				if_block_1.u();
				if_block_1.d();
				if_block_1 = null;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
			if (if_block) if_block.u();
			if (if_block_1) if_block_1.u();
		},

		d: function destroy() {
			map.destroy(false);
			if (if_block) if_block.d();
			if (if_block_1) if_block_1.d();
		}
	};
}

function mouseover_handler(event) {
	var component = this._svelte.component;
	var each_value = this._svelte.each_value,
	    i_index = this._svelte.i_index,
	    i = each_value[i_index];
	component.hoverItem(event, i);
}

function Groups(options) {
	(0, _shared.init)(this, options);
	this._state = (0, _shared.assign)((0, _shared.assign)(this.store._init(["isBrowser", "offline", "isGeolocating"]), data()), options.data);
	this.store._add(this, ["isBrowser", "offline", "isGeolocating"]);
	this._recompute({ data: 1, allItems: 1 }, this._state);

	this._handlers.destroy = [ondestroy, _shared.removeFromStore];

	var self = this;
	var _oncreate = function _oncreate() {
		var changed = { data: 1, allItems: 1, view: 1, mapLocations: 1, locationsInView: 1, $isBrowser: 1, $offline: 1, hasLocations: 1, $isGeolocating: 1, allListsItems: 1, utils: 1, content: 1 };
		oncreate.call(self);
		self.fire("update", { changed: changed, current: self._state });
	};

	if (!options.root) {
		this._oncreate = [];
		this._beforecreate = [];
		this._aftercreate = [];
	}

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(_oncreate);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);

		this._lock = true;
		(0, _shared.callAll)(this._beforecreate);
		(0, _shared.callAll)(this._oncreate);
		(0, _shared.callAll)(this._aftercreate);
		this._lock = false;
	}
}

(0, _shared.assign)(Groups.prototype, _shared.proto);
(0, _shared.assign)(Groups.prototype, methods_1);

Groups.prototype._recompute = function _recompute(changed, state) {
	if (changed.data) {
		if (this._differs(state.allListsItems, state.allListsItems = allListsItems(state.data))) changed.allListsItems = true;
	}

	if (changed.allItems) {
		if (this._differs(state.mapLocations, state.mapLocations = mapLocations(state.allItems))) changed.mapLocations = true;
		if (this._differs(state.hasLocations, state.hasLocations = hasLocations(state.allItems))) changed.hasLocations = true;
	}
};
exports.default = Groups;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/index.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _helpers = __webpack_require__(2);

var _helpers2 = _interopRequireDefault(_helpers);

var _methods = __webpack_require__(1);

var _methods2 = _interopRequireDefault(_methods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function data() {
	return {
		isBrowser: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined,
		started: false,
		videoBackgroundSize: "900",
		videoBackgroundOrientation: "landscape"
	};
};

var srcset = _helpers2.default.srcset;

var facebookURL = _helpers2.default.facebookURL;

var twitterURL = _helpers2.default.twitterURL;

var emailURL = _helpers2.default.emailURL;

var smsURL = _helpers2.default.smsURL;

var methods_1 = {
	// Determine oreientation and width for video
	responsiveVideo: function responsiveVideo() {
		// Determine width
		var windowWidth = window.innerWidth;
		var widths = ["300", "600", "900", "1200", "2000"];
		var width = widths[0];
		for (var i = 0; i < widths.length - 1; i++) {
			if (windowWidth > parseInt(widths[i], 10) && windowWidth <= parseInt(widths[i + 1], 10)) {
				width = widths[i + 1];
				break;
			}
		}

		// Ideally we would get the orientation based on the aspect
		// ratio, but the CSS in _mixins that defines full_view
		// just uses the lg breakpoint
		var orientation = window.matchMedia("(min-width: 992px)").matches ? "landscape" : "portrait";

		this.set({
			videoBackgroundSize: width,
			videoBackgroundOrientation: orientation
		});
	},


	// Video ended
	videoEnded: function videoEnded(prop, e) {
		var p = {};
		p[prop] = true;
		this.set(p);
	},

	// Go to groups/menu
	goToGroups: function goToGroups(e) {
		var _this = this;

		if (e && e.preventDefault) {
			e.preventDefault();
		}
		var u = this.get("utils");
		this.set({ started: true });

		// Yay, ads!
		if (u && this.REALLYINTHEWAY() && this.refs.INTHEWAY) {
			u.goTo(this.refs.INTHEWAY);
			setTimeout(function () {
				u.goTo(_this.refs.groupNavigation);
			}, 2800);
		} else if (u && this.refs.groupNavigation) {
			u.goTo(this.refs.groupNavigation);
		}
	},

	// Check if ad is showing
	REALLYINTHEWAY: function REALLYINTHEWAY() {
		if (this.refs.INTHEWAY) {
			var styles = window.getComputedStyle(this.refs.INTHEWAY, null);
			return styles.getPropertyValue("display") !== "none";
		}
	}
};

function oncreate() {
	var _this2 = this;

	// Set size of video
	this.responsiveVideo();

	// Checking for autoplay is silly, just try to play
	setTimeout(function () {
		try {
			_this2.refs.introVideo.play().then(function () {
				_this2.set({ canAutoplay: true, introVideoPlaying: true });
			}).catch(function (e) {
				//console.error(e);
				_this2.set({ canAutoplay: false, introVideoPlaying: false });
			});
		} catch (e) {
			console.error(e);
			_this2.set({ canAutoplay: false, introVideoPlaying: false });
		}
	}, 400);
};

function create_main_fragment(component, state) {
	var div,
	    section,
	    div_1,
	    div_2,
	    video,
	    source,
	    source_src_value,
	    source_1,
	    source_1_src_value,
	    video_class_value,
	    text_1,
	    div_3,
	    text_2,
	    div_4,
	    img,
	    text_3,
	    span,
	    text_4,
	    text_6,
	    div_5,
	    h1,
	    span_1,
	    text_7,
	    text_8,
	    span_2,
	    text_9,
	    text_12,
	    div_6,
	    a,
	    text_13,
	    section_class_value,
	    text_17,
	    section_1,
	    div_7,
	    div_8,
	    text_18,
	    div_9,
	    img_1,
	    text_19,
	    span_3,
	    text_20,
	    text_22,
	    h1_1,
	    span_4,
	    text_23_value = state.data.title,
	    text_23,
	    text_24,
	    div_10,
	    text_26,
	    div_11,
	    div_12,
	    a_1,
	    span_5,
	    text_27,
	    a_1_href_value,
	    text_29,
	    a_2,
	    span_6,
	    text_30,
	    a_2_href_value,
	    text_32,
	    a_3,
	    span_7,
	    text_33,
	    a_3_href_value,
	    text_35,
	    a_4,
	    span_8,
	    text_36,
	    a_4_href_value,
	    div_class_value;

	function ended_handler(event) {
		component.videoEnded('introVideoEnded', event);
	}

	function click_handler(event) {
		component.goToGroups(event);
	}

	var each_value = state.data.groups;

	var each_blocks = [];

	for (var i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(component, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value: each_value,
			g: each_value[i],
			g_index: i
		}));
	}

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			section = (0, _shared.createElement)("section");
			div_1 = (0, _shared.createElement)("div");
			div_2 = (0, _shared.createElement)("div");
			video = (0, _shared.createElement)("video");
			source = (0, _shared.createElement)("source");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n\n      ");
			div_3 = (0, _shared.createElement)("div");
			text_2 = (0, _shared.createText)("\n\n      ");
			div_4 = (0, _shared.createElement)("div");
			img = (0, _shared.createElement)("img");
			text_3 = (0, _shared.createText)("\n        ");
			span = (0, _shared.createElement)("span");
			text_4 = (0, _shared.createText)("Star Tribune");
			text_6 = (0, _shared.createText)("\n\n      ");
			div_5 = (0, _shared.createElement)("div");
			h1 = (0, _shared.createElement)("h1");
			span_1 = (0, _shared.createElement)("span");
			text_7 = (0, _shared.createText)("Final Four 2019");
			text_8 = (0, _shared.createText)("\n          ");
			span_2 = (0, _shared.createElement)("span");
			text_9 = (0, _shared.createText)("Essential Twin Cities Guide");
			text_12 = (0, _shared.createText)("\n\n      ");
			div_6 = (0, _shared.createElement)("div");
			a = (0, _shared.createElement)("a");
			text_13 = (0, _shared.createText)("Get started");
			text_17 = (0, _shared.createText)("\n\n  \n\n  ");
			section_1 = (0, _shared.createElement)("section");
			div_7 = (0, _shared.createElement)("div");
			div_8 = (0, _shared.createElement)("div");
			text_18 = (0, _shared.createText)("\n\n      ");
			div_9 = (0, _shared.createElement)("div");
			img_1 = (0, _shared.createElement)("img");
			text_19 = (0, _shared.createText)("\n        ");
			span_3 = (0, _shared.createElement)("span");
			text_20 = (0, _shared.createText)("Star Tribune");
			text_22 = (0, _shared.createText)("\n\n      ");
			h1_1 = (0, _shared.createElement)("h1");
			span_4 = (0, _shared.createElement)("span");
			text_23 = (0, _shared.createText)(text_23_value);
			text_24 = (0, _shared.createText)("\n\n      ");
			div_10 = (0, _shared.createElement)("div");

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			text_26 = (0, _shared.createText)("\n\n      ");
			div_11 = (0, _shared.createElement)("div");
			div_12 = (0, _shared.createElement)("div");
			a_1 = (0, _shared.createElement)("a");
			span_5 = (0, _shared.createElement)("span");
			text_27 = (0, _shared.createText)("Share on Facebook");
			text_29 = (0, _shared.createText)("\n          ");
			a_2 = (0, _shared.createElement)("a");
			span_6 = (0, _shared.createElement)("span");
			text_30 = (0, _shared.createText)("Share on Twitter");
			text_32 = (0, _shared.createText)("\n          ");
			a_3 = (0, _shared.createElement)("a");
			span_7 = (0, _shared.createElement)("span");
			text_33 = (0, _shared.createText)("Share via email");
			text_35 = (0, _shared.createText)("\n          ");
			a_4 = (0, _shared.createElement)("a");
			span_8 = (0, _shared.createElement)("span");
			text_36 = (0, _shared.createText)("Share via SMS");
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			section = (0, _shared.claimElement)(div_nodes, "SECTION", { class: true }, false);
			var section_nodes = (0, _shared.children)(section);

			div_1 = (0, _shared.claimElement)(section_nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			div_2 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_2_nodes = (0, _shared.children)(div_2);

			video = (0, _shared.claimElement)(div_2_nodes, "VIDEO", { muted: true, playsinline: true, autoplay: true, id: true, class: true }, false);
			var video_nodes = (0, _shared.children)(video);

			source = (0, _shared.claimElement)(video_nodes, "SOURCE", { src: true, type: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);

			source_1 = (0, _shared.claimElement)(video_nodes, "SOURCE", { src: true, type: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			video_nodes.forEach(_shared.detachNode);
			div_2_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			div_3 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_3_nodes = (0, _shared.children)(div_3);

			div_3_nodes.forEach(_shared.detachNode);
			text_2 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			div_4 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_4_nodes = (0, _shared.children)(div_4);

			img = (0, _shared.claimElement)(div_4_nodes, "IMG", { src: true, alt: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			text_3 = (0, _shared.claimText)(div_4_nodes, "\n        ");

			span = (0, _shared.claimElement)(div_4_nodes, "SPAN", { class: true }, false);
			var span_nodes = (0, _shared.children)(span);

			text_4 = (0, _shared.claimText)(span_nodes, "Star Tribune");
			span_nodes.forEach(_shared.detachNode);
			div_4_nodes.forEach(_shared.detachNode);
			text_6 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			div_5 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_5_nodes = (0, _shared.children)(div_5);

			h1 = (0, _shared.claimElement)(div_5_nodes, "H1", { class: true }, false);
			var h1_nodes = (0, _shared.children)(h1);

			span_1 = (0, _shared.claimElement)(h1_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			text_7 = (0, _shared.claimText)(span_1_nodes, "Final Four 2019");
			span_1_nodes.forEach(_shared.detachNode);
			text_8 = (0, _shared.claimText)(h1_nodes, "\n          ");

			span_2 = (0, _shared.claimElement)(h1_nodes, "SPAN", { class: true }, false);
			var span_2_nodes = (0, _shared.children)(span_2);

			text_9 = (0, _shared.claimText)(span_2_nodes, "Essential Twin Cities Guide");
			span_2_nodes.forEach(_shared.detachNode);
			h1_nodes.forEach(_shared.detachNode);
			div_5_nodes.forEach(_shared.detachNode);
			text_12 = (0, _shared.claimText)(div_1_nodes, "\n\n      ");

			div_6 = (0, _shared.claimElement)(div_1_nodes, "DIV", { class: true }, false);
			var div_6_nodes = (0, _shared.children)(div_6);

			a = (0, _shared.claimElement)(div_6_nodes, "A", { href: true, class: true, id: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text_13 = (0, _shared.claimText)(a_nodes, "Get started");
			a_nodes.forEach(_shared.detachNode);
			div_6_nodes.forEach(_shared.detachNode);
			div_1_nodes.forEach(_shared.detachNode);
			section_nodes.forEach(_shared.detachNode);
			text_17 = (0, _shared.claimText)(div_nodes, "\n\n  \n\n  ");

			section_1 = (0, _shared.claimElement)(div_nodes, "SECTION", { id: true, class: true }, false);
			var section_1_nodes = (0, _shared.children)(section_1);

			div_7 = (0, _shared.claimElement)(section_1_nodes, "DIV", { class: true }, false);
			var div_7_nodes = (0, _shared.children)(div_7);

			div_8 = (0, _shared.claimElement)(div_7_nodes, "DIV", { class: true }, false);
			var div_8_nodes = (0, _shared.children)(div_8);

			div_8_nodes.forEach(_shared.detachNode);
			text_18 = (0, _shared.claimText)(div_7_nodes, "\n\n      ");

			div_9 = (0, _shared.claimElement)(div_7_nodes, "DIV", { class: true }, false);
			var div_9_nodes = (0, _shared.children)(div_9);

			img_1 = (0, _shared.claimElement)(div_9_nodes, "IMG", { src: true, alt: true }, false);
			var img_1_nodes = (0, _shared.children)(img_1);

			img_1_nodes.forEach(_shared.detachNode);
			text_19 = (0, _shared.claimText)(div_9_nodes, "\n        ");

			span_3 = (0, _shared.claimElement)(div_9_nodes, "SPAN", { class: true }, false);
			var span_3_nodes = (0, _shared.children)(span_3);

			text_20 = (0, _shared.claimText)(span_3_nodes, "Star Tribune");
			span_3_nodes.forEach(_shared.detachNode);
			div_9_nodes.forEach(_shared.detachNode);
			text_22 = (0, _shared.claimText)(div_7_nodes, "\n\n      ");

			h1_1 = (0, _shared.claimElement)(div_7_nodes, "H1", { class: true }, false);
			var h1_1_nodes = (0, _shared.children)(h1_1);

			span_4 = (0, _shared.claimElement)(h1_1_nodes, "SPAN", {}, false);
			var span_4_nodes = (0, _shared.children)(span_4);

			text_23 = (0, _shared.claimText)(span_4_nodes, text_23_value);
			span_4_nodes.forEach(_shared.detachNode);
			h1_1_nodes.forEach(_shared.detachNode);
			text_24 = (0, _shared.claimText)(div_7_nodes, "\n\n      ");

			div_10 = (0, _shared.claimElement)(div_7_nodes, "DIV", { class: true }, false);
			var div_10_nodes = (0, _shared.children)(div_10);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_10_nodes);
			}

			div_10_nodes.forEach(_shared.detachNode);
			text_26 = (0, _shared.claimText)(div_7_nodes, "\n\n      ");

			div_11 = (0, _shared.claimElement)(div_7_nodes, "DIV", { class: true }, false);
			var div_11_nodes = (0, _shared.children)(div_11);

			div_12 = (0, _shared.claimElement)(div_11_nodes, "DIV", { class: true }, false);
			var div_12_nodes = (0, _shared.children)(div_12);

			a_1 = (0, _shared.claimElement)(div_12_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			span_5 = (0, _shared.claimElement)(a_1_nodes, "SPAN", { class: true }, false);
			var span_5_nodes = (0, _shared.children)(span_5);

			text_27 = (0, _shared.claimText)(span_5_nodes, "Share on Facebook");
			span_5_nodes.forEach(_shared.detachNode);
			a_1_nodes.forEach(_shared.detachNode);
			text_29 = (0, _shared.claimText)(div_12_nodes, "\n          ");

			a_2 = (0, _shared.claimElement)(div_12_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_2_nodes = (0, _shared.children)(a_2);

			span_6 = (0, _shared.claimElement)(a_2_nodes, "SPAN", { class: true }, false);
			var span_6_nodes = (0, _shared.children)(span_6);

			text_30 = (0, _shared.claimText)(span_6_nodes, "Share on Twitter");
			span_6_nodes.forEach(_shared.detachNode);
			a_2_nodes.forEach(_shared.detachNode);
			text_32 = (0, _shared.claimText)(div_12_nodes, "\n          ");

			a_3 = (0, _shared.claimElement)(div_12_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_3_nodes = (0, _shared.children)(a_3);

			span_7 = (0, _shared.claimElement)(a_3_nodes, "SPAN", { class: true }, false);
			var span_7_nodes = (0, _shared.children)(span_7);

			text_33 = (0, _shared.claimText)(span_7_nodes, "Share via email");
			span_7_nodes.forEach(_shared.detachNode);
			a_3_nodes.forEach(_shared.detachNode);
			text_35 = (0, _shared.claimText)(div_12_nodes, "\n          ");

			a_4 = (0, _shared.claimElement)(div_12_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_4_nodes = (0, _shared.children)(a_4);

			span_8 = (0, _shared.claimElement)(a_4_nodes, "SPAN", { class: true }, false);
			var span_8_nodes = (0, _shared.children)(span_8);

			text_36 = (0, _shared.claimText)(span_8_nodes, "Share via SMS");
			span_8_nodes.forEach(_shared.detachNode);
			a_4_nodes.forEach(_shared.detachNode);
			div_12_nodes.forEach(_shared.detachNode);
			div_11_nodes.forEach(_shared.detachNode);
			div_7_nodes.forEach(_shared.detachNode);
			section_1_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.src = source_src_value = "./assets/videos/final-four-" + state.videoBackgroundOrientation + "-" + state.videoBackgroundSize + ".webm";
			source.type = "video/webm";
			source_1.src = source_1_src_value = "./assets/videos/final-four-" + state.videoBackgroundOrientation + "-" + state.videoBackgroundSize + ".mp4";
			source_1.type = "video/mp4";
			(0, _shared.addListener)(video, "ended", ended_handler);
			video.muted = true;
			(0, _shared.setAttribute)(video, "playsinline", true);
			video.autoplay = true;
			video.id = "index-section-video-background";
			video.className = video_class_value = state.introVideoEnded ? 'ended' : state.introVideoPlaying ? 'playing' : '';
			div_2.className = "index-section-background index-section-video-background";
			div_3.className = "index-section-background index-section-image-background";
			img.src = "./assets/images/strib/strib-name-star-black.svg";
			img.alt = "Star Tribune logo";
			span.className = "sr-only";
			div_4.className = "title-logo";
			span_1.className = "super-bowl";
			span_2.className = "guide";
			h1.className = "sr-only";
			div_5.className = "vertical-center";
			(0, _shared.addListener)(a, "click", click_handler);
			a.href = "#group-navigation-anchor";
			a.className = "get-started";
			a.id = "start-button";
			div_6.className = "vertical-bottom";
			div_1.className = "index-section-inner";
			section.className = section_class_value = "splash index-section " + (state.canAutoplay ? 'can-autoplay' : '') + " " + (state.canAutoplay === false ? 'cannot-autoplay' : '') + " " + (state.introVideoEnded ? 'intro-video-ended' : '');
			div_8.className = "index-section-background";
			img_1.src = "./assets/images/strib/strib-name-star-white.svg";
			img_1.alt = "Star Tribune logo";
			span_3.className = "sr-only";
			div_9.className = "title-logo";
			h1_1.className = "main-nav-heading";
			div_10.className = "vertical-center main-nav-groups cf";
			span_5.className = "sr-only";
			a_1.href = a_1_href_value = facebookURL(state.data, state.content);
			a_1.target = "_blank";
			a_1.rel = "noopener";
			a_1.className = "facebook-button";
			span_6.className = "sr-only";
			a_2.href = a_2_href_value = twitterURL(state.data, state.content);
			a_2.target = "_blank";
			a_2.rel = "noopener";
			a_2.className = "twitter-button";
			span_7.className = "sr-only";
			a_3.href = a_3_href_value = emailURL(state.data, state.content);
			a_3.target = "_blank";
			a_3.rel = "noopener";
			a_3.className = "email-button";
			span_8.className = "sr-only";
			a_4.href = a_4_href_value = smsURL(state.data, state.content);
			a_4.target = "_blank";
			a_4.rel = "noopener";
			a_4.className = "sms-button";
			div_12.className = "social-buttons";
			div_11.className = "vertical-bottom";
			div_7.className = "index-section-inner";
			section_1.id = "group-navigation-anchor";
			section_1.className = "group-navigation index-section";
			div.className = div_class_value = "component component-index " + (state.started ? 'is-started' : '') + " " + (state.$sameReferrer && state.$visits && state.$visits.repeat ? 'repeat-visitor' : '');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(section, div);
			(0, _shared.appendNode)(div_1, section);
			(0, _shared.appendNode)(div_2, div_1);
			(0, _shared.appendNode)(video, div_2);
			(0, _shared.appendNode)(source, video);
			(0, _shared.appendNode)(source_1, video);
			component.refs.introVideo = video;
			(0, _shared.appendNode)(text_1, div_1);
			(0, _shared.appendNode)(div_3, div_1);
			(0, _shared.appendNode)(text_2, div_1);
			(0, _shared.appendNode)(div_4, div_1);
			(0, _shared.appendNode)(img, div_4);
			(0, _shared.appendNode)(text_3, div_4);
			(0, _shared.appendNode)(span, div_4);
			(0, _shared.appendNode)(text_4, span);
			(0, _shared.appendNode)(text_6, div_1);
			(0, _shared.appendNode)(div_5, div_1);
			(0, _shared.appendNode)(h1, div_5);
			(0, _shared.appendNode)(span_1, h1);
			(0, _shared.appendNode)(text_7, span_1);
			(0, _shared.appendNode)(text_8, h1);
			(0, _shared.appendNode)(span_2, h1);
			(0, _shared.appendNode)(text_9, span_2);
			(0, _shared.appendNode)(text_12, div_1);
			(0, _shared.appendNode)(div_6, div_1);
			(0, _shared.appendNode)(a, div_6);
			(0, _shared.appendNode)(text_13, a);
			(0, _shared.appendNode)(text_17, div);
			(0, _shared.appendNode)(section_1, div);
			(0, _shared.appendNode)(div_7, section_1);
			(0, _shared.appendNode)(div_8, div_7);
			(0, _shared.appendNode)(text_18, div_7);
			(0, _shared.appendNode)(div_9, div_7);
			(0, _shared.appendNode)(img_1, div_9);
			(0, _shared.appendNode)(text_19, div_9);
			(0, _shared.appendNode)(span_3, div_9);
			(0, _shared.appendNode)(text_20, span_3);
			(0, _shared.appendNode)(text_22, div_7);
			(0, _shared.appendNode)(h1_1, div_7);
			(0, _shared.appendNode)(span_4, h1_1);
			(0, _shared.appendNode)(text_23, span_4);
			(0, _shared.appendNode)(text_24, div_7);
			(0, _shared.appendNode)(div_10, div_7);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div_10, null);
			}

			(0, _shared.appendNode)(text_26, div_7);
			(0, _shared.appendNode)(div_11, div_7);
			(0, _shared.appendNode)(div_12, div_11);
			(0, _shared.appendNode)(a_1, div_12);
			(0, _shared.appendNode)(span_5, a_1);
			(0, _shared.appendNode)(text_27, span_5);
			(0, _shared.appendNode)(text_29, div_12);
			(0, _shared.appendNode)(a_2, div_12);
			(0, _shared.appendNode)(span_6, a_2);
			(0, _shared.appendNode)(text_30, span_6);
			(0, _shared.appendNode)(text_32, div_12);
			(0, _shared.appendNode)(a_3, div_12);
			(0, _shared.appendNode)(span_7, a_3);
			(0, _shared.appendNode)(text_33, span_7);
			(0, _shared.appendNode)(text_35, div_12);
			(0, _shared.appendNode)(a_4, div_12);
			(0, _shared.appendNode)(span_8, a_4);
			(0, _shared.appendNode)(text_36, span_8);
			component.refs.groupNavigation = section_1;
		},

		p: function update(changed, state) {
			if ((changed.videoBackgroundOrientation || changed.videoBackgroundSize) && source_src_value !== (source_src_value = "./assets/videos/final-four-" + state.videoBackgroundOrientation + "-" + state.videoBackgroundSize + ".webm")) {
				source.src = source_src_value;
			}

			if ((changed.videoBackgroundOrientation || changed.videoBackgroundSize) && source_1_src_value !== (source_1_src_value = "./assets/videos/final-four-" + state.videoBackgroundOrientation + "-" + state.videoBackgroundSize + ".mp4")) {
				source_1.src = source_1_src_value;
			}

			if ((changed.introVideoEnded || changed.introVideoPlaying) && video_class_value !== (video_class_value = state.introVideoEnded ? 'ended' : state.introVideoPlaying ? 'playing' : '')) {
				video.className = video_class_value;
			}

			if ((changed.canAutoplay || changed.introVideoEnded) && section_class_value !== (section_class_value = "splash index-section " + (state.canAutoplay ? 'can-autoplay' : '') + " " + (state.canAutoplay === false ? 'cannot-autoplay' : '') + " " + (state.introVideoEnded ? 'intro-video-ended' : ''))) {
				section.className = section_class_value;
			}

			if (changed.data && text_23_value !== (text_23_value = state.data.title)) {
				text_23.data = text_23_value;
			}

			var each_value = state.data.groups;

			if (changed.data) {
				for (var i = 0; i < each_value.length; i += 1) {
					var each_context = (0, _shared.assign)((0, _shared.assign)({}, state), {
						each_value: each_value,
						g: each_value[i],
						g_index: i
					});

					if (each_blocks[i]) {
						each_blocks[i].p(changed, each_context);
					} else {
						each_blocks[i] = create_each_block(component, each_context);
						each_blocks[i].c();
						each_blocks[i].m(div_10, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].u();
					each_blocks[i].d();
				}
				each_blocks.length = each_value.length;
			}

			if ((changed.data || changed.content) && a_1_href_value !== (a_1_href_value = facebookURL(state.data, state.content))) {
				a_1.href = a_1_href_value;
			}

			if ((changed.data || changed.content) && a_2_href_value !== (a_2_href_value = twitterURL(state.data, state.content))) {
				a_2.href = a_2_href_value;
			}

			if ((changed.data || changed.content) && a_3_href_value !== (a_3_href_value = emailURL(state.data, state.content))) {
				a_3.href = a_3_href_value;
			}

			if ((changed.data || changed.content) && a_4_href_value !== (a_4_href_value = smsURL(state.data, state.content))) {
				a_4.href = a_4_href_value;
			}

			if ((changed.started || changed.$sameReferrer || changed.$visits) && div_class_value !== (div_class_value = "component component-index " + (state.started ? 'is-started' : '') + " " + (state.$sameReferrer && state.$visits && state.$visits.repeat ? 'repeat-visitor' : ''))) {
				div.className = div_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);

			for (var i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].u();
			}
		},

		d: function destroy() {
			(0, _shared.removeListener)(video, "ended", ended_handler);
			if (component.refs.introVideo === video) component.refs.introVideo = null;
			(0, _shared.removeListener)(a, "click", click_handler);

			(0, _shared.destroyEach)(each_blocks);

			if (component.refs.groupNavigation === section_1) component.refs.groupNavigation = null;
		}
	};
}

// (59:8) {{#each data.groups as g}}
function create_each_block(component, state) {
	var g = state.g,
	    each_value = state.each_value,
	    g_index = state.g_index;
	var div,
	    a,
	    span,
	    text_value = g.title,
	    text,
	    a_href_value;

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			a = (0, _shared.createElement)("a");
			span = (0, _shared.createElement)("span");
			text = (0, _shared.createText)(text_value);
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			a = (0, _shared.claimElement)(div_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			span = (0, _shared.claimElement)(a_nodes, "SPAN", {}, false);
			var span_nodes = (0, _shared.children)(span);

			text = (0, _shared.claimText)(span_nodes, text_value);
			span_nodes.forEach(_shared.detachNode);
			a_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + g.filename;
			div.className = "group";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(a, div);
			(0, _shared.appendNode)(span, a);
			(0, _shared.appendNode)(text, span);
		},

		p: function update(changed, state) {
			g = state.g;
			each_value = state.each_value;
			g_index = state.g_index;
			if (changed.data && text_value !== (text_value = g.title)) {
				text.data = text_value;
			}

			if (changed.data && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + g.filename)) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: _shared.noop
	};
}

function Index(options) {
	(0, _shared.init)(this, options);
	this.refs = {};
	this._state = (0, _shared.assign)((0, _shared.assign)(this.store._init(["sameReferrer", "visits"]), data()), options.data);
	this.store._add(this, ["sameReferrer", "visits"]);

	this._handlers.destroy = [_shared.removeFromStore];

	var self = this;
	var _oncreate = function _oncreate() {
		var changed = { started: 1, $sameReferrer: 1, $visits: 1, canAutoplay: 1, introVideoEnded: 1, introVideoPlaying: 1, videoBackgroundOrientation: 1, videoBackgroundSize: 1, data: 1, content: 1 };
		oncreate.call(self);
		self.fire("update", { changed: changed, current: self._state });
	};

	if (!options.root) {
		this._oncreate = [];
	}

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(_oncreate);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);

		(0, _shared.callAll)(this._oncreate);
	}
}

(0, _shared.assign)(Index.prototype, _shared.proto);
(0, _shared.assign)(Index.prototype, methods_1);
exports.default = Index;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* app/svelte-components/lists.html generated by Svelte v1.64.1 */


var _shared = __webpack_require__(0);

var _helpers = __webpack_require__(2);

var _helpers2 = _interopRequireDefault(_helpers);

var _methods = __webpack_require__(1);

var _methods2 = _interopRequireDefault(_methods);

var _observe = __webpack_require__(5);

var _observe2 = _interopRequireDefault(_observe);

var _items = __webpack_require__(3);

var _items2 = _interopRequireDefault(_items);

var _map = __webpack_require__(7);

var _map2 = _interopRequireDefault(_map);

var _ad = __webpack_require__(4);

var _ad2 = _interopRequireDefault(_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasLocations(data) {
	return data.items ? !!data.items.find(function (i) {
		return i && i.latitude && i.longitude;
	}) : false;
};

function mapLocations(data) {
	return data.items ? data.items.map(function (i) {
		return {
			id: i.id,
			content: i.name || i.title,
			lat: parseFloat(i.latitude),
			lng: parseFloat(i.longitude)
		};
	}) : [];
};

function data() {
	return {
		isBrowser: (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined,
		view: "alpha"
	};
};

var escapeHTML = _helpers2.default.escapeHTML;

var srcset = _helpers2.default.srcset;

var fullByline = _helpers2.default.fullByline;

var facebookURL = _helpers2.default.facebookURL;

var twitterURL = _helpers2.default.twitterURL;

var emailURL = _helpers2.default.emailURL;

var smsURL = _helpers2.default.smsURL;

var methods_1 = {
	startQueryRouter: _methods2.default.startQueryRouter,
	eventSet: _methods2.default.eventSet,
	goTo: _methods2.default.goTo,

	// Handle when an item is observed
	observeItem: function observeItem(id) {
		var currentID = this.get("observeMapItemID");
		if (currentID && id && currentID === id) {
			return;
		}

		var data = this.get("data");
		var item = _.find(data.items, { id: id });

		// Mark as in view
		if (id) {
			this.set({ inViewID: id });
		}

		// Update image
		if (id && item && item.mainImageLocal) {
			data.mainVisual = item.mainImageLocal;
			data.mainVisualDescription = item.imageDescription;
			this.set({ data: data });
		}

		this.set({ observeMapItemID: id });
	},

	// Sort items by alpha
	sortAlpha: function sortAlpha() {
		var d = this.get("data");
		d.items = _.sortBy(d.items, function (i) {
			return i.title || i.name;
		});
		this.set({ data: d });
	},

	// Sort items by distance
	sortDistance: function sortDistance() {
		var _this = this;

		// Since we depend on browers geolocation, check for browser
		if (!this.get("isBrowser")) {
			return;
		}

		// Geolocate and sort
		this.store.geolocate().then(function (position) {
			var d = _this.get("data");
			d.items = _.sortBy(d.items, function (i) {
				return i.distance || 99999;
			});
			_this.set({ data: d, geoloationError: false });
		}).catch(function (error) {
			_this.set({ geoloationError: true });
			console.error(error);
		});
	}
};

function oncreate() {
	var _this2 = this;

	// Use query router for view
	this.startQueryRouter(["view"], { view: "alpha" });

	// In theory, we should be more specific and watch for any changes
	// in data.items, but this is a simple look to see if the length has
	// changed.
	this.observe("data", function (n, o) {
		// Observe list
		if (_this2.get("isBrowser") && (n && n.items && o && o.items && n.items.length !== o.items.length || !o)) {
			if (_this2.__itemObserver) {
				_this2.__itemObserver.stop();
				_this2.__itemObserver.addElements(document.querySelectorAll(".item-list .component-item"));
			} else {
				_this2.__itemObserver = (0, _observe2.default)({
					visibleThreshold: 0.75,
					elements: document.querySelectorAll(".item-list .component-item"),
					onObserve: _.bind(_this2.observeItem, _this2),
					throttle: false
				});
			}
		}
	});

	// Watch for in view change.
	this.observe("inViewID", function (n, o) {
		if (n && n !== o) {
			var _data = _this2.get("data");
			var item = _.find(_data.items, { id: n });

			if (item) {
				_data.items.forEach(function (i) {
					i.inView = i.id === n ? true : false;
				});
				_this2.set({
					data: _data,
					locationsInView: item.latitude && item.longitude ? [n] : []
				});
			}
		}
	});

	// Handle view change
	this.observe("view", function (n, o) {
		if (n && n !== o) {
			if (n === "distance") {
				_this2.sortDistance();
			} else {
				_this2.sortAlpha();
			}
		}
	});
};

function ondestroy() {
	var u = this.get("utils");
	if (u) {
		u.stopGeolocate();
	}
};

function create_main_fragment(component, state) {
	var div,
	    text_1,
	    div_1,
	    nav,
	    text_2,
	    text_4,
	    article,
	    h1,
	    text_5_value = state.data.title,
	    text_5,
	    text_6,
	    div_2,
	    text_8,
	    div_3,
	    a,
	    span,
	    text_9,
	    a_href_value,
	    text_11,
	    a_1,
	    span_1,
	    text_12,
	    a_1_href_value,
	    text_14,
	    a_2,
	    span_2,
	    text_15,
	    a_2_href_value,
	    text_17,
	    a_3,
	    span_3,
	    text_18,
	    a_3_href_value,
	    text_21,
	    div_4,
	    raw_value = state.data.description,
	    text_22,
	    text_23,
	    text_24;

	function select_block_type_1(state) {
		if (state.view === 'distance') return create_if_block;
		if (state.data.mainVisual) return create_if_block_1;
		return null;
	}

	var current_block_type = select_block_type_1(state);
	var if_block = current_block_type && current_block_type(component, state);

	var if_block_2 = state.data.groups && state.data.groups[0] && create_if_block_4(component, state);

	var if_block_3 = state.hasLocations && create_if_block_5(component, state);

	function select_block_type_2(state) {
		if (fullByline(state.data)) return create_if_block_7;
		return create_if_block_8;
	}

	var current_block_type_1 = select_block_type_2(state);
	var if_block_4 = current_block_type_1(component, state);

	function select_block_type_3(state) {
		if (state.utils && state.utils.hasGeolocate && !state.geoloationError) return create_if_block_9;
		if (state.geoloationError) return create_if_block_11;
		return null;
	}

	var current_block_type_2 = select_block_type_3(state);
	var if_block_5 = current_block_type_2 && current_block_type_2(component, state);

	function select_block_type_4(state) {
		if (state.data.items) return create_if_block_12;
		return create_if_block_13;
	}

	var current_block_type_3 = select_block_type_4(state);
	var if_block_7 = current_block_type_3(component, state);

	var if_block_8 = state.data.ad && create_if_block_14(component, state);

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			if (if_block) if_block.c();
			text_1 = (0, _shared.createText)("\n\n");
			div_1 = (0, _shared.createElement)("div");
			nav = (0, _shared.createElement)("nav");
			if (if_block_2) if_block_2.c();
			text_2 = (0, _shared.createText)("\n\n    ");
			if (if_block_3) if_block_3.c();
			text_4 = (0, _shared.createText)("\n\n  ");
			article = (0, _shared.createElement)("article");
			h1 = (0, _shared.createElement)("h1");
			text_5 = (0, _shared.createText)(text_5_value);
			text_6 = (0, _shared.createText)("\n\n    ");
			div_2 = (0, _shared.createElement)("div");
			if_block_4.c();
			text_8 = (0, _shared.createText)("\n\n    ");
			div_3 = (0, _shared.createElement)("div");
			a = (0, _shared.createElement)("a");
			span = (0, _shared.createElement)("span");
			text_9 = (0, _shared.createText)("Share on Facebook");
			text_11 = (0, _shared.createText)("\n      ");
			a_1 = (0, _shared.createElement)("a");
			span_1 = (0, _shared.createElement)("span");
			text_12 = (0, _shared.createText)("Share on Twitter");
			text_14 = (0, _shared.createText)("\n      ");
			a_2 = (0, _shared.createElement)("a");
			span_2 = (0, _shared.createElement)("span");
			text_15 = (0, _shared.createText)("Share via email");
			text_17 = (0, _shared.createText)("\n      ");
			a_3 = (0, _shared.createElement)("a");
			span_3 = (0, _shared.createElement)("span");
			text_18 = (0, _shared.createText)("Share via SMS");
			text_21 = (0, _shared.createText)("\n\n    ");
			div_4 = (0, _shared.createElement)("div");
			text_22 = (0, _shared.createText)("\n\n    ");
			if (if_block_5) if_block_5.c();
			text_23 = (0, _shared.createText)("\n\n    ");
			if_block_7.c();
			text_24 = (0, _shared.createText)("\n\n    ");
			if (if_block_8) if_block_8.c();
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			if (if_block) if_block.l(div_nodes);
			div_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(nodes, "\n\n");

			div_1 = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_1_nodes = (0, _shared.children)(div_1);

			nav = (0, _shared.claimElement)(div_1_nodes, "NAV", { class: true }, false);
			var nav_nodes = (0, _shared.children)(nav);

			if (if_block_2) if_block_2.l(nav_nodes);
			text_2 = (0, _shared.claimText)(nav_nodes, "\n\n    ");
			if (if_block_3) if_block_3.l(nav_nodes);
			nav_nodes.forEach(_shared.detachNode);
			text_4 = (0, _shared.claimText)(div_1_nodes, "\n\n  ");

			article = (0, _shared.claimElement)(div_1_nodes, "ARTICLE", { class: true }, false);
			var article_nodes = (0, _shared.children)(article);

			h1 = (0, _shared.claimElement)(article_nodes, "H1", { class: true }, false);
			var h1_nodes = (0, _shared.children)(h1);

			text_5 = (0, _shared.claimText)(h1_nodes, text_5_value);
			h1_nodes.forEach(_shared.detachNode);
			text_6 = (0, _shared.claimText)(article_nodes, "\n\n    ");

			div_2 = (0, _shared.claimElement)(article_nodes, "DIV", { class: true }, false);
			var div_2_nodes = (0, _shared.children)(div_2);

			if_block_4.l(div_2_nodes);
			div_2_nodes.forEach(_shared.detachNode);
			text_8 = (0, _shared.claimText)(article_nodes, "\n\n    ");

			div_3 = (0, _shared.claimElement)(article_nodes, "DIV", { class: true }, false);
			var div_3_nodes = (0, _shared.children)(div_3);

			a = (0, _shared.claimElement)(div_3_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			span = (0, _shared.claimElement)(a_nodes, "SPAN", { class: true }, false);
			var span_nodes = (0, _shared.children)(span);

			text_9 = (0, _shared.claimText)(span_nodes, "Share on Facebook");
			span_nodes.forEach(_shared.detachNode);
			a_nodes.forEach(_shared.detachNode);
			text_11 = (0, _shared.claimText)(div_3_nodes, "\n      ");

			a_1 = (0, _shared.claimElement)(div_3_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			span_1 = (0, _shared.claimElement)(a_1_nodes, "SPAN", { class: true }, false);
			var span_1_nodes = (0, _shared.children)(span_1);

			text_12 = (0, _shared.claimText)(span_1_nodes, "Share on Twitter");
			span_1_nodes.forEach(_shared.detachNode);
			a_1_nodes.forEach(_shared.detachNode);
			text_14 = (0, _shared.claimText)(div_3_nodes, "\n      ");

			a_2 = (0, _shared.claimElement)(div_3_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_2_nodes = (0, _shared.children)(a_2);

			span_2 = (0, _shared.claimElement)(a_2_nodes, "SPAN", { class: true }, false);
			var span_2_nodes = (0, _shared.children)(span_2);

			text_15 = (0, _shared.claimText)(span_2_nodes, "Share via email");
			span_2_nodes.forEach(_shared.detachNode);
			a_2_nodes.forEach(_shared.detachNode);
			text_17 = (0, _shared.claimText)(div_3_nodes, "\n      ");

			a_3 = (0, _shared.claimElement)(div_3_nodes, "A", { href: true, target: true, rel: true, class: true }, false);
			var a_3_nodes = (0, _shared.children)(a_3);

			span_3 = (0, _shared.claimElement)(a_3_nodes, "SPAN", { class: true }, false);
			var span_3_nodes = (0, _shared.children)(span_3);

			text_18 = (0, _shared.claimText)(span_3_nodes, "Share via SMS");
			span_3_nodes.forEach(_shared.detachNode);
			a_3_nodes.forEach(_shared.detachNode);
			div_3_nodes.forEach(_shared.detachNode);
			text_21 = (0, _shared.claimText)(article_nodes, "\n\n    ");

			div_4 = (0, _shared.claimElement)(article_nodes, "DIV", { class: true }, false);
			var div_4_nodes = (0, _shared.children)(div_4);

			div_4_nodes.forEach(_shared.detachNode);
			text_22 = (0, _shared.claimText)(article_nodes, "\n\n    ");
			if (if_block_5) if_block_5.l(article_nodes);
			text_23 = (0, _shared.claimText)(article_nodes, "\n\n    ");
			if_block_7.l(article_nodes);
			text_24 = (0, _shared.claimText)(article_nodes, "\n\n    ");
			if (if_block_8) if_block_8.l(article_nodes);
			article_nodes.forEach(_shared.detachNode);
			div_1_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "main-visual";
			nav.className = "minor-navigation items-2 minor-nav-lists";
			h1.className = "heading-alternate";
			div_2.className = "byline";
			span.className = "sr-only";
			a.href = a_href_value = facebookURL(state.data, state.content);
			a.target = "_blank";
			a.rel = "noopener";
			a.className = "facebook-button";
			span_1.className = "sr-only";
			a_1.href = a_1_href_value = twitterURL(state.data, state.content);
			a_1.target = "_blank";
			a_1.rel = "noopener";
			a_1.className = "twitter-button";
			span_2.className = "sr-only";
			a_2.href = a_2_href_value = emailURL(state.data, state.content);
			a_2.target = "_blank";
			a_2.rel = "noopener";
			a_2.className = "email-button";
			span_3.className = "sr-only";
			a_3.href = a_3_href_value = smsURL(state.data, state.content);
			a_3.target = "_blank";
			a_3.rel = "noopener";
			a_3.className = "sms-button";
			div_3.className = "social-buttons social-buttons-gray";
			div_4.className = "article-description";
			article.className = "lists";
			div_1.className = "component component-list has-minor-navigation";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			if (if_block) if_block.m(div, null);
			(0, _shared.insertNode)(text_1, target, anchor);
			(0, _shared.insertNode)(div_1, target, anchor);
			(0, _shared.appendNode)(nav, div_1);
			if (if_block_2) if_block_2.m(nav, null);
			(0, _shared.appendNode)(text_2, nav);
			if (if_block_3) if_block_3.m(nav, null);
			(0, _shared.appendNode)(text_4, div_1);
			(0, _shared.appendNode)(article, div_1);
			(0, _shared.appendNode)(h1, article);
			(0, _shared.appendNode)(text_5, h1);
			(0, _shared.appendNode)(text_6, article);
			(0, _shared.appendNode)(div_2, article);
			if_block_4.m(div_2, null);
			(0, _shared.appendNode)(text_8, article);
			(0, _shared.appendNode)(div_3, article);
			(0, _shared.appendNode)(a, div_3);
			(0, _shared.appendNode)(span, a);
			(0, _shared.appendNode)(text_9, span);
			(0, _shared.appendNode)(text_11, div_3);
			(0, _shared.appendNode)(a_1, div_3);
			(0, _shared.appendNode)(span_1, a_1);
			(0, _shared.appendNode)(text_12, span_1);
			(0, _shared.appendNode)(text_14, div_3);
			(0, _shared.appendNode)(a_2, div_3);
			(0, _shared.appendNode)(span_2, a_2);
			(0, _shared.appendNode)(text_15, span_2);
			(0, _shared.appendNode)(text_17, div_3);
			(0, _shared.appendNode)(a_3, div_3);
			(0, _shared.appendNode)(span_3, a_3);
			(0, _shared.appendNode)(text_18, span_3);
			(0, _shared.appendNode)(text_21, article);
			(0, _shared.appendNode)(div_4, article);
			div_4.innerHTML = raw_value;
			(0, _shared.appendNode)(text_22, article);
			if (if_block_5) if_block_5.m(article, null);
			(0, _shared.appendNode)(text_23, article);
			if_block_7.m(article, null);
			(0, _shared.appendNode)(text_24, article);
			if (if_block_8) if_block_8.m(article, null);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type_1(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if (if_block) {
					if_block.u();
					if_block.d();
				}
				if_block = current_block_type && current_block_type(component, state);
				if (if_block) if_block.c();
				if (if_block) if_block.m(div, null);
			}

			if (state.data.groups && state.data.groups[0]) {
				if (if_block_2) {
					if_block_2.p(changed, state);
				} else {
					if_block_2 = create_if_block_4(component, state);
					if_block_2.c();
					if_block_2.m(nav, text_2);
				}
			} else if (if_block_2) {
				if_block_2.u();
				if_block_2.d();
				if_block_2 = null;
			}

			if (state.hasLocations) {
				if (if_block_3) {
					if_block_3.p(changed, state);
				} else {
					if_block_3 = create_if_block_5(component, state);
					if_block_3.c();
					if_block_3.m(nav, null);
				}
			} else if (if_block_3) {
				if_block_3.u();
				if_block_3.d();
				if_block_3 = null;
			}

			if (changed.data && text_5_value !== (text_5_value = state.data.title)) {
				text_5.data = text_5_value;
			}

			if (current_block_type_1 === (current_block_type_1 = select_block_type_2(state)) && if_block_4) {
				if_block_4.p(changed, state);
			} else {
				if_block_4.u();
				if_block_4.d();
				if_block_4 = current_block_type_1(component, state);
				if_block_4.c();
				if_block_4.m(div_2, null);
			}

			if ((changed.data || changed.content) && a_href_value !== (a_href_value = facebookURL(state.data, state.content))) {
				a.href = a_href_value;
			}

			if ((changed.data || changed.content) && a_1_href_value !== (a_1_href_value = twitterURL(state.data, state.content))) {
				a_1.href = a_1_href_value;
			}

			if ((changed.data || changed.content) && a_2_href_value !== (a_2_href_value = emailURL(state.data, state.content))) {
				a_2.href = a_2_href_value;
			}

			if ((changed.data || changed.content) && a_3_href_value !== (a_3_href_value = smsURL(state.data, state.content))) {
				a_3.href = a_3_href_value;
			}

			if (changed.data && raw_value !== (raw_value = state.data.description)) {
				div_4.innerHTML = raw_value;
			}

			if (current_block_type_2 === (current_block_type_2 = select_block_type_3(state)) && if_block_5) {
				if_block_5.p(changed, state);
			} else {
				if (if_block_5) {
					if_block_5.u();
					if_block_5.d();
				}
				if_block_5 = current_block_type_2 && current_block_type_2(component, state);
				if (if_block_5) if_block_5.c();
				if (if_block_5) if_block_5.m(article, text_23);
			}

			if (current_block_type_3 === (current_block_type_3 = select_block_type_4(state)) && if_block_7) {
				if_block_7.p(changed, state);
			} else {
				if_block_7.u();
				if_block_7.d();
				if_block_7 = current_block_type_3(component, state);
				if_block_7.c();
				if_block_7.m(article, text_24);
			}

			if (state.data.ad) {
				if (if_block_8) {
					if_block_8.p(changed, state);
				} else {
					if_block_8 = create_if_block_14(component, state);
					if_block_8.c();
					if_block_8.m(article, null);
				}
			} else if (if_block_8) {
				if_block_8.u();
				if_block_8.d();
				if_block_8 = null;
			}
		},

		u: function unmount() {
			div_4.innerHTML = '';

			(0, _shared.detachNode)(div);
			if (if_block) if_block.u();
			(0, _shared.detachNode)(text_1);
			(0, _shared.detachNode)(div_1);
			if (if_block_2) if_block_2.u();
			if (if_block_3) if_block_3.u();
			if_block_4.u();
			if (if_block_5) if_block_5.u();
			if_block_7.u();
			if (if_block_8) if_block_8.u();
		},

		d: function destroy() {
			if (if_block) if_block.d();
			if (if_block_2) if_block_2.d();
			if (if_block_3) if_block_3.d();
			if_block_4.d();
			if (if_block_5) if_block_5.d();
			if_block_7.d();
			if (if_block_8) if_block_8.d();
		}
	};
}

// (5:4) {{#if $isBrowser && $offline}}
function create_if_block_2(component, state) {
	var img, img_alt_value, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual.replace('.jpg', '-600px.jpg');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual.replace('.jpg', '-600px.jpg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (9:4) {{else}}
function create_if_block_3(component, state) {
	var picture, source, source_srcset_value, text, source_1, source_1_srcset_value, text_1, img, img_alt_value, img_src_value;

	return {
		c: function create() {
			picture = (0, _shared.createElement)("picture");
			source = (0, _shared.createElement)("source");
			text = (0, _shared.createText)("\n        ");
			source_1 = (0, _shared.createElement)("source");
			text_1 = (0, _shared.createText)("\n        ");
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			picture = (0, _shared.claimElement)(nodes, "PICTURE", {}, false);
			var picture_nodes = (0, _shared.children)(picture);

			source = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_nodes = (0, _shared.children)(source);

			source_nodes.forEach(_shared.detachNode);
			text = (0, _shared.claimText)(picture_nodes, "\n        ");

			source_1 = (0, _shared.claimElement)(picture_nodes, "SOURCE", { type: true, srcset: true, sizes: true }, false);
			var source_1_nodes = (0, _shared.children)(source_1);

			source_1_nodes.forEach(_shared.detachNode);
			text_1 = (0, _shared.claimText)(picture_nodes, "\n        ");

			img = (0, _shared.claimElement)(picture_nodes, "IMG", { alt: true, src: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			picture_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			source.type = "image/webp";
			(0, _shared.setAttribute)(source, "srcset", source_srcset_value = srcset(state.data.basePath, state.data.mainVisual, 'webp'));
			source.sizes = "100vw";
			source_1.type = "image/jpeg";
			(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value = srcset(state.data.basePath, state.data.mainVisual));
			source_1.sizes = "100vw";
			img.alt = img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '';
			img.src = img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(picture, target, anchor);
			(0, _shared.appendNode)(source, picture);
			(0, _shared.appendNode)(text, picture);
			(0, _shared.appendNode)(source_1, picture);
			(0, _shared.appendNode)(text_1, picture);
			(0, _shared.appendNode)(img, picture);
		},

		p: function update(changed, state) {
			if (changed.data && source_srcset_value !== (source_srcset_value = srcset(state.data.basePath, state.data.mainVisual, 'webp'))) {
				(0, _shared.setAttribute)(source, "srcset", source_srcset_value);
			}

			if (changed.data && source_1_srcset_value !== (source_1_srcset_value = srcset(state.data.basePath, state.data.mainVisual))) {
				(0, _shared.setAttribute)(source_1, "srcset", source_1_srcset_value);
			}

			if (changed.data && img_alt_value !== (img_alt_value = state.data.mainVisualDescription ? state.data.mainVisualDescription : '')) {
				img.alt = img_alt_value;
			}

			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/" + state.data.mainVisual)) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(picture);
		},

		d: _shared.noop
	};
}

// (2:2) {{#if view === 'distance'}}
function create_if_block(component, state) {

	var map_initial_data = {
		locations: state.mapLocations,
		inView: state.locationsInView,
		zoom: 10,
		goToOffset: -0.2
	};
	var map = new _map2.default({
		root: component.root,
		data: map_initial_data
	});

	return {
		c: function create() {
			map._fragment.c();
		},

		l: function claim(nodes) {
			map._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			map._mount(target, anchor);
		},

		p: function update(changed, state) {
			var map_changes = {};
			if (changed.mapLocations) map_changes.locations = state.mapLocations;
			if (changed.locationsInView) map_changes.inView = state.locationsInView;
			map._set(map_changes);
		},

		u: function unmount() {
			map._unmount();
		},

		d: function destroy() {
			map.destroy(false);
		}
	};
}

// (4:28) 
function create_if_block_1(component, state) {
	var if_block_anchor;

	function select_block_type(state) {
		if (state.$isBrowser && state.$offline) return create_if_block_2;
		return create_if_block_3;
	}

	var current_block_type = select_block_type(state);
	var if_block = current_block_type(component, state);

	return {
		c: function create() {
			if_block.c();
			if_block_anchor = (0, _shared.createComment)();
		},

		l: function claim(nodes) {
			if_block.l(nodes);
			if_block_anchor = (0, _shared.createComment)();
		},

		m: function mount(target, anchor) {
			if_block.m(target, anchor);
			(0, _shared.insertNode)(if_block_anchor, target, anchor);
		},

		p: function update(changed, state) {
			if (current_block_type === (current_block_type = select_block_type(state)) && if_block) {
				if_block.p(changed, state);
			} else {
				if_block.u();
				if_block.d();
				if_block = current_block_type(component, state);
				if_block.c();
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},

		u: function unmount() {
			if_block.u();
			(0, _shared.detachNode)(if_block_anchor);
		},

		d: function destroy() {
			if_block.d();
		}
	};
}

// (29:4) {{#if data.groups && data.groups[0] }}
function create_if_block_4(component, state) {
	var h1,
	    a,
	    text_value = state.data.groups[0].title,
	    text,
	    a_href_value;

	return {
		c: function create() {
			h1 = (0, _shared.createElement)("h1");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)(text_value);
			this.h();
		},

		l: function claim(nodes) {
			h1 = (0, _shared.claimElement)(nodes, "H1", {}, false);
			var h1_nodes = (0, _shared.children)(h1);

			a = (0, _shared.claimElement)(h1_nodes, "A", { href: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, text_value);
			a_nodes.forEach(_shared.detachNode);
			h1_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			a.href = a_href_value = "" + state.data.basePath + "/" + state.data.groups[0].filename;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(h1, target, anchor);
			(0, _shared.appendNode)(a, h1);
			(0, _shared.appendNode)(text, a);
		},

		p: function update(changed, state) {
			if (changed.data && text_value !== (text_value = state.data.groups[0].title)) {
				text.data = text_value;
			}

			if (changed.data && a_href_value !== (a_href_value = "" + state.data.basePath + "/" + state.data.groups[0].filename)) {
				a.href = a_href_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(h1);
		},

		d: _shared.noop
	};
}

// (39:12) {{#if $isGeolocating}}
function create_if_block_6(component, state) {
	var img, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { class: true, src: true, alt: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.className = "loading-icon";
			img.src = img_src_value = "" + state.data.basePath + "/assets/images/icons/loading.svg";
			img.alt = "Loading icon";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && img_src_value !== (img_src_value = "" + state.data.basePath + "/assets/images/icons/loading.svg")) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (33:4) {{#if hasLocations}}
function create_if_block_5(component, state) {
	var ul, li, a, text, a_class_value, li_1, a_1, text_1, a_1_class_value;

	function click_handler(event) {
		component.eventSet(event, { view: 'alpha' });
	}

	var if_block = state.$isGeolocating && create_if_block_6(component, state);

	function click_handler_1(event) {
		component.eventSet(event, { view: 'distance' });
	}

	return {
		c: function create() {
			ul = (0, _shared.createElement)("ul");
			li = (0, _shared.createElement)("li");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)("Alphabetical");
			li_1 = (0, _shared.createElement)("li");
			a_1 = (0, _shared.createElement)("a");
			text_1 = (0, _shared.createText)("Map\n            ");
			if (if_block) if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			ul = (0, _shared.claimElement)(nodes, "UL", { class: true }, false);
			var ul_nodes = (0, _shared.children)(ul);

			li = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_nodes = (0, _shared.children)(li);

			a = (0, _shared.claimElement)(li_nodes, "A", { href: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, "Alphabetical");
			a_nodes.forEach(_shared.detachNode);
			li_nodes.forEach(_shared.detachNode);

			li_1 = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_1_nodes = (0, _shared.children)(li_1);

			a_1 = (0, _shared.claimElement)(li_1_nodes, "A", { href: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			text_1 = (0, _shared.claimText)(a_1_nodes, "Map\n            ");
			if (if_block) if_block.l(a_1_nodes);
			a_1_nodes.forEach(_shared.detachNode);
			li_1_nodes.forEach(_shared.detachNode);
			ul_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			(0, _shared.addListener)(a, "click", click_handler);
			a.href = "?view=alpha";
			a.className = a_class_value = "alphabetical " + (state.view === 'alpha' ? 'active' : '');
			(0, _shared.addListener)(a_1, "click", click_handler_1);
			a_1.href = "?view=distance";
			a_1.className = a_1_class_value = "distance " + (state.view === 'distance' ? 'active' : '');
			ul.className = "cf";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(ul, target, anchor);
			(0, _shared.appendNode)(li, ul);
			(0, _shared.appendNode)(a, li);
			(0, _shared.appendNode)(text, a);
			(0, _shared.appendNode)(li_1, ul);
			(0, _shared.appendNode)(a_1, li_1);
			(0, _shared.appendNode)(text_1, a_1);
			if (if_block) if_block.m(a_1, null);
		},

		p: function update(changed, state) {
			if (changed.view && a_class_value !== (a_class_value = "alphabetical " + (state.view === 'alpha' ? 'active' : ''))) {
				a.className = a_class_value;
			}

			if (state.$isGeolocating) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_6(component, state);
					if_block.c();
					if_block.m(a_1, null);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (changed.view && a_1_class_value !== (a_1_class_value = "distance " + (state.view === 'distance' ? 'active' : ''))) {
				a_1.className = a_1_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(ul);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			(0, _shared.removeListener)(a, "click", click_handler);
			if (if_block) if_block.d();
			(0, _shared.removeListener)(a_1, "click", click_handler_1);
		}
	};
}

// (52:6) {{#if fullByline(data)}}
function create_if_block_7(component, state) {
	var raw_value = state.data.byline,
	    raw_before,
	    raw_after;

	return {
		c: function create() {
			raw_before = (0, _shared.createElement)('noscript');
			raw_after = (0, _shared.createElement)('noscript');
		},

		l: function claim(nodes) {
			raw_before = (0, _shared.createElement)('noscript');
			raw_after = (0, _shared.createElement)('noscript');
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(raw_before, target, anchor);
			raw_before.insertAdjacentHTML("afterend", raw_value);
			(0, _shared.insertNode)(raw_after, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && raw_value !== (raw_value = state.data.byline)) {
				(0, _shared.detachBetween)(raw_before, raw_after);
				raw_before.insertAdjacentHTML("afterend", raw_value);
			}
		},

		u: function unmount() {
			(0, _shared.detachBetween)(raw_before, raw_after);

			(0, _shared.detachNode)(raw_before);
			(0, _shared.detachNode)(raw_after);
		},

		d: _shared.noop
	};
}

// (54:6) {{else}}
function create_if_block_8(component, state) {
	var strong,
	    text,
	    text_1_value = escapeHTML(state.data.byline),
	    text_1,
	    text_2;

	return {
		c: function create() {
			strong = (0, _shared.createElement)("strong");
			text = (0, _shared.createText)("By ");
			text_1 = (0, _shared.createText)(text_1_value);
			text_2 = (0, _shared.createText)(" • Star Tribune");
		},

		l: function claim(nodes) {
			strong = (0, _shared.claimElement)(nodes, "STRONG", {}, false);
			var strong_nodes = (0, _shared.children)(strong);

			text = (0, _shared.claimText)(strong_nodes, "By ");
			text_1 = (0, _shared.claimText)(strong_nodes, text_1_value);
			strong_nodes.forEach(_shared.detachNode);
			text_2 = (0, _shared.claimText)(nodes, " • Star Tribune");
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(strong, target, anchor);
			(0, _shared.appendNode)(text, strong);
			(0, _shared.appendNode)(text_1, strong);
			(0, _shared.insertNode)(text_2, target, anchor);
		},

		p: function update(changed, state) {
			if (changed.data && text_1_value !== (text_1_value = escapeHTML(state.data.byline))) {
				text_1.data = text_1_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(strong);
			(0, _shared.detachNode)(text_2);
		},

		d: _shared.noop
	};
}

// (83:14) {{#if $isGeolocating}}
function create_if_block_10(component, state) {
	var img, img_src_value;

	return {
		c: function create() {
			img = (0, _shared.createElement)("img");
			this.h();
		},

		l: function claim(nodes) {
			img = (0, _shared.claimElement)(nodes, "IMG", { class: true, src: true, alt: true }, false);
			var img_nodes = (0, _shared.children)(img);

			img_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			img.className = "loading-icon loading-image-small";
			img.src = img_src_value = "" + state.data.basePath + (state.view === 'distance' ? '/assets/images/icons/loading-white.svg' : '/assets/images/icons/loading.svg');
			img.alt = "Loading icon";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(img, target, anchor);
		},

		p: function update(changed, state) {
			if ((changed.data || changed.view) && img_src_value !== (img_src_value = "" + state.data.basePath + (state.view === 'distance' ? '/assets/images/icons/loading-white.svg' : '/assets/images/icons/loading.svg'))) {
				img.src = img_src_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(img);
		},

		d: _shared.noop
	};
}

// (76:4) {{#if utils && utils.hasGeolocate && !geoloationError }}
function create_if_block_9(component, state) {
	var nav, ul, li, a, text, a_class_value, li_1, a_1, text_1, a_1_class_value;

	function click_handler(event) {
		component.eventSet(event, { view: 'alpha' });
	}

	var if_block = state.$isGeolocating && create_if_block_10(component, state);

	function click_handler_1(event) {
		component.eventSet(event, { view: 'distance' });
	}

	return {
		c: function create() {
			nav = (0, _shared.createElement)("nav");
			ul = (0, _shared.createElement)("ul");
			li = (0, _shared.createElement)("li");
			a = (0, _shared.createElement)("a");
			text = (0, _shared.createText)("Alphabetical");
			li_1 = (0, _shared.createElement)("li");
			a_1 = (0, _shared.createElement)("a");
			text_1 = (0, _shared.createText)("Near Me\n              ");
			if (if_block) if_block.c();
			this.h();
		},

		l: function claim(nodes) {
			nav = (0, _shared.claimElement)(nodes, "NAV", { class: true }, false);
			var nav_nodes = (0, _shared.children)(nav);

			ul = (0, _shared.claimElement)(nav_nodes, "UL", { class: true }, false);
			var ul_nodes = (0, _shared.children)(ul);

			li = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_nodes = (0, _shared.children)(li);

			a = (0, _shared.claimElement)(li_nodes, "A", { href: true, class: true }, false);
			var a_nodes = (0, _shared.children)(a);

			text = (0, _shared.claimText)(a_nodes, "Alphabetical");
			a_nodes.forEach(_shared.detachNode);
			li_nodes.forEach(_shared.detachNode);

			li_1 = (0, _shared.claimElement)(ul_nodes, "LI", {}, false);
			var li_1_nodes = (0, _shared.children)(li_1);

			a_1 = (0, _shared.claimElement)(li_1_nodes, "A", { href: true, class: true }, false);
			var a_1_nodes = (0, _shared.children)(a_1);

			text_1 = (0, _shared.claimText)(a_1_nodes, "Near Me\n              ");
			if (if_block) if_block.l(a_1_nodes);
			a_1_nodes.forEach(_shared.detachNode);
			li_1_nodes.forEach(_shared.detachNode);
			ul_nodes.forEach(_shared.detachNode);
			nav_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			(0, _shared.addListener)(a, "click", click_handler);
			a.href = "?view=alpha";
			a.className = a_class_value = "alphabetical " + (state.view === 'alpha' ? 'active' : '');
			(0, _shared.addListener)(a_1, "click", click_handler_1);
			a_1.href = "?view=distance";
			a_1.className = a_1_class_value = "distance " + (state.view === 'distance' ? 'active' : '');
			ul.className = "cf";
			nav.className = "toggle-nav";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(nav, target, anchor);
			(0, _shared.appendNode)(ul, nav);
			(0, _shared.appendNode)(li, ul);
			(0, _shared.appendNode)(a, li);
			(0, _shared.appendNode)(text, a);
			(0, _shared.appendNode)(li_1, ul);
			(0, _shared.appendNode)(a_1, li_1);
			(0, _shared.appendNode)(text_1, a_1);
			if (if_block) if_block.m(a_1, null);
		},

		p: function update(changed, state) {
			if (changed.view && a_class_value !== (a_class_value = "alphabetical " + (state.view === 'alpha' ? 'active' : ''))) {
				a.className = a_class_value;
			}

			if (state.$isGeolocating) {
				if (if_block) {
					if_block.p(changed, state);
				} else {
					if_block = create_if_block_10(component, state);
					if_block.c();
					if_block.m(a_1, null);
				}
			} else if (if_block) {
				if_block.u();
				if_block.d();
				if_block = null;
			}

			if (changed.view && a_1_class_value !== (a_1_class_value = "distance " + (state.view === 'distance' ? 'active' : ''))) {
				a_1.className = a_1_class_value;
			}
		},

		u: function unmount() {
			(0, _shared.detachNode)(nav);
			if (if_block) if_block.u();
		},

		d: function destroy() {
			(0, _shared.removeListener)(a, "click", click_handler);
			if (if_block) if_block.d();
			(0, _shared.removeListener)(a_1, "click", click_handler_1);
		}
	};
}

// (90:30) 
function create_if_block_11(component, state) {
	var div, text;

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			text = (0, _shared.createText)("There was an issue trying to find your location, make sure your location services are turned on, and try again.");
			this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			text = (0, _shared.claimText)(div_nodes, "There was an issue trying to find your location, make sure your location services are turned on, and try again.");
			div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "geolocation-error";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(text, div);
		},

		p: _shared.noop,

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: _shared.noop
	};
}

// (98:8) {{#each data.items as p @id}}
function create_each_block(component, key_1, state) {
	var p = state.p,
	    each_value = state.each_value,
	    p_index = state.p_index;
	var first;

	var item_initial_data = {
		data: p,
		utils: state.utils,
		display: "list",
		view: state.view,
		content: state.content
	};
	var item = new _items2.default({
		root: component.root,
		data: item_initial_data
	});

	return {
		key: key_1,

		first: null,

		c: function create() {
			first = (0, _shared.createComment)();
			item._fragment.c();
			this.h();
		},

		l: function claim(nodes) {
			first = (0, _shared.createComment)();
			item._fragment.l(nodes);
			this.h();
		},

		h: function hydrate() {
			this.first = first;
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(first, target, anchor);
			item._mount(target, anchor);
		},

		p: function update(changed, state) {
			p = state.p;
			each_value = state.each_value;
			p_index = state.p_index;
			var item_changes = {};
			if (changed.data) item_changes.data = p;
			if (changed.utils) item_changes.utils = state.utils;
			if (changed.view) item_changes.view = state.view;
			if (changed.content) item_changes.content = state.content;
			item._set(item_changes);
		},

		u: function unmount() {
			(0, _shared.detachNode)(first);
			item._unmount();
		},

		d: function destroy() {
			item.destroy(false);
		}
	};
}

// (96:4) {{#if data.items}}
function create_if_block_12(component, state) {
	var div,
	    each_blocks_1 = [],
	    each_lookup = (0, _shared.blankObject)();

	var each_value = state.data.items;

	for (var i = 0; i < each_value.length; i += 1) {
		var key = each_value[i].id;
		each_blocks_1[i] = each_lookup[key] = create_each_block(component, key, (0, _shared.assign)((0, _shared.assign)({}, state), {
			each_value: each_value,
			p: each_value[i],
			p_index: i
		}));
	}

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}this.h();
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", { class: true }, false);
			var div_nodes = (0, _shared.children)(div);

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(div_nodes);
			}div_nodes.forEach(_shared.detachNode);
			this.h();
		},

		h: function hydrate() {
			div.className = "item-list";
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);

			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div, null);
			}
		},

		p: function update(changed, state) {
			var each_value = state.data.items;

			each_blocks_1 = (0, _shared.updateKeyedEach)(each_blocks_1, component, changed, "id", 1, each_value, each_lookup, div, false, create_each_block, "m", null, function (i) {
				return (0, _shared.assign)((0, _shared.assign)({}, state), {
					each_value: each_value,
					p: each_value[i],
					p_index: i
				});
			});
		},

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: function destroy() {
			for (i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}
		}
	};
}

// (103:4) {{else}}
function create_if_block_13(component, state) {
	var div, em, text;

	return {
		c: function create() {
			div = (0, _shared.createElement)("div");
			em = (0, _shared.createElement)("em");
			text = (0, _shared.createText)("This list should have items.");
		},

		l: function claim(nodes) {
			div = (0, _shared.claimElement)(nodes, "DIV", {}, false);
			var div_nodes = (0, _shared.children)(div);

			em = (0, _shared.claimElement)(div_nodes, "EM", {}, false);
			var em_nodes = (0, _shared.children)(em);

			text = (0, _shared.claimText)(em_nodes, "This list should have items.");
			em_nodes.forEach(_shared.detachNode);
			div_nodes.forEach(_shared.detachNode);
		},

		m: function mount(target, anchor) {
			(0, _shared.insertNode)(div, target, anchor);
			(0, _shared.appendNode)(em, div);
			(0, _shared.appendNode)(text, em);
		},

		p: _shared.noop,

		u: function unmount() {
			(0, _shared.detachNode)(div);
		},

		d: _shared.noop
	};
}

// (107:4) {{#if data.ad}}
function create_if_block_14(component, state) {

	var ad_initial_data = { ad: state.data.ad };
	var ad = new _ad2.default({
		root: component.root,
		data: ad_initial_data
	});

	return {
		c: function create() {
			ad._fragment.c();
		},

		l: function claim(nodes) {
			ad._fragment.l(nodes);
		},

		m: function mount(target, anchor) {
			ad._mount(target, anchor);
		},

		p: function update(changed, state) {
			var ad_changes = {};
			if (changed.data) ad_changes.ad = state.data.ad;
			ad._set(ad_changes);
		},

		u: function unmount() {
			ad._unmount();
		},

		d: function destroy() {
			ad.destroy(false);
		}
	};
}

function Lists(options) {
	(0, _shared.init)(this, options);
	this._state = (0, _shared.assign)((0, _shared.assign)(this.store._init(["isBrowser", "offline", "isGeolocating"]), data()), options.data);
	this.store._add(this, ["isBrowser", "offline", "isGeolocating"]);
	this._recompute({ data: 1 }, this._state);

	this._handlers.destroy = [ondestroy, _shared.removeFromStore];

	var self = this;
	var _oncreate = function _oncreate() {
		var changed = { data: 1, view: 1, mapLocations: 1, locationsInView: 1, $isBrowser: 1, $offline: 1, hasLocations: 1, $isGeolocating: 1, content: 1, utils: 1, geoloationError: 1 };
		oncreate.call(self);
		self.fire("update", { changed: changed, current: self._state });
	};

	if (!options.root) {
		this._oncreate = [];
		this._beforecreate = [];
		this._aftercreate = [];
	}

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(_oncreate);

	if (options.target) {
		var nodes = (0, _shared.children)(options.target);
		options.hydrate ? this._fragment.l(nodes) : this._fragment.c();
		nodes.forEach(_shared.detachNode);
		this._mount(options.target, options.anchor);

		this._lock = true;
		(0, _shared.callAll)(this._beforecreate);
		(0, _shared.callAll)(this._oncreate);
		(0, _shared.callAll)(this._aftercreate);
		this._lock = false;
	}
}

(0, _shared.assign)(Lists.prototype, _shared.proto);
(0, _shared.assign)(Lists.prototype, methods_1);

Lists.prototype._recompute = function _recompute(changed, state) {
	if (changed.data) {
		if (this._differs(state.hasLocations, state.hasLocations = hasLocations(state.data))) changed.hasLocations = true;
		if (this._differs(state.mapLocations, state.mapLocations = mapLocations(state.data))) changed.mapLocations = true;
	}
};
exports.default = Lists;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js